var Kw = Object.defineProperty;
var zu = (n) => {
  throw TypeError(n);
};
var Qw = (n, e, t) => e in n ? Kw(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var y = (n, e, t) => Qw(n, typeof e != "symbol" ? e + "" : e, t), cl = (n, e, t) => e.has(n) || zu("Cannot " + t);
var s = (n, e, t) => (cl(n, e, "read from private field"), t ? t.call(n) : e.get(n)), c = (n, e, t) => e.has(n) ? zu("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), u = (n, e, t, i) => (cl(n, e, "write to private field"), i ? i.call(n, t) : e.set(n, t), t), a = (n, e, t) => (cl(n, e, "access private method"), t);
import { jsx as N, Fragment as zw, jsxs as Jr } from "react/jsx-runtime";
import * as $ from "react";
import { g as Yw, a as Xw, i as Yu, h as Jw, b as Zw, c as tT, d as eT, e as iT, f as sT } from "./vidstack-google-cast-BaNgBqhV.js";
const li = Symbol(0);
let mh = !1, $l = !1, Qe = null, Qn = null, Ae = null, be = 0, jn = [], $u = {};
const nT = () => {
}, aa = 0, Nd = 1, gh = 2, Qh = 3;
function rT() {
  mh = !0, queueMicrotask(Fd);
}
function Fd() {
  if (!jn.length) {
    mh = !1;
    return;
  }
  $l = !0;
  for (let n = 0; n < jn.length; n++)
    jn[n].$st !== aa && aT(jn[n]);
  jn = [], mh = !1, $l = !1;
}
function aT(n) {
  let e = [n];
  for (; n = n[li]; )
    n.$e && n.$st !== aa && e.push(n);
  for (let t = e.length - 1; t >= 0; t--)
    Au(e[t]);
}
function oT(n) {
  const e = yh();
  return Po(e, n.length ? n.bind(null, ta.bind(e)) : n, null);
}
function v(n) {
  return Po(Qe, n, null);
}
function Zr(n) {
  return Po(null, n, null);
}
function Gi() {
  $l || Fd();
}
function vu() {
  return Qe;
}
function Ke(n, e) {
  try {
    return Po(e, n, null);
  } catch (t) {
    ku(e, t);
    return;
  }
}
function Su(n, e = Qe) {
  return e == null ? void 0 : e.$cx[n];
}
function hT(n, e, t = Qe) {
  t && (t.$cx = { ...t.$cx, [n]: e });
}
function it(n) {
  if (!n || !Qe)
    return n || nT;
  const e = Qe;
  return e.$d ? Array.isArray(e.$d) ? e.$d.push(n) : e.$d = [e.$d, n] : e.$d = n, function() {
    e.$st !== Qh && (n.call(null), zh(e.$d) ? e.$d = null : Array.isArray(e.$d) && e.$d.splice(e.$d.indexOf(n), 1));
  };
}
function ta(n = !0) {
  if (this.$st !== Qh) {
    if (this.$h)
      if (Array.isArray(this.$h))
        for (let e = this.$h.length - 1; e >= 0; e--)
          ta.call(this.$h[e]);
      else
        ta.call(this.$h);
    if (n) {
      const e = this[li];
      e && (Array.isArray(e.$h) ? e.$h.splice(e.$h.indexOf(this), 1) : e.$h = null), lT(this);
    }
  }
}
function lT(n) {
  n.$st = Qh, n.$d && _d(n), n.$s && vl(n, 0), n[li] = null, n.$s = null, n.$o = null, n.$h = null, n.$cx = $u, n.$eh = null;
}
function _d(n) {
  try {
    if (Array.isArray(n.$d))
      for (let e = n.$d.length - 1; e >= 0; e--) {
        const t = n.$d[e];
        t.call(t);
      }
    else
      n.$d.call(n.$d);
    n.$d = null;
  } catch (e) {
    ku(n, e);
  }
}
function Po(n, e, t) {
  const i = Qe, r = Qn;
  Qe = n, Qn = t;
  try {
    return e.call(n);
  } finally {
    Qe = i, Qn = r;
  }
}
function ku(n, e) {
  if (!n || !n.$eh)
    throw e;
  let t = 0, i = n.$eh.length, r = e;
  for (t = 0; t < i; t++)
    try {
      n.$eh[t](r);
      break;
    } catch (o) {
      r = o;
    }
  if (t === i)
    throw r;
}
function Pu() {
  return this.$st === Qh ? this.$v : (Qn && !this.$e && (!Ae && Qn.$s && Qn.$s[be] == this ? be++ : Ae ? Ae.push(this) : Ae = [this]), this.$c && Au(this), this.$v);
}
function Hd(n) {
  const e = zh(n) ? n(this.$v) : n;
  if (this.$ch(this.$v, e) && (this.$v = e, this.$o))
    for (let t = 0; t < this.$o.length; t++)
      jd(this.$o[t], gh);
  return this.$v;
}
const Eu = function() {
  this[li] = null, this.$h = null, Qe && Qe.append(this);
}, Fn = Eu.prototype;
Fn.$cx = $u;
Fn.$eh = null;
Fn.$c = null;
Fn.$d = null;
Fn.append = function(n) {
  n[li] = this, this.$h ? Array.isArray(this.$h) ? this.$h.push(n) : this.$h = [this.$h, n] : this.$h = n, n.$cx = n.$cx === $u ? this.$cx : { ...this.$cx, ...n.$cx }, this.$eh && (n.$eh = n.$eh ? [...n.$eh, ...this.$eh] : this.$eh);
};
Fn.dispose = function() {
  ta.call(this);
};
function yh() {
  return new Eu();
}
const Ud = function(e, t, i) {
  Eu.call(this), this.$st = t ? gh : aa, this.$i = !1, this.$e = !1, this.$s = null, this.$o = null, this.$v = e, t && (this.$c = t), i && i.dirty && (this.$ch = i.dirty);
}, Cu = Ud.prototype;
Object.setPrototypeOf(Cu, Fn);
Cu.$ch = cT;
Cu.call = Pu;
function xu(n, e, t) {
  return new Ud(n, e, t);
}
function cT(n, e) {
  return n !== e;
}
function zh(n) {
  return typeof n == "function";
}
function Au(n) {
  if (n.$st === Nd)
    for (let e = 0; e < n.$s.length && (Au(n.$s[e]), n.$st !== gh); e++)
      ;
  n.$st === gh ? Bd(n) : n.$st = aa;
}
function uT(n) {
  n.$h && ta.call(n, !1), n.$d && _d(n), n.$eh = n[li] ? n[li].$eh : null;
}
function Bd(n) {
  let e = Ae, t = be;
  Ae = null, be = 0;
  try {
    uT(n);
    const i = Po(n, n.$c, n);
    Xu(n), !n.$e && n.$i ? Hd.call(n, i) : (n.$v = i, n.$i = !0);
  } catch (i) {
    Xu(n), ku(n, i);
  } finally {
    Ae = e, be = t, n.$st = aa;
  }
}
function Xu(n) {
  if (Ae) {
    if (n.$s && vl(n, be), n.$s && be > 0) {
      n.$s.length = be + Ae.length;
      for (let t = 0; t < Ae.length; t++)
        n.$s[be + t] = Ae[t];
    } else
      n.$s = Ae;
    let e;
    for (let t = be; t < n.$s.length; t++)
      e = n.$s[t], e.$o ? e.$o.push(n) : e.$o = [n];
  } else n.$s && be < n.$s.length && (vl(n, be), n.$s.length = be);
}
function jd(n, e) {
  if (!(n.$st >= e) && (n.$e && n.$st === aa && (jn.push(n), mh || rT()), n.$st = e, n.$o))
    for (let t = 0; t < n.$o.length; t++)
      jd(n.$o[t], Nd);
}
function vl(n, e) {
  let t, i;
  for (let r = e; r < n.$s.length; r++)
    t = n.$s[r], t.$o && (i = t.$o.indexOf(n), t.$o[i] = t.$o[t.$o.length - 1], t.$o.pop());
}
function bh(...n) {
}
function Ki(n) {
  return n === null;
}
function Et(n) {
  return typeof n > "u";
}
function dT(n) {
  return Ki(n) || Et(n);
}
function fT(n) {
  return (n == null ? void 0 : n.constructor) === Object;
}
function Te(n) {
  return typeof n == "number" && !Number.isNaN(n);
}
function R(n) {
  return typeof n == "string";
}
function Ok(n) {
  return typeof n == "boolean";
}
function $e(n) {
  return typeof n == "function";
}
function zt(n) {
  return Array.isArray(n);
}
const pT = Event, Wd = Symbol("DOM_EVENT");
var xd, Ad;
class H extends (Ad = pT, xd = Wd, Ad) {
  constructor(t, ...i) {
    var o, h;
    super(t, i[0]);
    y(this, xd, !0);
    /**
     * The event detail.
     */
    y(this, "detail");
    /**
     * The event trigger chain.
     */
    y(this, "triggers", new mT());
    this.detail = (o = i[0]) == null ? void 0 : o.detail;
    const r = (h = i[0]) == null ? void 0 : h.trigger;
    r && this.triggers.add(r);
  }
  /**
   * The preceding event that was responsible for this event being fired.
   */
  get trigger() {
    return this.triggers.source;
  }
  /**
   * The origin event that lead to this event being fired.
   */
  get originEvent() {
    return this.triggers.origin;
  }
  /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */
  get isOriginTrusted() {
    var t;
    return ((t = this.triggers.origin) == null ? void 0 : t.isTrusted) ?? !1;
  }
}
class mT {
  constructor() {
    y(this, "chain", []);
  }
  get source() {
    return this.chain[0];
  }
  get origin() {
    return this.chain[this.chain.length - 1];
  }
  /**
   * Appends the event to the end of the chain.
   */
  add(e) {
    this.chain.push(e), gT(e) && this.chain.push(...e.triggers);
  }
  /**
   * Removes the event from the chain and returns it (if found).
   */
  remove(e) {
    return this.chain.splice(this.chain.indexOf(e), 1)[0];
  }
  /**
   * Returns whether the chain contains the given `event`.
   */
  has(e) {
    return this.chain.some((t) => t === e);
  }
  /**
   * Returns whether the chain contains the given event type.
   */
  hasType(e) {
    return !!this.findType(e);
  }
  /**
   * Returns the first event with the given `type` found in the chain.
   */
  findType(e) {
    return this.chain.find((t) => t.type === e);
  }
  /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */
  walk(e) {
    for (const t of this.chain) {
      const i = e(t);
      if (i) return [t, i];
    }
  }
  [Symbol.iterator]() {
    return this.chain.values();
  }
}
function gT(n) {
  return !!(n != null && n[Wd]);
}
class Gd extends EventTarget {
  constructor() {
    super(...arguments);
    /** @internal type only */
    y(this, "$ts__events");
  }
  addEventListener(t, i, r) {
    return super.addEventListener(t, i, r);
  }
  removeEventListener(t, i, r) {
    return super.removeEventListener(t, i, r);
  }
}
function ft(n, e, t, i) {
  return n.addEventListener(e, t, i), it(() => n.removeEventListener(e, t, i));
}
var zn, Yn;
class dt {
  constructor(e) {
    c(this, zn);
    c(this, Yn);
    u(this, zn, e), u(this, Yn, new AbortController()), it(this.abort.bind(this));
  }
  get signal() {
    return s(this, Yn).signal;
  }
  add(e, t, i) {
    if (this.signal.aborted) throw Error("aborted");
    return s(this, zn).addEventListener(e, t, {
      ...i,
      signal: i != null && i.signal ? yT(this.signal, i.signal) : this.signal
    }), this;
  }
  remove(e, t) {
    return s(this, zn).removeEventListener(e, t), this;
  }
  abort(e) {
    s(this, Yn).abort(e);
  }
}
zn = new WeakMap(), Yn = new WeakMap();
function yT(...n) {
  const e = new AbortController(), t = { signal: e.signal };
  function i(r) {
    e.abort(r.target.reason);
  }
  for (const r of n) {
    if (r.aborted) {
      e.abort(r.reason);
      break;
    }
    r.addEventListener("abort", i, t);
  }
  return e.signal;
}
function bT(n) {
  return !!(n != null && n.type.startsWith("touch"));
}
function Yh(n) {
  return !!(n != null && n.type.startsWith("key"));
}
function wT(n) {
  return Yh(n) && n.key === "Enter";
}
function Kd(n) {
  return Yh(n) && (n.key === "Enter" || n.key === " ");
}
function TT(n) {
  return n instanceof Node;
}
function W(n, e, t) {
  if (n) if (!t && t !== "" && t !== 0)
    n.removeAttribute(e);
  else {
    const i = t === !0 ? "" : t + "";
    n.getAttribute(e) !== i && n.setAttribute(e, i);
  }
  else return;
}
function Vs(n, e, t) {
  if (n) !t && t !== 0 ? n.style.removeProperty(e) : n.style.setProperty(e, t + "");
  else return;
}
function Xh(n) {
  return n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $T(n) {
  return vT(n).replace(/\s/g, "");
}
function vT(n) {
  return Qd(n.replace(/-./g, (e) => " " + e[1].toUpperCase()));
}
function Qd(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
function wh(n) {
  return n ? "true" : "false";
}
function Dk(n) {
  return Object.keys(n);
}
function Sl() {
  let n, e;
  return { promise: new Promise((i, r) => {
    n = i, e = r;
  }), resolve: n, reject: e };
}
function ST(n) {
  return new Promise((e) => setTimeout(e, n));
}
function oa(n) {
  let e = -1, t;
  function i(...r) {
    t = r, !(e >= 0) && (e = window.requestAnimationFrame(() => {
      n.apply(this, t), e = -1, t = void 0;
    }));
  }
  return i;
}
const kT = typeof window < "u" ? "requestIdleCallback" in window ? window.requestIdleCallback : (n) => window.setTimeout(n, 1) : bh;
function PT(n, e) {
  return new Promise((t) => {
    kT((i) => {
      n == null || n(i), t();
    }, e);
  });
}
function kl(n) {
  return !R(n) && "width" in n && "height" in n && Te(n.width) && Te(n.height);
}
var fe = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, Ju = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], Zu = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], td = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], he = typeof window < "u" && typeof window.document < "u" ? window.document : {}, Pe = "fullscreenEnabled" in he && Object.keys(fe) || Ju[0] in he && Ju || Zu[0] in he && Zu || td[0] in he && td || [], qn = {
  requestFullscreen: function(n) {
    return n[Pe[fe.requestFullscreen]]();
  },
  requestFullscreenFunction: function(n) {
    return n[Pe[fe.requestFullscreen]];
  },
  get exitFullscreen() {
    return he[Pe[fe.exitFullscreen]].bind(he);
  },
  get fullscreenPseudoClass() {
    return ":" + Pe[fe.fullscreen];
  },
  addEventListener: function(n, e, t) {
    return he.addEventListener(Pe[fe[n]], e, t);
  },
  removeEventListener: function(n, e, t) {
    return he.removeEventListener(Pe[fe[n]], e, t);
  },
  get fullscreenEnabled() {
    return !!he[Pe[fe.fullscreenEnabled]];
  },
  set fullscreenEnabled(n) {
  },
  get fullscreenElement() {
    return he[Pe[fe.fullscreenElement]];
  },
  set fullscreenElement(n) {
  },
  get onfullscreenchange() {
    return he[("on" + Pe[fe.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(n) {
    return he[("on" + Pe[fe.fullscreenchange]).toLowerCase()] = n;
  },
  get onfullscreenerror() {
    return he[("on" + Pe[fe.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(n) {
    return he[("on" + Pe[fe.fullscreenerror]).toLowerCase()] = n;
  }
};
function V(n, e) {
  const t = xu(n, null, e), i = Pu.bind(t);
  return i[li] = !0, i.set = Hd.bind(t), i;
}
function ET(n) {
  return zh(n) && li in n;
}
function Eo(n, e) {
  const t = xu(
    e == null ? void 0 : e.initial,
    n,
    e
  ), i = Pu.bind(t);
  return i[li] = !0, i;
}
function zd(n, e) {
  const t = xu(
    null,
    function() {
      let r = n();
      return zh(r) && it(r), null;
    },
    void 0
  );
  return t.$e = !0, Bd(t), ta.bind(t, !0);
}
function CT(n) {
  return ET(n) && "set" in n;
}
const b = zd;
function ha(n) {
  return { id: Symbol(), provide: n };
}
function Qi(n, e, t = vu()) {
  var r;
  const i = !Et(e);
  hT(n.id, i ? e : (r = n.provide) == null ? void 0 : r.call(n), t);
}
function Me(n) {
  return Su(n.id);
}
function On(n) {
  return !Et(Su(n.id));
}
const ul = /* @__PURE__ */ Symbol(0), dl = /* @__PURE__ */ Symbol(0), Jh = /* @__PURE__ */ Symbol(0), fl = {};
var Md, Xn, Jn, Ys, Zn, ci, Yd, Xd, Jd, Zd;
Md = Jh;
class xT {
  constructor(e, t, i) {
    c(this, ci);
    /** @internal type only */
    y(this, "$ts__events");
    /** @internal type only */
    y(this, "$ts__vars");
    /* @internal */
    y(this, Md, null);
    y(this, "$el", V(null));
    y(this, "el", null);
    y(this, "scope", null);
    y(this, "attachScope", null);
    y(this, "connectScope", null);
    y(this, "component", null);
    y(this, "destroyed", !1);
    y(this, "props", fl);
    y(this, "attrs", null);
    y(this, "styles", null);
    y(this, "state");
    y(this, "$state");
    c(this, Xn, []);
    c(this, Jn, []);
    c(this, Ys, []);
    c(this, Zn, []);
    var h;
    this.scope = t, i != null && i.scope && i.scope.append(t);
    let r = e.state, o = e.props;
    if (r && (this.$state = r.create(), this.state = new Proxy(this.$state, {
      get: (l, d) => this.$state[d]()
    }), Qi(r, this.$state)), o && (this.props = AT(o), i != null && i.props))
      for (const l of Object.keys(i.props))
        (h = this.props[l]) == null || h.set(i.props[l]);
    it(this.destroy.bind(this));
  }
  setup() {
    Ke(() => {
      for (const e of s(this, Xn)) e();
    }, this.scope);
  }
  attach(e) {
    this.el || (this.el = e, this.$el.set(e), Ke(() => {
      this.attachScope = yh(), Ke(() => {
        for (const t of s(this, Jn)) t(this.el);
        a(this, ci, Yd).call(this), a(this, ci, Xd).call(this);
      }, this.attachScope);
    }, this.scope), e.dispatchEvent(new Event("attached")));
  }
  detach() {
    var e;
    (e = this.attachScope) == null || e.dispose(), this.attachScope = null, this.connectScope = null, this.el = null, this.$el.set(null);
  }
  connect() {
    !this.el || !this.attachScope || !s(this, Ys).length || Ke(() => {
      this.connectScope = yh(), Ke(() => {
        for (const e of s(this, Ys)) e(this.el);
      }, this.connectScope);
    }, this.attachScope);
  }
  disconnect() {
    var e;
    (e = this.connectScope) == null || e.dispose(), this.connectScope = null;
  }
  destroy() {
    if (this.destroyed) return;
    this.destroyed = !0, Ke(() => {
      for (const t of s(this, Zn)) t(this.el);
    }, this.scope);
    const e = this.el;
    this.detach(), this.scope.dispose(), s(this, Xn).length = 0, s(this, Jn).length = 0, s(this, Ys).length = 0, s(this, Zn).length = 0, this.component = null, this.attrs = null, this.styles = null, this.props = fl, this.scope = null, this.state = fl, this.$state = null, e && delete e.$;
  }
  addHooks(e) {
    e.onSetup && s(this, Xn).push(e.onSetup.bind(e)), e.onAttach && s(this, Jn).push(e.onAttach.bind(e)), e.onConnect && s(this, Ys).push(e.onConnect.bind(e)), e.onDestroy && s(this, Zn).push(e.onDestroy.bind(e));
  }
}
Xn = new WeakMap(), Jn = new WeakMap(), Ys = new WeakMap(), Zn = new WeakMap(), ci = new WeakSet(), Yd = function() {
  if (this.attrs)
    for (const e of Object.keys(this.attrs))
      $e(this.attrs[e]) ? b(a(this, ci, Jd).bind(this, e)) : W(this.el, e, this.attrs[e]);
}, Xd = function() {
  if (this.styles)
    for (const e of Object.keys(this.styles))
      $e(this.styles[e]) ? b(a(this, ci, Zd).bind(this, e)) : Vs(this.el, e, this.styles[e]);
}, Jd = function(e) {
  W(this.el, e, this.attrs[e].call(this.component));
}, Zd = function(e) {
  Vs(this.el, e, this.styles[e].call(this.component));
};
function AT(n) {
  const e = {};
  for (const t of Object.keys(n)) {
    const i = n[t];
    e[t] = V(i, i);
  }
  return e;
}
let va = { $$: null };
function MT(n, e) {
  return oT(() => {
    va.$$ = new xT(n, vu(), e);
    const t = new n();
    return va.$$.component = t, va.$$ = null, t;
  });
}
class qe extends EventTarget {
  constructor() {
    super();
    /** @internal */
    y(this, "$$");
    va.$$ && this.attach(va);
  }
  get el() {
    return this.$$.el;
  }
  get $el() {
    return this.$$.$el();
  }
  get scope() {
    return this.$$.scope;
  }
  get attachScope() {
    return this.$$.attachScope;
  }
  get connectScope() {
    return this.$$.connectScope;
  }
  /** @internal */
  get $props() {
    return this.$$.props;
  }
  /** @internal */
  get $state() {
    return this.$$.$state;
  }
  get state() {
    return this.$$.state;
  }
  attach({ $$: t }) {
    return this.$$ = t, t.addHooks(this), this;
  }
  addEventListener(t, i, r) {
    this.listen(t, i, r);
  }
  removeEventListener(t, i, r) {
    var o;
    (o = this.el) == null || o.removeEventListener(t, i, r);
  }
  /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */
  /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */
  setAttributes(t) {
    this.$$.attrs || (this.$$.attrs = {}), Object.assign(this.$$.attrs, t);
  }
  /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */
  setStyles(t) {
    this.$$.styles || (this.$$.styles = {}), Object.assign(this.$$.styles, t);
  }
  /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */
  setCSSVars(t) {
    this.setStyles(t);
  }
  /**
   * Type-safe utility for creating component DOM events.
   */
  createEvent(t, ...i) {
    return new H(t, i[0]);
  }
  /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */
  dispatch(t, ...i) {
    if (!this.el) return !1;
    const r = t instanceof Event ? t : new H(t, i[0]);
    return Object.defineProperty(r, "target", {
      get: () => this.$$.component
    }), Zr(() => {
      var o, h;
      return (h = (o = this.$$)[Jh]) == null || h.call(o, r), this.el.dispatchEvent(r);
    });
  }
  dispatchEvent(t) {
    return this.dispatch(t);
  }
  /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */
  listen(t, i, r) {
    return this.el ? ft(this.el, t, i, r) : bh;
  }
}
class Lt extends qe {
  subscribe(e) {
    return Ke(() => b(() => e(this.state)), this.$$.scope);
  }
  destroy() {
    this.$$.destroy();
  }
}
function nt(n, e, t) {
  n[ul] || (n[ul] = /* @__PURE__ */ new Set()), n[ul].add(e);
}
function _t(n, e, t) {
  n[dl] || (n[dl] = /* @__PURE__ */ new Set()), n[dl].add(e);
}
var tr;
class la {
  constructor(e) {
    y(this, "id", Symbol(0));
    y(this, "record");
    c(this, tr);
    this.record = e, u(this, tr, Object.getOwnPropertyDescriptors(e));
  }
  create() {
    const e = {}, t = new Proxy(e, { get: (i, r) => e[r]() });
    for (const i of Object.keys(this.record)) {
      const r = s(this, tr)[i].get;
      e[i] = r ? Eo(r.bind(t)) : V(this.record[i]);
    }
    return e;
  }
  reset(e, t) {
    for (const i of Object.keys(e))
      !s(this, tr)[i].get && (!t || t(i)) && e[i].set(this.record[i]);
  }
}
tr = new WeakMap();
function Co(n) {
  return Me(n);
}
const LT = (navigator == null ? void 0 : navigator.userAgent.toLowerCase()) || "", Zh = /iphone|ipad|ipod|ios|crios|fxios/i.test(LT), tf = /(iphone|ipod)/gi.test((navigator == null ? void 0 : navigator.platform) || ""), tl = !!window.chrome, Th = !!window.safari || Zh;
function ef() {
  return IT() && $e(screen.orientation.unlock);
}
function IT() {
  return !Et(window.screen.orientation) && !Et(window.screen.orientation.lock);
}
function sf(n, e) {
  return n || (n = document.createElement("audio")), n.canPlayType(e).length > 0;
}
function nf(n, e) {
  return n || (n = document.createElement("video")), n.canPlayType(e).length > 0;
}
function RT(n) {
  return n || (n = document.createElement("video")), n.canPlayType("application/vnd.apple.mpegurl").length > 0;
}
function qT(n) {
  return !!document.pictureInPictureEnabled && !(n != null && n.disablePictureInPicture);
}
function OT(n) {
  return $e(n == null ? void 0 : n.webkitSupportsPresentationMode) && $e(n == null ? void 0 : n.webkitSetPresentationMode);
}
async function DT() {
  const n = document.createElement("video");
  return n.volume = 0.5, await ST(0), n.volume === 0.5;
}
function VT() {
  return (window == null ? void 0 : window.ManagedMediaSource) ?? (window == null ? void 0 : window.MediaSource) ?? (window == null ? void 0 : window.WebKitMediaSource);
}
function NT() {
  return (window == null ? void 0 : window.SourceBuffer) ?? (window == null ? void 0 : window.WebKitSourceBuffer);
}
function Mu() {
  const n = VT();
  if (Et(n)) return !1;
  const e = n && $e(n.isTypeSupported) && n.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), t = NT(), i = Et(t) || !Et(t.prototype) && $e(t.prototype.appendBuffer) && $e(t.prototype.remove);
  return !!e && !!i;
}
function FT() {
  return Mu();
}
var vi;
class Go {
  constructor(e, t) {
    c(this, vi);
    zt(e) ? u(this, vi, e) : !Et(e) && !Et(t) ? u(this, vi, [[e, t]]) : u(this, vi, []);
  }
  get length() {
    return s(this, vi).length;
  }
  start(e) {
    return s(this, vi)[e][0] ?? 1 / 0;
  }
  end(e) {
    return s(this, vi)[e][1] ?? 1 / 0;
  }
}
vi = new WeakMap();
function ed(n) {
  if (!n.length) return null;
  let e = n.start(0);
  for (let t = 1; t < n.length; t++) {
    const i = n.start(t);
    i < e && (e = i);
  }
  return e;
}
function zs(n) {
  if (!n.length) return null;
  let e = n.end(0);
  for (let t = 1; t < n.length; t++) {
    const i = n.end(t);
    i > e && (e = i);
  }
  return e;
}
function _T(n) {
  if (n.length <= 1)
    return n;
  n.sort((i, r) => i[0] - r[0]);
  let e = [], t = n[0];
  for (let i = 1; i < n.length; i++) {
    const r = n[i];
    t[1] >= r[0] - 1 ? t = [t[0], Math.max(t[1], r[1])] : (e.push(t), t = r);
  }
  return e.push(t), e;
}
function HT(n, e, t) {
  let i = e[0], r = e[1];
  return t < i ? [t, -1] : t === i ? e : i === -1 ? (e[0] = t, e) : (t > i && (e[1] = t, r === -1 && n.push(e)), _T(n), e);
}
const UT = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i, BT = /* @__PURE__ */ new Set([
  "audio/aac",
  "audio/mpeg",
  "audio/ogg",
  "audio/3gp",
  "audio/mp3",
  "audio/webm",
  "audio/flac",
  "audio/m4a",
  "audio/m4b",
  "audio/mp4a",
  "audio/mp4"
]), jT = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, WT = /* @__PURE__ */ new Set([
  "video/mp4",
  "video/webm",
  "video/3gp",
  "video/ogg",
  "video/avi",
  "video/mpeg"
]), GT = /\.(m3u8)($|\?)/i, KT = /\.(mpd)($|\?)/i, QT = /* @__PURE__ */ new Set([
  // Apple sanctioned
  "application/vnd.apple.mpegurl",
  // Apple sanctioned for backwards compatibility
  "audio/mpegurl",
  // Very common
  "audio/x-mpegurl",
  // Very common
  "application/x-mpegurl",
  // Included for completeness
  "video/x-mpegurl",
  "video/mpegurl",
  "application/mpegurl"
]), zT = /* @__PURE__ */ new Set(["application/dash+xml"]);
function rf({ src: n, type: e }) {
  return R(n) ? UT.test(n) || BT.has(e) || n.startsWith("blob:") && e === "audio/object" : e === "audio/object";
}
function af(n) {
  return R(n.src) ? jT.test(n.src) || WT.has(n.type) || n.src.startsWith("blob:") && n.type === "video/object" || ca(n) && RT() : n.type === "video/object";
}
function ca({ src: n, type: e }) {
  return R(n) && GT.test(n) || QT.has(e);
}
function Lu({ src: n, type: e }) {
  return R(n) && KT.test(n) || zT.has(e);
}
function of(n) {
  return R(n.src) && (rf(n) || af(n) || ca(n));
}
function Vk(n) {
  return typeof window.MediaStream < "u" && n instanceof window.MediaStream;
}
function YT(n, e) {
  const t = new URL(n);
  for (const i of Object.keys(e)) {
    const r = e[i];
    Et(r) || t.searchParams.set(i, e[i] + "");
  }
  return t.toString();
}
function el(n, e = "preconnect") {
  const t = document.querySelector(`link[href="${n}"]`);
  if (!Ki(t)) return !0;
  const i = document.createElement("link");
  return i.rel = e, i.href = n, i.crossOrigin = "true", document.head.append(i), !0;
}
const pa = {};
function Iu(n) {
  if (pa[n]) return pa[n].promise;
  const e = Sl(), t = document.querySelector(`script[src="${n}"]`);
  if (!Ki(t))
    return e.resolve(), e.promise;
  pa[n] = e;
  const i = document.createElement("script");
  return i.src = n, i.onload = () => {
    e.resolve(), delete pa[n];
  }, i.onerror = () => {
    e.reject(), delete pa[n];
  }, setTimeout(() => document.head.append(i), 0), e.promise;
}
function Sa(n) {
  return n === "use-credentials" ? "include" : R(n) ? "same-origin" : void 0;
}
const XT = Symbol(0), JT = Symbol(0), ZT = Symbol(0), t$ = Symbol(0), e$ = Symbol(0), i$ = Symbol(0), s$ = Symbol(0), q = {
  crossOrigin: XT,
  readyState: JT,
  updateActiveCues: ZT,
  canLoad: t$,
  onModeChange: e$,
  native: i$,
  nativeHLS: s$
};
function id(n, e) {
  return e >= n.startTime && e < n.endTime;
}
function hf(n, e, t) {
  let i = null, r = vu();
  function o() {
    const h = R(e) ? [e] : e, l = n.toArray().find((d) => h.includes(d.kind) && d.mode === "showing");
    if (l !== i) {
      if (!l) {
        t(null), i = null;
        return;
      }
      l.readyState == 2 ? t(l) : (t(null), Ke(() => {
        const d = ft(
          l,
          "load",
          () => {
            t(l), d();
          },
          { once: !0 }
        );
      }, r)), i = l;
    }
  }
  return o(), ft(n, "mode-change", o);
}
var Ld, Id, Rd, qd, Ca, Si, Xs, xa, Js, Bt, ki, Pt, lf, Pl, ga, El, Cl, xl;
class Ns extends Gd {
  constructor(t) {
    super();
    c(this, Pt);
    y(this, "src");
    y(this, "content");
    y(this, "type");
    y(this, "encoding");
    y(this, "id", "");
    y(this, "label", "");
    y(this, "language", "");
    y(this, "kind");
    y(this, "default", !1);
    y(this, "sourceType");
    c(this, Ca, !1);
    c(this, Si, 0);
    c(this, Xs, "disabled");
    c(this, xa, {});
    c(this, Js, []);
    c(this, Bt, []);
    c(this, ki, []);
    /** @internal */
    y(this, qd, 0);
    /** @internal */
    y(this, Rd);
    /** @internal */
    y(this, Id, null);
    /** @internal */
    y(this, Ld, null);
    for (const i of Object.keys(t)) this[i] = t[i];
    this.type || (this.type = "vtt"), t.content ? a(this, Pt, lf).call(this, t) : t.src || (this[q.readyState] = 2);
  }
  static createId(t) {
    return `vds-${t.type}-${t.kind}-${t.src ?? t.label ?? "?"}`;
  }
  get metadata() {
    return s(this, xa);
  }
  get regions() {
    return s(this, Js);
  }
  get cues() {
    return s(this, Bt);
  }
  get activeCues() {
    return s(this, ki);
  }
  /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */
  get readyState() {
    return this[q.readyState];
  }
  get mode() {
    return s(this, Xs);
  }
  set mode(t) {
    this.setMode(t);
  }
  addCue(t, i) {
    var h;
    let r = 0, o = s(this, Bt).length;
    for (r = 0; r < o && !(t.endTime <= s(this, Bt)[r].startTime); r++) ;
    r === o ? s(this, Bt).push(t) : s(this, Bt).splice(r, 0, t), t instanceof TextTrackCue || (h = this[q.native]) == null || h.track.addCue(t), this.dispatchEvent(new H("add-cue", { detail: t, trigger: i })), id(t, s(this, Si)) && this[q.updateActiveCues](s(this, Si), i);
  }
  removeCue(t, i) {
    var o;
    const r = s(this, Bt).indexOf(t);
    if (r >= 0) {
      const h = s(this, ki).includes(t);
      s(this, Bt).splice(r, 1), (o = this[q.native]) == null || o.track.removeCue(t), this.dispatchEvent(new H("remove-cue", { detail: t, trigger: i })), h && this[q.updateActiveCues](s(this, Si), i);
    }
  }
  setMode(t, i) {
    var r;
    s(this, Xs) !== t && (u(this, Xs, t), t === "disabled" ? (u(this, ki, []), a(this, Pt, xl).call(this)) : this.readyState === 2 ? this[q.updateActiveCues](s(this, Si), i) : a(this, Pt, Pl).call(this), this.dispatchEvent(new H("mode-change", { detail: this, trigger: i })), (r = this[q.onModeChange]) == null || r.call(this));
  }
  /** @internal */
  [(qd = q.readyState, Rd = q.crossOrigin, Id = q.onModeChange, Ld = q.native, q.updateActiveCues)](t, i) {
    if (u(this, Si, t), this.mode === "disabled" || !s(this, Bt).length) return;
    const r = [];
    for (let h = 0, l = s(this, Bt).length; h < l; h++) {
      const d = s(this, Bt)[h];
      id(d, t) && r.push(d);
    }
    let o = r.length !== s(this, ki).length;
    if (!o) {
      for (let h = 0; h < r.length; h++)
        if (!s(this, ki).includes(r[h])) {
          o = !0;
          break;
        }
    }
    u(this, ki, r), o && a(this, Pt, xl).call(this, i);
  }
  /** @internal */
  [q.canLoad]() {
    u(this, Ca, !0), s(this, Xs) !== "disabled" && a(this, Pt, Pl).call(this);
  }
}
Ca = new WeakMap(), Si = new WeakMap(), Xs = new WeakMap(), xa = new WeakMap(), Js = new WeakMap(), Bt = new WeakMap(), ki = new WeakMap(), Pt = new WeakSet(), lf = function(t) {
  import("./dev-D3SS6qhA.js").then((i) => i.d).then(({ parseText: i, VTTCue: r, VTTRegion: o }) => {
    !R(t.content) || t.type === "json" ? (a(this, Pt, Cl).call(this, t.content, r, o), this.readyState !== 3 && a(this, Pt, ga).call(this)) : i(t.content, { type: t.type }).then(({ cues: h, regions: l }) => {
      u(this, Bt, h), u(this, Js, l), a(this, Pt, ga).call(this);
    });
  });
}, Pl = async function() {
  var t, i;
  if (!(!s(this, Ca) || this[q.readyState] > 0)) {
    if (this[q.readyState] = 1, this.dispatchEvent(new H("load-start")), !this.src) {
      a(this, Pt, ga).call(this);
      return;
    }
    try {
      const { parseResponse: r, VTTCue: o, VTTRegion: h } = await import("./dev-D3SS6qhA.js").then((f) => f.d), l = (t = this[q.crossOrigin]) == null ? void 0 : t.call(this), d = fetch(this.src, {
        headers: this.type === "json" ? { "Content-Type": "application/json" } : void 0,
        credentials: Sa(l)
      });
      if (this.type === "json")
        a(this, Pt, Cl).call(this, await (await d).text(), o, h);
      else {
        const { errors: f, metadata: p, regions: m, cues: w } = await r(d, {
          type: this.type,
          encoding: this.encoding
        });
        if (((i = f[0]) == null ? void 0 : i.code) === 0)
          throw f[0];
        u(this, xa, p), u(this, Js, m), u(this, Bt, w);
      }
      a(this, Pt, ga).call(this);
    } catch (r) {
      a(this, Pt, El).call(this, r);
    }
  }
}, ga = function() {
  if (this[q.readyState] = 2, !this.src || this.type !== "vtt") {
    const i = this[q.native];
    if (i && !i.managed)
      for (const r of s(this, Bt)) i.track.addCue(r);
  }
  const t = new H("load");
  this[q.updateActiveCues](s(this, Si), t), this.dispatchEvent(t);
}, El = function(t) {
  this[q.readyState] = 3, this.dispatchEvent(new H("error", { detail: t }));
}, Cl = function(t, i, r) {
  try {
    const { regions: o, cues: h } = r$(t, i, r);
    u(this, Js, o), u(this, Bt, h);
  } catch (o) {
    a(this, Pt, El).call(this, o);
  }
}, xl = function(t) {
  this.dispatchEvent(new H("cue-change", { trigger: t }));
};
const n$ = /captions|subtitles/;
function le(n) {
  return n$.test(n.kind);
}
function r$(n, e, t) {
  const i = R(n) ? JSON.parse(n) : n;
  let r = [], o = [];
  return i.regions && t && (r = i.regions.map((h) => Object.assign(new t(), h))), (i.cues || zt(i)) && (o = (zt(i) ? i : i.cues).filter((h) => Te(h.startTime) && Te(h.endTime)).map((h) => Object.assign(new e(0, 0, ""), h))), { regions: r, cues: o };
}
const ua = new la({
  artist: "",
  artwork: null,
  audioTrack: null,
  audioTracks: [],
  autoPlay: !1,
  autoPlayError: null,
  audioGain: null,
  buffered: new Go(),
  canLoad: !1,
  canLoadPoster: !1,
  canFullscreen: !1,
  canOrientScreen: ef(),
  canPictureInPicture: !1,
  canPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  get iOSControls() {
    return tf && this.mediaType === "video" && (!this.playsInline || !qn.fullscreenEnabled && this.fullscreen);
  },
  get nativeControls() {
    return this.controls || this.iOSControls;
  },
  controlsVisible: !1,
  get controlsHidden() {
    return !this.controlsVisible;
  },
  crossOrigin: null,
  ended: !1,
  error: null,
  fullscreen: !1,
  get loop() {
    return this.providedLoop || this.userPrefersLoop;
  },
  logLevel: "silent",
  mediaType: "unknown",
  muted: !1,
  paused: !0,
  played: new Go(),
  playing: !1,
  playsInline: !1,
  pictureInPicture: !1,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: !1,
  canSetQuality: !0,
  canSetPlaybackRate: !0,
  canSetVolume: !1,
  canSetAudioGain: !1,
  seekable: new Go(),
  seeking: !1,
  source: { src: "", type: "" },
  sources: [],
  started: !1,
  textTracks: [],
  textTrack: null,
  get hasCaptions() {
    return this.textTracks.filter(le).length > 0;
  },
  volume: 1,
  waiting: !1,
  realCurrentTime: 0,
  get currentTime() {
    return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
  },
  providedDuration: -1,
  intrinsicDuration: 0,
  get duration() {
    return this.seekableWindow;
  },
  get title() {
    return this.providedTitle || this.inferredTitle;
  },
  get poster() {
    return this.providedPoster || this.inferredPoster;
  },
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    const n = ed(this.buffered) ?? 0;
    return Math.max(n, this.clipStartTime);
  },
  get bufferedEnd() {
    const n = zs(this.buffered) ?? 0;
    return Math.min(this.seekableEnd, Math.max(0, n - this.clipStartTime));
  },
  get bufferedWindow() {
    return Math.max(0, this.bufferedEnd - this.bufferedStart);
  },
  get seekableStart() {
    if (this.isLiveDVR && this.liveDVRWindow > 0)
      return Math.max(0, this.seekableEnd - this.liveDVRWindow);
    const n = ed(this.seekable) ?? 0;
    return Math.max(n, this.clipStartTime);
  },
  get seekableEnd() {
    if (this.providedDuration > 0) return this.providedDuration;
    const n = this.liveSyncPosition > 0 ? this.liveSyncPosition : this.canPlay ? zs(this.seekable) ?? 1 / 0 : 0;
    return this.clipEndTime > 0 ? Math.min(this.clipEndTime, n) : n;
  },
  get seekableWindow() {
    const n = this.seekableEnd - this.seekableStart;
    return isNaN(n) ? 1 / 0 : Math.max(0, n);
  },
  // ~~ remote playback ~~
  canAirPlay: !1,
  canGoogleCast: !1,
  remotePlaybackState: "disconnected",
  remotePlaybackType: "none",
  remotePlaybackLoader: null,
  remotePlaybackInfo: null,
  get isAirPlayConnected() {
    return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
  },
  get isGoogleCastConnected() {
    return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
  },
  // ~~ responsive design ~~
  pointer: "fine",
  orientation: "landscape",
  width: 0,
  height: 0,
  mediaWidth: 0,
  mediaHeight: 0,
  lastKeyboardAction: null,
  // ~~ user props ~~
  userBehindLiveEdge: !1,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.duration) && (!this.isLiveDVR || this.duration >= this.liveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, this.seekableEnd - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  get isLiveDVR() {
    return /:dvr/.test(this.streamType);
  },
  get liveDVRWindow() {
    return Math.max(this.inferredLiveDVRWindow, this.minLiveDVRWindow);
  },
  // ~~ internal props ~~
  autoPlaying: !1,
  providedTitle: "",
  inferredTitle: "",
  providedLoop: !1,
  userPrefersLoop: !1,
  providedPoster: "",
  inferredPoster: "",
  inferredViewType: "unknown",
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null,
  inferredLiveDVRWindow: 0,
  savedState: null
}), cf = /* @__PURE__ */ new Set([
  "autoPlayError",
  "autoPlaying",
  "buffered",
  "canPlay",
  "error",
  "paused",
  "played",
  "playing",
  "seekable",
  "seeking",
  "waiting"
]), a$ = /* @__PURE__ */ new Set([
  ...cf,
  "ended",
  "inferredPoster",
  "inferredStreamType",
  "inferredTitle",
  "intrinsicDuration",
  "inferredLiveDVRWindow",
  "liveSyncPosition",
  "realCurrentTime",
  "savedState",
  "started",
  "userBehindLiveEdge"
]);
function sd(n, e = !1) {
  const t = e ? cf : a$;
  ua.reset(n, (i) => t.has(i)), Gi();
}
function uf(n, e) {
  const t = n + e.clipStartTime(), i = Math.floor(n) === Math.floor(e.seekableStart()), r = Math.floor(t) === Math.floor(e.seekableEnd());
  return i ? e.seekableStart() : r ? e.seekableEnd() : e.isLiveDVR() && e.liveDVRWindow() > 0 && t < e.seekableEnd() - e.liveDVRWindow() ? e.bufferedStart() : Math.min(Math.max(e.seekableStart() + 0.1, t), e.seekableEnd() - 0.1);
}
const Ru = ha();
function ue() {
  return Me(Ru);
}
var Zs, me, er, xh, Z, st, o$;
class df {
  constructor(e = void 0) {
    c(this, Z);
    c(this, Zs, null);
    c(this, me, null);
    c(this, er, -1);
    c(this, xh);
    u(this, xh, e);
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(e) {
    u(this, Zs, e);
  }
  /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(e) {
    var t;
    return s(this, me) ? s(this, me) : ((t = e ?? s(this, Zs)) == null || t.dispatchEvent(
      new H("find-media-player", {
        detail: (i) => void u(this, me, i),
        bubbles: !0,
        composed: !0
      })
    ), s(this, me));
  }
  /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(e) {
    u(this, me, e);
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(e) {
    a(this, Z, st).call(this, "media-start-loading", e);
  }
  /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(e) {
    a(this, Z, st).call(this, "media-poster-start-loading", e);
  }
  /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */
  requestAirPlay(e) {
    a(this, Z, st).call(this, "media-airplay-request", e);
  }
  /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */
  requestGoogleCast(e) {
    a(this, Z, st).call(this, "media-google-cast-request", e);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(e) {
    a(this, Z, st).call(this, "media-play-request", e);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(e) {
    a(this, Z, st).call(this, "media-pause-request", e);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(e) {
    a(this, Z, st).call(this, "media-mute-request", e);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(e) {
    a(this, Z, st).call(this, "media-unmute-request", e);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  enterFullscreen(e, t) {
    a(this, Z, st).call(this, "media-enter-fullscreen-request", t, e);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  exitFullscreen(e, t) {
    a(this, Z, st).call(this, "media-exit-fullscreen-request", t, e);
  }
  /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */
  lockScreenOrientation(e, t) {
    a(this, Z, st).call(this, "media-orientation-lock-request", t, e);
  }
  /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */
  unlockScreenOrientation(e) {
    a(this, Z, st).call(this, "media-orientation-unlock-request", e);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  enterPictureInPicture(e) {
    a(this, Z, st).call(this, "media-enter-pip-request", e);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  exitPictureInPicture(e) {
    a(this, Z, st).call(this, "media-exit-pip-request", e);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(e, t) {
    a(this, Z, st).call(this, "media-seeking-request", t, e);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(e, t) {
    a(this, Z, st).call(this, "media-seek-request", t, e);
  }
  seekToLiveEdge(e) {
    a(this, Z, st).call(this, "media-live-edge-request", e);
  }
  /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */
  changeDuration(e, t) {
    a(this, Z, st).call(this, "media-duration-change-request", t, e);
  }
  /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */
  changeClipStart(e, t) {
    a(this, Z, st).call(this, "media-clip-start-change-request", t, e);
  }
  /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */
  changeClipEnd(e, t) {
    a(this, Z, st).call(this, "media-clip-end-change-request", t, e);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(e, t) {
    a(this, Z, st).call(this, "media-volume-change-request", t, Math.max(0, Math.min(1, e)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(e, t) {
    a(this, Z, st).call(this, "media-audio-track-change-request", t, e);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(e, t) {
    a(this, Z, st).call(this, "media-quality-change-request", t, e);
  }
  /**
   * Request auto quality selection.
   */
  requestAutoQuality(e) {
    this.changeQuality(-1, e);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(e, t, i) {
    a(this, Z, st).call(this, "media-text-track-change-request", i, {
      index: e,
      mode: t
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(e, t) {
    a(this, Z, st).call(this, "media-rate-change-request", t, e);
  }
  /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */
  changeAudioGain(e, t) {
    a(this, Z, st).call(this, "media-audio-gain-change-request", t, e);
  }
  /**
   * Dispatch a request to resume idle tracking on controls.
   */
  resumeControls(e) {
    a(this, Z, st).call(this, "media-resume-controls-request", e);
  }
  /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */
  pauseControls(e) {
    a(this, Z, st).call(this, "media-pause-controls-request", e);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    t && (t.state.paused ? this.play(e) : this.pause(e));
  }
  /**
   * Dispatch a request to toggle the controls visibility.
   */
  toggleControls(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    t && (t.controls.showing ? t.controls.hide(0, e) : t.controls.show(0, e));
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    t && (t.state.muted ? this.unmute(e) : this.mute(e));
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  toggleFullscreen(e, t) {
    const i = this.getPlayer(t == null ? void 0 : t.target);
    i && (i.state.fullscreen ? this.exitFullscreen(e, t) : this.enterFullscreen(e, t));
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  togglePictureInPicture(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    t && (t.state.pictureInPicture ? this.exitPictureInPicture(e) : this.enterPictureInPicture(e));
  }
  /**
   * Show captions.
   */
  showCaptions(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    if (!t)
      return;
    let i = t.state.textTracks, r = s(this, er);
    (!i[r] || !le(i[r])) && (r = -1), r === -1 && (r = i.findIndex((o) => le(o) && o.default)), r === -1 && (r = i.findIndex((o) => le(o))), r >= 0 && this.changeTextTrackMode(r, "showing", e), u(this, er, -1);
  }
  /**
   * Turn captions off.
   */
  disableCaptions(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    if (!t)
      return;
    const i = t.state.textTracks, r = t.state.textTrack;
    if (r) {
      const o = i.indexOf(r);
      this.changeTextTrackMode(o, "disabled", e), u(this, er, o);
    }
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(e) {
    const t = this.getPlayer(e == null ? void 0 : e.target);
    t && (t.state.textTrack ? this.disableCaptions() : this.showCaptions());
  }
  userPrefersLoopChange(e, t) {
    a(this, Z, st).call(this, "media-user-loop-change-request", t, e);
  }
}
Zs = new WeakMap(), me = new WeakMap(), er = new WeakMap(), xh = new WeakMap(), Z = new WeakSet(), st = function(e, t, i) {
  var l, d;
  const r = new H(e, {
    bubbles: !0,
    composed: !0,
    cancelable: !0,
    detail: i,
    trigger: t
  });
  let o = (t == null ? void 0 : t.target) || null;
  o && o instanceof Lt && (o = o.el), o = !o || o === document || o === window || o === document.body || ((l = s(this, me)) == null ? void 0 : l.el) && o instanceof Node && !s(this, me).el.contains(o) ? s(this, Zs) ?? ((d = this.getPlayer()) == null ? void 0 : d.el) : o ?? s(this, Zs), s(this, me) ? e === "media-play-request" && !s(this, me).state.canLoad ? o == null || o.dispatchEvent(r) : s(this, me).canPlayQueue.enqueue(e, () => o == null ? void 0 : o.dispatchEvent(r)) : o == null || o.dispatchEvent(r);
}, o$ = function(e) {
};
var xo = h$;
function h$(n, e, t) {
  var i = null, r = null, o = t && t.leading, h = t && t.trailing;
  o == null && (o = !0), h == null && (h = !o), o == !0 && (h = !1);
  var l = function() {
    i && (clearTimeout(i), i = null);
  }, d = function() {
    var p = r;
    l(), p && p();
  }, f = function() {
    var p = o && !i, m = this, w = arguments;
    if (r = function() {
      return n.apply(m, w);
    }, i || (i = setTimeout(function() {
      if (i = null, h)
        return r();
    }, e)), p)
      return p = !1, r();
  };
  return f.cancel = l, f.flush = d, f;
}
var St;
class l$ {
  constructor() {
    y(this, "playerId", "vds-player");
    y(this, "mediaId", null);
    c(this, St, {
      volume: null,
      muted: null,
      audioGain: null,
      time: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null
    });
    y(this, "saveTimeThrottled", xo(this.saveTime.bind(this), 1e3));
  }
  async getVolume() {
    return s(this, St).volume;
  }
  async setVolume(e) {
    s(this, St).volume = e, this.save();
  }
  async getMuted() {
    return s(this, St).muted;
  }
  async setMuted(e) {
    s(this, St).muted = e, this.save();
  }
  async getTime() {
    return s(this, St).time;
  }
  async setTime(e, t) {
    const i = e < 0;
    s(this, St).time = i ? null : e, i || t ? this.saveTime() : this.saveTimeThrottled();
  }
  async getLang() {
    return s(this, St).lang;
  }
  async setLang(e) {
    s(this, St).lang = e, this.save();
  }
  async getCaptions() {
    return s(this, St).captions;
  }
  async setCaptions(e) {
    s(this, St).captions = e, this.save();
  }
  async getPlaybackRate() {
    return s(this, St).rate;
  }
  async setPlaybackRate(e) {
    s(this, St).rate = e, this.save();
  }
  async getAudioGain() {
    return s(this, St).audioGain;
  }
  async setAudioGain(e) {
    s(this, St).audioGain = e, this.save();
  }
  async getVideoQuality() {
    return s(this, St).quality;
  }
  async setVideoQuality(e) {
    s(this, St).quality = e, this.save();
  }
  onChange(e, t, i = "vds-player") {
    const r = i ? localStorage.getItem(i) : null, o = t ? localStorage.getItem(t) : null;
    this.playerId = i, this.mediaId = t, u(this, St, {
      volume: null,
      muted: null,
      audioGain: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null,
      ...r ? JSON.parse(r) : {},
      time: o ? +o : null
    });
  }
  save() {
    if (!this.playerId) return;
    const e = JSON.stringify({ ...s(this, St), time: void 0 });
    localStorage.setItem(this.playerId, e);
  }
  saveTime() {
    if (!this.mediaId) return;
    const e = (s(this, St).time ?? 0).toString();
    localStorage.setItem(this.mediaId, e);
  }
}
St = new WeakMap();
const c$ = Symbol(0), u$ = Symbol(0), d$ = Symbol(0), f$ = Symbol(0), p$ = Symbol(0), m$ = Symbol(0), g$ = Symbol(0), y$ = Symbol(0), b$ = Symbol(0), D = {
  add: c$,
  remove: u$,
  reset: d$,
  select: f$,
  readonly: p$,
  setReadonly: m$,
  onReset: g$,
  onRemove: y$,
  onUserSelect: b$
};
var Od;
class ff extends Gd {
  constructor() {
    super(...arguments);
    y(this, "items", []);
    /** @internal */
    y(this, Od, !1);
  }
  get length() {
    return this.items.length;
  }
  get readonly() {
    return this[D.readonly];
  }
  /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */
  indexOf(t) {
    return this.items.indexOf(t);
  }
  /**
   * Returns an item matching the given `id`, or `null` if not present.
   */
  getById(t) {
    return t === "" ? null : this.items.find((i) => i.id === t) ?? null;
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.items];
  }
  [(Od = D.readonly, Symbol.iterator)]() {
    return this.items.values();
  }
  /** @internal */
  [D.add](t, i) {
    const r = this.items.length;
    "" + r in this || Object.defineProperty(this, r, {
      get() {
        return this.items[r];
      }
    }), !this.items.includes(t) && (this.items.push(t), this.dispatchEvent(new H("add", { detail: t, trigger: i })));
  }
  /** @internal */
  [D.remove](t, i) {
    var o;
    const r = this.items.indexOf(t);
    r >= 0 && ((o = this[D.onRemove]) == null || o.call(this, t, i), this.items.splice(r, 1), this.dispatchEvent(new H("remove", { detail: t, trigger: i })));
  }
  /** @internal */
  [D.reset](t) {
    var i;
    for (const r of [...this.items]) this[D.remove](r, t);
    this.items = [], this[D.setReadonly](!1, t), (i = this[D.onReset]) == null || i.call(this);
  }
  /** @internal */
  [D.setReadonly](t, i) {
    this[D.readonly] !== t && (this[D.readonly] = t, this.dispatchEvent(new H("readonly-change", { detail: t, trigger: i })));
  }
}
const ma = Symbol(0);
class pf extends ff {
  get selected() {
    return this.items.find((e) => e.selected) ?? null;
  }
  get selectedIndex() {
    return this.items.findIndex((e) => e.selected);
  }
  /** @internal */
  [D.onRemove](e, t) {
    this[D.select](e, !1, t);
  }
  /** @internal */
  [D.add](e, t) {
    e[ma] = !1, Object.defineProperty(e, "selected", {
      get() {
        return this[ma];
      },
      set: (i) => {
        var r;
        this.readonly || ((r = this[D.onUserSelect]) == null || r.call(this), this[D.select](e, i));
      }
    }), super[D.add](e, t);
  }
  /** @internal */
  [D.select](e, t, i) {
    if (t === (e == null ? void 0 : e[ma])) return;
    const r = this.selected;
    e && (e[ma] = t), (t ? r !== e : r === e) && (r && (r[ma] = !1), this.dispatchEvent(
      new H("change", {
        detail: {
          prev: r,
          current: this.selected
        },
        trigger: i
      })
    ));
  }
}
class w$ extends pf {
}
function ce(n, e = 2) {
  return Number(n.toFixed(e));
}
function Al(n) {
  var e;
  return ((e = String(n).split(".")[1]) == null ? void 0 : e.length) ?? 0;
}
function qu(n, e, t) {
  return Math.max(n, Math.min(t, e));
}
function nd(n, e) {
  const t = e.composedPath()[0];
  return TT(t) && n.contains(t);
}
const Ml = /* @__PURE__ */ new Set();
{
  let n = function() {
    for (const e of Ml)
      try {
        e();
      } catch {
      }
    window.requestAnimationFrame(n);
  };
  n();
}
function T$(n) {
  return Ml.add(n), () => Ml.delete(n);
}
function Vt(n, e, t) {
  n.hasAttribute(e) || n.setAttribute(e, t);
}
function $$(n, e) {
  if (n.hasAttribute("aria-label") || n.hasAttribute("data-no-label")) return;
  if (!$e(e)) {
    W(n, "aria-label", e);
    return;
  }
  function t() {
    W(n, "aria-label", e());
  }
  b(t);
}
function mf(n) {
  const e = getComputedStyle(n);
  return e.display !== "none" && parseInt(e.opacity) > 0;
}
function v$(n) {
  return !!n && ("checkVisibility" in n ? n.checkVisibility({ checkOpacity: !0, checkVisibilityCSS: !0 }) : mf(n));
}
function gf(n, e) {
  return T$(() => e(v$(n)));
}
function yf(n, e, t) {
  for (; e; ) {
    if (e === n)
      return !0;
    if (t != null && t(e))
      break;
    e = e.parentElement;
  }
  return !1;
}
function ea(n, e) {
  return new dt(n).add("pointerup", (t) => {
    t.button === 0 && !t.defaultPrevented && e(t);
  }).add("keydown", (t) => {
    Kd(t) && e(t);
  });
}
function bf(n) {
  return bT(n) && (n.touches.length > 1 || n.changedTouches.length > 1);
}
function S$(n) {
  return getComputedStyle(n).animationName !== "none";
}
function $h(n) {
  return n instanceof HTMLElement;
}
var Aa, Pi, Ma, ns, Le, wf, Tf, Ll, Il;
class k$ {
  constructor() {
    c(this, Le);
    y(this, "priority", 0);
    c(this, Aa, !0);
    c(this, Pi, null);
    c(this, Ma, null);
    c(this, ns, /* @__PURE__ */ new Set());
  }
  canRender(e, t) {
    return !!t;
  }
  attach(e) {
    u(this, Pi, e), e && (e.textTracks.onchange = a(this, Le, Il).bind(this));
  }
  addTrack(e) {
    s(this, ns).add(e), a(this, Le, wf).call(this, e);
  }
  removeTrack(e) {
    var t, i;
    (i = (t = e[q.native]) == null ? void 0 : t.remove) == null || i.call(t), e[q.native] = null, s(this, ns).delete(e);
  }
  changeTrack(e) {
    const t = e == null ? void 0 : e[q.native];
    t && t.track.mode !== "showing" && (t.track.mode = "showing"), u(this, Ma, e);
  }
  setDisplay(e) {
    u(this, Aa, e), a(this, Le, Il).call(this);
  }
  detach() {
    s(this, Pi) && (s(this, Pi).textTracks.onchange = null);
    for (const e of s(this, ns)) this.removeTrack(e);
    s(this, ns).clear(), u(this, Pi, null), u(this, Ma, null);
  }
}
Aa = new WeakMap(), Pi = new WeakMap(), Ma = new WeakMap(), ns = new WeakMap(), Le = new WeakSet(), wf = function(e) {
  var i;
  if (!s(this, Pi)) return;
  const t = e[i = q.native] ?? (e[i] = a(this, Le, Tf).call(this, e));
  $h(t) && (s(this, Pi).append(t), t.track.mode = t.default ? "showing" : "disabled");
}, Tf = function(e) {
  const t = document.createElement("track"), i = e.default || e.mode === "showing", r = e.src && e.type === "vtt";
  return t.id = e.id, t.src = r ? e.src : "", t.label = e.label, t.kind = e.kind, t.default = i, e.language && (t.srclang = e.language), i && !r && a(this, Le, Ll).call(this, e, t.track), t;
}, Ll = function(e, t) {
  var i;
  if (!(e.src && e.type === "vtt" || (i = t.cues) != null && i.length))
    for (const r of e.cues) t.addCue(r);
}, Il = function(e) {
  for (const t of s(this, ns)) {
    const i = t[q.native];
    if (!i) continue;
    if (!s(this, Aa)) {
      i.track.mode = i.managed ? "hidden" : "disabled";
      continue;
    }
    const r = i.track.mode === "showing";
    r && a(this, Le, Ll).call(this, t, i.track), t.setMode(r ? "showing" : "disabled", e);
  }
};
var tn, ir, en, La, Ia, ge, ze, kt, $f, Rl, vf, Sf, kf, Wn, Pf;
class P$ {
  constructor(e) {
    c(this, kt);
    c(this, tn, null);
    c(this, ir);
    c(this, en, []);
    c(this, La);
    c(this, Ia, !1);
    c(this, ge, null);
    c(this, ze, null);
    u(this, La, e);
    const t = e.textTracks;
    u(this, ir, t), b(a(this, kt, $f).bind(this)), it(a(this, kt, Pf).bind(this)), new dt(t).add("add", a(this, kt, Sf).bind(this)).add("remove", a(this, kt, kf).bind(this)).add("mode-change", a(this, kt, Wn).bind(this));
  }
  add(e) {
    s(this, en).push(e), Zr(a(this, kt, Wn).bind(this));
  }
  remove(e) {
    e.detach(), s(this, en).splice(s(this, en).indexOf(e), 1), Zr(a(this, kt, Wn).bind(this));
  }
  /** @internal */
  attachVideo(e) {
    requestAnimationFrame(() => {
      if (u(this, tn, e), e) {
        u(this, ge, new k$()), s(this, ge).attach(e);
        for (const t of s(this, ir)) a(this, kt, Rl).call(this, t);
      }
      a(this, kt, Wn).call(this);
    });
  }
}
tn = new WeakMap(), ir = new WeakMap(), en = new WeakMap(), La = new WeakMap(), Ia = new WeakMap(), ge = new WeakMap(), ze = new WeakMap(), kt = new WeakSet(), $f = function() {
  const { nativeControls: e } = s(this, La).$state;
  u(this, Ia, e()), a(this, kt, Wn).call(this);
}, Rl = function(e) {
  var t;
  le(e) && ((t = s(this, ge)) == null || t.addTrack(e));
}, vf = function(e) {
  var t;
  le(e) && ((t = s(this, ge)) == null || t.removeTrack(e));
}, Sf = function(e) {
  a(this, kt, Rl).call(this, e.detail);
}, kf = function(e) {
  a(this, kt, vf).call(this, e.detail);
}, Wn = function() {
  var i, r, o, h, l, d, f;
  const e = s(this, ir).selected;
  if (s(this, tn) && (s(this, Ia) || e != null && e[q.nativeHLS])) {
    (i = s(this, ze)) == null || i.changeTrack(null), (r = s(this, ge)) == null || r.setDisplay(!0), (o = s(this, ge)) == null || o.changeTrack(e);
    return;
  }
  if ((h = s(this, ge)) == null || h.setDisplay(!1), (l = s(this, ge)) == null || l.changeTrack(null), !e) {
    (d = s(this, ze)) == null || d.changeTrack(null);
    return;
  }
  const t = s(this, en).sort((p, m) => p.priority - m.priority).find((p) => p.canRender(e, s(this, tn)));
  s(this, ze) !== t && ((f = s(this, ze)) == null || f.detach(), t == null || t.attach(s(this, tn)), u(this, ze, t ?? null)), t == null || t.changeTrack(e);
}, Pf = function() {
  var e, t;
  (e = s(this, ge)) == null || e.detach(), u(this, ge, null), (t = s(this, ze)) == null || t.detach(), u(this, ze, null);
};
var Ou = E$;
function E$(n, e, t) {
  var i = null, r = null, o = function() {
    i && (clearTimeout(i), r = null, i = null);
  }, h = function() {
    var d = r;
    o(), d && d();
  }, l = function() {
    if (!e)
      return n.apply(this, arguments);
    var d = this, f = arguments, p = t && !i;
    if (o(), r = function() {
      n.apply(d, f);
    }, i = setTimeout(function() {
      if (i = null, !p) {
        var m = r;
        return r = null, m();
      }
    }, e), p)
      return r();
  };
  return l.cancel = o, l.flush = h, l;
}
var Dd, sn, Ye, Xe, Je, Ra, sr, qa, ui, Ef, ql, Ol;
class C$ extends ff {
  constructor() {
    super();
    c(this, ui);
    c(this, sn, !1);
    c(this, Ye, {});
    c(this, Xe, null);
    c(this, Je, null);
    /** @internal */
    y(this, Dd);
    c(this, Ra, Ou(async () => {
      var r;
      if (!s(this, sn)) return;
      !s(this, Je) && s(this, Xe) && u(this, Je, await s(this, Xe).getLang());
      const t = await ((r = s(this, Xe)) == null ? void 0 : r.getCaptions()), i = [
        ["captions", "subtitles"],
        "chapters",
        "descriptions",
        "metadata"
      ];
      for (const o of i) {
        const h = this.getByKind(o);
        if (h.find((m) => m.mode === "showing")) continue;
        const l = s(this, Je) ? h.find((m) => m.language === s(this, Je)) : null, d = zt(o) ? s(this, Ye)[o.find((m) => s(this, Ye)[m]) || ""] : s(this, Ye)[o], f = l ?? d, p = f && le(f);
        f && (!p || t !== !1) && (f.mode = "showing", p && a(this, ui, ql).call(this, f));
      }
    }, 300));
    c(this, sr, null);
    c(this, qa, a(this, ui, Ef).bind(this));
  }
  get selected() {
    return this.items.find((i) => i.mode === "showing" && le(i)) ?? null;
  }
  get selectedIndex() {
    const t = this.selected;
    return t ? this.indexOf(t) : -1;
  }
  get preferredLang() {
    return s(this, Je);
  }
  set preferredLang(t) {
    u(this, Je, t), a(this, ui, Ol).call(this, t);
  }
  add(t, i) {
    const r = t instanceof Ns, o = r ? t : new Ns(t), h = t.kind === "captions" || t.kind === "subtitles" ? "captions" : t.kind;
    return s(this, Ye)[h] && t.default && delete t.default, o.addEventListener("mode-change", s(this, qa)), this[D.add](o, i), o[q.crossOrigin] = this[q.crossOrigin], s(this, sn) && o[q.canLoad](), t.default && (s(this, Ye)[h] = o), s(this, Ra).call(this), this;
  }
  remove(t, i) {
    if (u(this, sr, t), !!this.items.includes(t))
      return t === s(this, Ye)[t.kind] && delete s(this, Ye)[t.kind], t.mode = "disabled", t[q.onModeChange] = null, t.removeEventListener("mode-change", s(this, qa)), this[D.remove](t, i), u(this, sr, null), this;
  }
  clear(t) {
    for (const i of [...this.items])
      this.remove(i, t);
    return this;
  }
  getByKind(t) {
    const i = Array.isArray(t) ? t : [t];
    return this.items.filter((r) => i.includes(r.kind));
  }
  /** @internal */
  [(Dd = q.crossOrigin, q.canLoad)]() {
    if (!s(this, sn)) {
      for (const t of this.items) t[q.canLoad]();
      u(this, sn, !0), s(this, Ra).call(this);
    }
  }
  setStorage(t) {
    u(this, Xe, t);
  }
}
sn = new WeakMap(), Ye = new WeakMap(), Xe = new WeakMap(), Je = new WeakMap(), Ra = new WeakMap(), sr = new WeakMap(), qa = new WeakMap(), ui = new WeakSet(), Ef = function(t) {
  const i = t.detail;
  if (s(this, Xe) && le(i) && i !== s(this, sr) && a(this, ui, ql).call(this, i), i.mode === "showing") {
    const r = le(i) ? ["captions", "subtitles"] : [i.kind];
    for (const o of this.items)
      o.mode === "showing" && o != i && r.includes(o.kind) && (o.mode = "disabled");
  }
  this.dispatchEvent(
    new H("mode-change", {
      detail: t.detail,
      trigger: t
    })
  );
}, ql = function(t) {
  var i, r;
  t.mode !== "disabled" && a(this, ui, Ol).call(this, t.language), (r = (i = s(this, Xe)) == null ? void 0 : i.setCaptions) == null || r.call(
    i,
    this.items.some((o) => le(o) && o.mode === "showing")
  );
}, Ol = function(t) {
  var i, r;
  (r = (i = s(this, Xe)) == null ? void 0 : i.setLang) == null || r.call(i, u(this, Je, t));
};
const x$ = Symbol(0), A$ = Symbol(0), ie = {
  setAuto: x$,
  enableAuto: A$
};
var Vd, nn;
class M$ extends pf {
  constructor() {
    super(...arguments);
    c(this, nn, !1);
    /**
     * Configures quality switching:
     *
     * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
     * request if any, flush the whole buffer, and fetch fragment matching with current position
     * and requested quality level.
     *
     * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
     * already buffered next fragment.
     *
     * - `load`: Set quality level for next loaded fragment.
     *
     * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
     * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
     */
    y(this, "switch", "current");
    /** @internal */
    y(this, Vd);
  }
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return s(this, nn) || this.readonly;
  }
  /** @internal */
  [(Vd = ie.enableAuto, D.onUserSelect)]() {
    this[ie.setAuto](!1);
  }
  /** @internal */
  [D.onReset](t) {
    this[ie.enableAuto] = void 0, this[ie.setAuto](!1, t);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(t) {
    var i;
    this.readonly || s(this, nn) || !this[ie.enableAuto] || ((i = this[ie.enableAuto]) == null || i.call(this, t), this[ie.setAuto](!0, t));
  }
  getBySrc(t) {
    return this.items.find((i) => i.src === t);
  }
  /** @internal */
  [ie.setAuto](t, i) {
    s(this, nn) !== t && (u(this, nn, t), this.dispatchEvent(
      new H("auto-change", {
        detail: t,
        trigger: i
      })
    ));
  }
}
nn = new WeakMap();
function L$(n, e) {
  return [...n].sort(e ? R$ : I$);
}
function I$(n, e) {
  return n.height === e.height ? (n.bitrate ?? 0) - (e.bitrate ?? 0) : n.height - e.height;
}
function R$(n, e) {
  return e.height === n.height ? (e.bitrate ?? 0) - (n.bitrate ?? 0) : e.height - n.height;
}
function Nk(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "AUDIO";
}
function Fk(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "VIDEO";
}
function _k(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "DASH";
}
function Hk(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "YOUTUBE";
}
function Uk(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "VIMEO";
}
function q$(n) {
  return n instanceof HTMLAudioElement;
}
function O$(n) {
  return n instanceof HTMLVideoElement;
}
function D$(n) {
  return q$(n) || O$(n);
}
class _n extends qe {
}
const V$ = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "j J ArrowLeft",
  seekForward: "l L ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown",
  speedUp: ">",
  slowDown: "<"
}, ya = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Ctrl"]), N$ = 'button, [role="button"]', rd = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
var Ot, Ct, Cf, xf, Af, Mf, Ko, rn, Lf, Ei, Dl, If;
class F$ extends _n {
  constructor(t) {
    super();
    c(this, Ct);
    c(this, Ot);
    c(this, rn);
    c(this, Ei, null);
    u(this, Ot, t);
  }
  onConnect() {
    b(a(this, Ct, Cf).bind(this));
  }
}
Ot = new WeakMap(), Ct = new WeakSet(), Cf = function() {
  const { keyDisabled: t, keyTarget: i } = this.$props;
  if (t()) return;
  const r = i() === "player" ? this.el : document, o = V(!1);
  r === this.el ? new dt(this.el).add("focusin", () => o.set(!0)).add("focusout", (h) => {
    this.el.contains(h.target) || o.set(!1);
  }) : (v(o) || o.set(document.querySelector("[data-media-player]") === this.el), ft(document, "focusin", (h) => {
    const l = h.composedPath().find((d) => d instanceof Element && d.localName === "media-player");
    l !== void 0 && o.set(this.el === l);
  })), b(() => {
    o() && new dt(r).add("keyup", a(this, Ct, xf).bind(this)).add("keydown", a(this, Ct, Af).bind(this)).add("keydown", a(this, Ct, Mf).bind(this), { capture: !0 });
  });
}, xf = function(t) {
  var h, l;
  const i = document.activeElement;
  if (!t.key || !this.$state.canSeek() || i != null && i.matches(rd))
    return;
  let { method: r, value: o } = a(this, Ct, Ko).call(this, t);
  if (!R(o) && !zt(o)) {
    (h = o == null ? void 0 : o.onKeyUp) == null || h.call(o, {
      event: t,
      player: s(this, Ot).player,
      remote: s(this, Ot).remote
    }), (l = o == null ? void 0 : o.callback) == null || l.call(o, t, s(this, Ot).remote);
    return;
  }
  if (r != null && r.startsWith("seek") && (t.preventDefault(), t.stopPropagation(), s(this, Ei) ? (a(this, Ct, Dl).call(this, t, r === "seekForward"), u(this, Ei, null)) : (s(this, Ot).remote.seek(s(this, rn), t), u(this, rn, void 0))), r != null && r.startsWith("volume")) {
    const d = this.el.querySelector("[data-media-volume-slider]");
    d == null || d.dispatchEvent(
      new KeyboardEvent("keyup", {
        key: r === "volumeUp" ? "Up" : "Down",
        shiftKey: t.shiftKey,
        trigger: t
      })
    );
  }
}, Af = function(t) {
  var l, d, f, p;
  if (!t.key || ya.has(t.key)) return;
  const i = document.activeElement;
  if (i != null && i.matches(rd) || Kd(t) && (i != null && i.matches(N$)))
    return;
  let { method: r, value: o } = a(this, Ct, Ko).call(this, t), h = !t.metaKey && /^[0-9]$/.test(t.key);
  if (!R(o) && !zt(o) && !h) {
    (l = o == null ? void 0 : o.onKeyDown) == null || l.call(o, {
      event: t,
      player: s(this, Ot).player,
      remote: s(this, Ot).remote
    }), (d = o == null ? void 0 : o.callback) == null || d.call(o, t, s(this, Ot).remote);
    return;
  }
  if (!r && h && !U$(t)) {
    t.preventDefault(), t.stopPropagation(), s(this, Ot).remote.seek(this.$state.duration() / 10 * Number(t.key), t);
    return;
  }
  if (r) {
    switch (t.preventDefault(), t.stopPropagation(), r) {
      case "seekForward":
      case "seekBackward":
        a(this, Ct, If).call(this, t, r, r === "seekForward");
        break;
      case "volumeUp":
      case "volumeDown":
        const m = this.el.querySelector("[data-media-volume-slider]");
        if (m)
          m.dispatchEvent(
            new KeyboardEvent("keydown", {
              key: r === "volumeUp" ? "Up" : "Down",
              shiftKey: t.shiftKey,
              trigger: t
            })
          );
        else {
          const P = t.shiftKey ? 0.1 : 0.05;
          s(this, Ot).remote.changeVolume(
            this.$state.volume() + (r === "volumeUp" ? +P : -P),
            t
          );
        }
        break;
      case "toggleFullscreen":
        s(this, Ot).remote.toggleFullscreen("prefer-media", t);
        break;
      case "speedUp":
      case "slowDown":
        const w = this.$state.playbackRate();
        s(this, Ot).remote.changePlaybackRate(
          Math.max(0.25, Math.min(2, w + (r === "speedUp" ? 0.25 : -0.25))),
          t
        );
        break;
      default:
        (p = (f = s(this, Ot).remote)[r]) == null || p.call(f, t);
    }
    this.$state.lastKeyboardAction.set({
      action: r,
      event: t
    });
  }
}, Mf = function(t) {
  D$(t.target) && a(this, Ct, Ko).call(this, t).method && t.preventDefault();
}, Ko = function(t) {
  const i = {
    ...this.$props.keyShortcuts(),
    ...s(this, Ot).ariaKeys
  }, r = Object.keys(i).find((o) => {
    var f;
    const h = i[o], l = zt(h) ? h.join(" ") : R(h) ? h : h == null ? void 0 : h.keys, d = (f = zt(l) ? l : l == null ? void 0 : l.split(" ")) == null ? void 0 : f.map(
      (p) => H$(p).replace(/Control/g, "Ctrl").split("+")
    );
    return d == null ? void 0 : d.some((p) => {
      const m = new Set(p.filter((w) => ya.has(w)));
      for (const w of ya) {
        const P = w.toLowerCase() + "Key";
        if (!m.has(w) && t[P])
          return !1;
      }
      return p.every((w) => ya.has(w) ? t[w.toLowerCase() + "Key"] : t.key === w.replace("Space", " "));
    });
  });
  return {
    method: r,
    value: r ? i[r] : null
  };
}, rn = new WeakMap(), Lf = function(t, i) {
  const r = t.shiftKey ? 10 : 5;
  return u(this, rn, Math.max(
    0,
    Math.min(
      (s(this, rn) ?? this.$state.currentTime()) + (i === "seekForward" ? +r : -r),
      this.$state.duration()
    )
  ));
}, Ei = new WeakMap(), Dl = function(t, i) {
  var r;
  (r = s(this, Ei)) == null || r.dispatchEvent(
    new KeyboardEvent(t.type, {
      key: i ? "Right" : "Left",
      shiftKey: t.shiftKey,
      trigger: t
    })
  );
}, If = function(t, i, r) {
  this.$state.canSeek() && (s(this, Ei) || u(this, Ei, this.el.querySelector("[data-media-time-slider]")), s(this, Ei) ? a(this, Ct, Dl).call(this, t, r) : s(this, Ot).remote.seeking(a(this, Ct, Lf).call(this, t, i), t));
};
const _$ = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function H$(n) {
  return n.replace(/Shift\+(\d)/g, (e, t) => _$[t - 1]);
}
function U$(n) {
  for (const e of ya)
    if (n[e.toLowerCase() + "Key"])
      return !0;
  return !1;
}
var an;
class B$ extends qe {
  constructor(t) {
    super();
    c(this, an);
    u(this, an, t);
  }
  onAttach(t) {
    const { $props: i, ariaKeys: r } = ue(), o = t.getAttribute("aria-keyshortcuts");
    if (o) {
      r[s(this, an)] = o, it(() => {
        delete r[s(this, an)];
      });
      return;
    }
    const h = i.keyShortcuts()[s(this, an)];
    if (h) {
      const l = zt(h) ? h.join(" ") : R(h) ? h : h == null ? void 0 : h.keys;
      t.setAttribute("aria-keyshortcuts", zt(l) ? l.join(" ") : l);
    }
  }
}
an = new WeakMap();
var nr, Ci, Oa, rr, rs, ar, tt, Rf, qf, Of, Df, Vf, Nf, Ff, _f, Qo, Vl, ba, Nl;
class j$ extends _n {
  constructor() {
    super(...arguments);
    c(this, tt);
    c(this, nr, -2);
    c(this, Ci, !1);
    c(this, Oa, V(!1));
    c(this, rr, V(!1));
    c(this, rs, null);
    c(this, ar, V(!0));
    /**
     * The default amount of delay in milliseconds while media playback is progressing without user
     * activity to indicate an idle state (i.e., hide controls).
     *
     * @defaultValue 2000
     */
    y(this, "defaultDelay", 2e3);
  }
  /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */
  get canIdle() {
    return s(this, ar).call(this);
  }
  set canIdle(t) {
    s(this, ar).set(t);
  }
  /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */
  get hideOnMouseLeave() {
    const { hideControlsOnMouseLeave: t } = this.$props;
    return s(this, Oa).call(this) || t();
  }
  set hideOnMouseLeave(t) {
    s(this, Oa).set(t);
  }
  /**
   * Whether media controls are currently visible.
   */
  get showing() {
    return this.$state.controlsVisible();
  }
  /**
   * Show controls.
   */
  show(t = 0, i) {
    a(this, tt, Qo).call(this), s(this, Ci) || a(this, tt, ba).call(this, !0, t, i);
  }
  /**
   * Hide controls.
   */
  hide(t = this.defaultDelay, i) {
    a(this, tt, Qo).call(this), s(this, Ci) || a(this, tt, ba).call(this, !1, t, i);
  }
  /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */
  pause(t) {
    u(this, Ci, !0), a(this, tt, Qo).call(this), a(this, tt, ba).call(this, !0, 0, t);
  }
  resume(t) {
    u(this, Ci, !1), !this.$state.paused() && a(this, tt, ba).call(this, !1, this.defaultDelay, t);
  }
  onConnect() {
    b(a(this, tt, Rf).bind(this));
  }
}
nr = new WeakMap(), Ci = new WeakMap(), Oa = new WeakMap(), rr = new WeakMap(), rs = new WeakMap(), ar = new WeakMap(), tt = new WeakSet(), Rf = function() {
  const { viewType: t } = this.$state;
  if (!this.el || !s(this, ar).call(this)) return;
  if (t() === "audio") {
    this.show();
    return;
  }
  b(a(this, tt, qf).bind(this)), b(a(this, tt, Of).bind(this));
  const i = a(this, tt, Df).bind(this), r = a(this, tt, Vf).bind(this), o = a(this, tt, Nf).bind(this);
  new dt(this.el).add("can-play", (h) => this.show(0, h)).add("play", i).add("pause", r).add("end", o).add("auto-play-fail", r);
}, qf = function() {
  if (!this.el) return;
  const { started: t, pointer: i, paused: r } = this.$state;
  if (!t() || i() !== "fine") return;
  const o = new dt(this.el), h = this.hideOnMouseLeave;
  (!h || !s(this, rr).call(this)) && b(() => {
    r() || o.add("pointermove", a(this, tt, Vl).bind(this));
  }), h && o.add("mouseenter", a(this, tt, Ff).bind(this)).add("mouseleave", a(this, tt, _f).bind(this));
}, Of = function() {
  const { paused: t, started: i, autoPlayError: r } = this.$state;
  if (t() || r() && !i()) return;
  const o = a(this, tt, Vl).bind(this);
  b(() => {
    if (!this.el) return;
    const h = this.$state.pointer(), l = h === "coarse", d = new dt(this.el), f = [l ? "touchend" : "pointerup", "keydown"];
    for (const p of f)
      d.add(p, o, { passive: !1 });
  });
}, Df = function(t) {
  t.triggers.hasType("ended") || (this.show(0, t), this.hide(void 0, t));
}, Vf = function(t) {
  this.show(0, t);
}, Nf = function(t) {
  const { loop: i } = this.$state;
  i() && this.hide(0, t);
}, Ff = function(t) {
  s(this, rr).set(!1), this.show(0, t), this.hide(void 0, t);
}, _f = function(t) {
  s(this, rr).set(!0), this.hide(0, t);
}, Qo = function() {
  window.clearTimeout(s(this, nr)), u(this, nr, -1);
}, Vl = function(t) {
  var i;
  // @ts-expect-error
  t.MEDIA_GESTURE || s(this, Ci) || bf(t) || (Yh(t) && (t.key === "Escape" ? ((i = this.el) == null || i.focus(), u(this, rs, null)) : s(this, rs) && (t.preventDefault(), requestAnimationFrame(() => {
    var r;
    (r = s(this, rs)) == null || r.focus(), u(this, rs, null);
  }))), this.show(0, t), this.hide(this.defaultDelay, t));
}, ba = function(t, i, r) {
  if (i === 0) {
    a(this, tt, Nl).call(this, t, r);
    return;
  }
  u(this, nr, window.setTimeout(() => {
    this.scope && a(this, tt, Nl).call(this, t && !s(this, Ci), r);
  }, i));
}, Nl = function(t, i) {
  var r;
  this.$state.controlsVisible() !== t && (this.$state.controlsVisible.set(t), !t && document.activeElement && ((r = this.el) != null && r.contains(document.activeElement)) && u(this, rs, document.activeElement), this.dispatch("controls-change", {
    detail: t,
    trigger: i
  }));
};
const Fl = qn.fullscreenEnabled;
var as, or, Fs, Hf, Uf, Bf;
class W$ extends qe {
  constructor() {
    super(...arguments);
    c(this, Fs);
    /**
     * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
     * listened to globally on the document so we need to know if they relate to the current host
     * element or not.
     */
    c(this, as, !1);
    c(this, or, !1);
  }
  get active() {
    return s(this, or);
  }
  get supported() {
    return Fl;
  }
  onConnect() {
    new dt(qn).add("fullscreenchange", a(this, Fs, Uf).bind(this)).add("fullscreenerror", a(this, Fs, Bf).bind(this)), it(a(this, Fs, Hf).bind(this));
  }
  async enter() {
    try {
      return u(this, as, !0), !this.el || pl(this.el) ? void 0 : (ad(), qn.requestFullscreen(this.el));
    } catch (t) {
      throw u(this, as, !1), t;
    }
  }
  async exit() {
    if (!(!this.el || !pl(this.el)))
      return ad(), qn.exitFullscreen();
  }
}
as = new WeakMap(), or = new WeakMap(), Fs = new WeakSet(), Hf = async function() {
  Fl && await this.exit();
}, Uf = function(t) {
  const i = pl(this.el);
  i !== s(this, or) && (i || u(this, as, !1), u(this, or, i), this.dispatch("fullscreen-change", { detail: i, trigger: t }));
}, Bf = function(t) {
  s(this, as) && (this.dispatch("fullscreen-error", { detail: null, trigger: t }), u(this, as, !1));
};
function pl(n) {
  if (qn.fullscreenElement === n) return !0;
  try {
    return n.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      qn.fullscreenPseudoClass
    );
  } catch {
    return !1;
  }
}
function ad() {
  if (!Fl)
    throw Error(
      "[vidstack] no fullscreen API"
    );
}
var os, xi, on, ve, jf, _l, Hl, Ul;
const Ah = class Ah extends qe {
  constructor() {
    super(...arguments);
    c(this, ve);
    c(this, os, V(a(this, ve, Ul).call(this)));
    c(this, xi, V(!1));
    c(this, on);
  }
  /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get type() {
    return s(this, os).call(this);
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return s(this, xi).call(this);
  }
  /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */
  get portrait() {
    return s(this, os).call(this).startsWith("portrait");
  }
  /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */
  get landscape() {
    return s(this, os).call(this).startsWith("landscape");
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return Ah.supported;
  }
  onConnect() {
    if (this.supported)
      ft(screen.orientation, "change", a(this, ve, _l).bind(this));
    else {
      const t = window.matchMedia("(orientation: landscape)");
      t.onchange = a(this, ve, _l).bind(this), it(() => t.onchange = null);
    }
    it(a(this, ve, jf).bind(this));
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(t) {
    v(s(this, xi)) || s(this, on) === t || (a(this, ve, Hl).call(this), await screen.orientation.lock(t), s(this, xi).set(!0), u(this, on, t));
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    v(s(this, xi)) && (a(this, ve, Hl).call(this), u(this, on, void 0), await screen.orientation.unlock(), s(this, xi).set(!1));
  }
};
os = new WeakMap(), xi = new WeakMap(), on = new WeakMap(), ve = new WeakSet(), jf = async function() {
  this.supported && s(this, xi).call(this) && await this.unlock();
}, _l = function(t) {
  s(this, os).set(a(this, ve, Ul).call(this)), this.dispatch("orientation-change", {
    detail: {
      orientation: v(s(this, os)),
      lock: s(this, on)
    },
    trigger: t
  });
}, Hl = function() {
  if (!this.supported)
    throw Error(
      "[vidstack] no orientation API"
    );
}, Ul = function() {
  return this.supported ? window.screen.orientation.type : window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
}, /**
 * Whether the native Screen Orientation API is available.
 */
y(Ah, "supported", ef());
let vh = Ah;
class G$ {
  constructor() {
    y(this, "name", "audio");
    y(this, "target");
  }
  canPlay(e) {
    return rf(e) ? !R(e.src) || e.type === "?" || sf(this.target, e.type) : !1;
  }
  mediaType() {
    return "audio";
  }
  async load(e) {
    return new (await import("./vidstack-audio-D-Rq-ghI.js")).AudioProvider(this.target, e);
  }
}
class Du {
  constructor() {
    y(this, "name", "video");
    y(this, "target");
  }
  canPlay(e) {
    return af(e) ? !R(e.src) || e.type === "?" || nf(this.target, e.type) : !1;
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    return new (await import("./vidstack-video-dFAZHvkx.js")).VideoProvider(this.target, e);
  }
}
const Mh = class Mh extends Du {
  constructor() {
    super(...arguments);
    y(this, "name", "hls");
  }
  canPlay(t) {
    return Mh.supported && ca(t);
  }
  async load(t) {
    return new (await import("./vidstack-hls-DqW0EBdu.js")).HLSProvider(this.target, t);
  }
};
y(Mh, "supported", Mu());
let Bl = Mh, zo = null, Sh = [], kh = [];
function Vu() {
  return zo ?? (zo = new AudioContext());
}
function K$() {
  const n = Vu(), e = n.createGain();
  return e.connect(n.destination), Sh.push(e), e;
}
function Q$(n, e) {
  const t = Vu(), i = t.createMediaElementSource(n);
  return e && i.connect(e), kh.push(i), i;
}
function z$(n) {
  const e = Sh.indexOf(n);
  e !== -1 && (Sh.splice(e, 1), n.disconnect(), Wf());
}
function Y$(n) {
  const e = kh.indexOf(n);
  e !== -1 && (kh.splice(e, 1), n.disconnect(), Wf());
}
function Wf() {
  zo && Sh.length === 0 && kh.length === 0 && zo.close().then(() => {
    zo = null;
  });
}
var Da, hr, ye, Ee, Nn, Gf, jl;
class Bk {
  constructor(e, t) {
    c(this, Nn);
    c(this, Da);
    c(this, hr);
    c(this, ye, null);
    c(this, Ee, null);
    u(this, Da, e), u(this, hr, t);
  }
  get currentGain() {
    var e, t;
    return ((t = (e = s(this, ye)) == null ? void 0 : e.gain) == null ? void 0 : t.value) ?? null;
  }
  get supported() {
    return !0;
  }
  setGain(e) {
    const t = this.currentGain;
    if (e !== this.currentGain) {
      if (e === 1 && t !== 1) {
        this.removeGain();
        return;
      }
      s(this, ye) || (u(this, ye, K$()), s(this, Ee) && s(this, Ee).connect(s(this, ye))), s(this, Ee) || u(this, Ee, Q$(s(this, Da), s(this, ye))), s(this, ye).gain.value = e, s(this, hr).call(this, e);
    }
  }
  removeGain() {
    s(this, ye) && (s(this, Ee) && s(this, Ee).connect(Vu().destination), a(this, Nn, jl).call(this), s(this, hr).call(this, null));
  }
  destroy() {
    a(this, Nn, Gf).call(this), a(this, Nn, jl).call(this);
  }
}
Da = new WeakMap(), hr = new WeakMap(), ye = new WeakMap(), Ee = new WeakMap(), Nn = new WeakSet(), Gf = function() {
  if (s(this, Ee))
    try {
      Y$(s(this, Ee));
    } catch {
    } finally {
      u(this, Ee, null);
    }
}, jl = function() {
  if (s(this, ye))
    try {
      z$(s(this, ye));
    } catch {
    } finally {
      u(this, ye, null);
    }
};
const X$ = ["focus", "blur", "visibilitychange", "pageshow", "pagehide"];
var hn, lr, Va, Lh, Kf;
class J$ {
  constructor() {
    c(this, Lh);
    c(this, hn, V(od()));
    c(this, lr, V(document.visibilityState));
    c(this, Va);
  }
  connect() {
    const e = new dt(window), t = a(this, Lh, Kf).bind(this);
    for (const i of X$)
      e.add(i, t);
    Th && e.add("beforeunload", (i) => {
      u(this, Va, setTimeout(() => {
        i.defaultPrevented || i.returnValue.length > 0 || (s(this, hn).set("hidden"), s(this, lr).set("hidden"));
      }, 0));
    });
  }
  /**
   * The current page state. Important to note we only account for a subset of page states, as
   * the rest aren't valuable to the player at the moment.
   *
   * - **active:** A page is in the active state if it is visible and has input focus.
   * - **passive:** A page is in the passive state if it is visible and does not have input focus.
   * - **hidden:** A page is in the hidden state if it is not visible.
   *
   * @see https://developers.google.com/web/updates/2018/07/page-lifecycle-api#states
   */
  get pageState() {
    return s(this, hn).call(this);
  }
  /**
   * The current document visibility state.
   *
   * - **visible:** The page content may be at least partially visible. In practice, this means that
   * the page is the foreground tab of a non-minimized window.
   * - **hidden:** The page content is not visible to the user. In practice this means that the
   * document is either a background tab or part of a minimized window, or the OS screen lock is
   * active.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
   */
  get visibility() {
    return s(this, lr).call(this);
  }
}
hn = new WeakMap(), lr = new WeakMap(), Va = new WeakMap(), Lh = new WeakSet(), Kf = function(e) {
  Th && window.clearTimeout(s(this, Va)), (e.type !== "blur" || s(this, hn).call(this) === "active") && (s(this, hn).set(od(e)), s(this, lr).set(document.visibilityState == "hidden" ? "hidden" : "visible"));
};
function od(n) {
  return (n == null ? void 0 : n.type) === "blur" || document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
var Ai, Na, Fa, Wl;
class Nu {
  constructor(e) {
    c(this, Fa);
    c(this, Ai);
    c(this, Na);
    u(this, Na, e);
  }
  start() {
    Et(s(this, Ai)) && a(this, Fa, Wl).call(this);
  }
  stop() {
    Te(s(this, Ai)) && window.cancelAnimationFrame(s(this, Ai)), u(this, Ai, void 0);
  }
}
Ai = new WeakMap(), Na = new WeakMap(), Fa = new WeakSet(), Wl = function() {
  u(this, Ai, window.requestAnimationFrame(() => {
    Et(s(this, Ai)) || (s(this, Na).call(this), a(this, Fa, Wl).call(this));
  }));
};
var _a, j, hs, cr, ur, ln, Ha, dr, g, J, Qf, fr, pr, zf, Yf, Xf, Jf, Ih, wu, vt, Z$, js, Zf, Gl, tp, ep, ip, Yo, sp, np, rp, ap, op, hp, lp, cp, up, dp, fp, pp, mp, gp, yp, bp, wp, Tp;
class jk {
  constructor(e, t) {
    c(this, g);
    c(this, _a);
    c(this, j);
    c(this, hs, !1);
    c(this, cr, !1);
    c(this, ur, !1);
    c(this, ln, new Nu(a(this, g, zf).bind(this)));
    c(this, Ha, new J$());
    c(this, dr);
    /**
     * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
     * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
     * resolve that by retrieving time updates in a request animation frame loop.
     */
    c(this, fr, 0);
    c(this, pr, -1);
    c(this, Ih);
    c(this, wu);
    u(this, _a, e), u(this, j, t), u(this, dr, new dt(e.media)), a(this, g, Yf).call(this), s(this, Ha).connect(), b(a(this, g, up).bind(this)), it(a(this, g, Qf).bind(this));
  }
}
_a = new WeakMap(), j = new WeakMap(), hs = new WeakMap(), cr = new WeakMap(), ur = new WeakMap(), ln = new WeakMap(), Ha = new WeakMap(), dr = new WeakMap(), g = new WeakSet(), J = function() {
  return s(this, _a).media;
}, Qf = function() {
  var e;
  u(this, cr, !1), u(this, ur, !1), s(this, ln).stop(), s(this, dr).abort(), (e = s(this, Ih)) == null || e.clear();
}, fr = new WeakMap(), pr = new WeakMap(), zf = function() {
  const e = s(this, g, J).currentTime;
  !(Th && e - s(this, pr) < 0.35) && s(this, fr) !== e && (a(this, g, js).call(this, e), u(this, fr, e));
}, Yf = function() {
  a(this, g, vt).call(this, "loadstart", a(this, g, Zf)), a(this, g, vt).call(this, "abort", a(this, g, Gl)), a(this, g, vt).call(this, "emptied", a(this, g, tp)), a(this, g, vt).call(this, "error", a(this, g, Tp)), a(this, g, vt).call(this, "volumechange", a(this, g, pp));
}, Xf = function() {
  s(this, cr) || (a(this, g, vt).call(this, "loadeddata", a(this, g, ep)), a(this, g, vt).call(this, "loadedmetadata", a(this, g, ip)), a(this, g, vt).call(this, "canplay", a(this, g, rp)), a(this, g, vt).call(this, "canplaythrough", a(this, g, ap)), a(this, g, vt).call(this, "durationchange", a(this, g, fp)), a(this, g, vt).call(this, "play", a(this, g, sp)), a(this, g, vt).call(this, "progress", a(this, g, yp)), a(this, g, vt).call(this, "stalled", a(this, g, hp)), a(this, g, vt).call(this, "suspend", a(this, g, bp)), a(this, g, vt).call(this, "ratechange", a(this, g, wp)), u(this, cr, !0));
}, Jf = function() {
  s(this, ur) || (a(this, g, vt).call(this, "pause", a(this, g, np)), a(this, g, vt).call(this, "playing", a(this, g, op)), a(this, g, vt).call(this, "seeked", a(this, g, mp)), a(this, g, vt).call(this, "seeking", a(this, g, gp)), a(this, g, vt).call(this, "ended", a(this, g, cp)), a(this, g, vt).call(this, "waiting", a(this, g, lp)), u(this, ur, !0));
}, Ih = new WeakMap(), wu = new WeakMap(), vt = function(e, t) {
  s(this, dr).add(e, t.bind(this));
}, Z$ = function(e) {
}, js = function(e, t) {
  const i = Math.min(e, s(this, j).$state.seekableEnd());
  s(this, j).notify("time-change", i, t);
}, Zf = function(e) {
  if (s(this, g, J).networkState === 3) {
    a(this, g, Gl).call(this, e);
    return;
  }
  a(this, g, Xf).call(this), s(this, j).notify("load-start", void 0, e);
}, Gl = function(e) {
  s(this, j).notify("abort", void 0, e);
}, tp = function() {
  s(this, j).notify("emptied", void 0, event);
}, ep = function(e) {
  s(this, j).notify("loaded-data", void 0, e);
}, ip = function(e) {
  u(this, fr, 0), u(this, pr, -1), a(this, g, Jf).call(this), s(this, j).notify("loaded-metadata", void 0, e), (Zh || Th && ca(s(this, j).$state.source())) && s(this, j).delegate.ready(a(this, g, Yo).call(this), e);
}, Yo = function() {
  return {
    provider: v(s(this, j).$provider),
    duration: s(this, g, J).duration,
    buffered: s(this, g, J).buffered,
    seekable: s(this, g, J).seekable
  };
}, sp = function(e) {
  s(this, j).$state.canPlay && s(this, j).notify("play", void 0, e);
}, np = function(e) {
  s(this, g, J).readyState === 1 && !s(this, hs) || (u(this, hs, !1), s(this, ln).stop(), s(this, j).notify("pause", void 0, e));
}, rp = function(e) {
  s(this, j).delegate.ready(a(this, g, Yo).call(this), e);
}, ap = function(e) {
  s(this, j).$state.started() || s(this, j).notify("can-play-through", a(this, g, Yo).call(this), e);
}, op = function(e) {
  s(this, g, J).paused || (u(this, hs, !1), s(this, j).notify("playing", void 0, e), s(this, ln).start());
}, hp = function(e) {
  s(this, j).notify("stalled", void 0, e), s(this, g, J).readyState < 3 && (u(this, hs, !0), s(this, j).notify("waiting", void 0, e));
}, lp = function(e) {
  s(this, g, J).readyState < 3 && (u(this, hs, !0), s(this, j).notify("waiting", void 0, e));
}, cp = function(e) {
  s(this, ln).stop(), a(this, g, js).call(this, s(this, g, J).duration, e), s(this, j).notify("end", void 0, e), s(this, j).$state.loop() && dT(s(this, g, J).controls) && (s(this, g, J).controls = !1);
}, up = function() {
  const e = s(this, j).$state.paused(), t = s(this, Ha).visibility === "hidden";
  (e || t) && ft(s(this, g, J), "timeupdate", a(this, g, dp).bind(this));
}, dp = function(e) {
  a(this, g, js).call(this, s(this, g, J).currentTime, e);
}, fp = function(e) {
  s(this, j).$state.ended() && a(this, g, js).call(this, s(this, g, J).duration, e), s(this, j).notify("duration-change", s(this, g, J).duration, e);
}, pp = function(e) {
  const t = {
    volume: s(this, g, J).volume,
    muted: s(this, g, J).muted
  };
  s(this, j).notify("volume-change", t, e);
}, mp = function(e) {
  u(this, pr, s(this, g, J).currentTime), a(this, g, js).call(this, s(this, g, J).currentTime, e), s(this, j).notify("seeked", s(this, g, J).currentTime, e), Math.trunc(s(this, g, J).currentTime) === Math.trunc(s(this, g, J).duration) && Al(s(this, g, J).duration) > Al(s(this, g, J).currentTime) && (a(this, g, js).call(this, s(this, g, J).duration, e), s(this, g, J).ended || s(this, j).player.dispatch(
    new H("media-play-request", {
      trigger: e
    })
  ));
}, gp = function(e) {
  s(this, j).notify("seeking", s(this, g, J).currentTime, e);
}, yp = function(e) {
  const t = {
    buffered: s(this, g, J).buffered,
    seekable: s(this, g, J).seekable
  };
  s(this, j).notify("progress", t, e);
}, bp = function(e) {
  s(this, j).notify("suspend", void 0, e);
}, wp = function(e) {
  s(this, j).notify("rate-change", s(this, g, J).playbackRate, e);
}, Tp = function(e) {
  const t = s(this, g, J).error;
  if (!t) return;
  const i = {
    message: t.message,
    code: t.code,
    mediaError: t
  };
  s(this, j).notify("error", i, e);
};
var Ua, Ne, Rt, Gn, $p, vp, Sp, Kl, kp;
class Wk {
  constructor(e, t) {
    c(this, Rt);
    c(this, Ua);
    c(this, Ne);
    u(this, Ua, e), u(this, Ne, t), s(this, Rt, Gn).onaddtrack = a(this, Rt, $p).bind(this), s(this, Rt, Gn).onremovetrack = a(this, Rt, vp).bind(this), s(this, Rt, Gn).onchange = a(this, Rt, Sp).bind(this), ft(s(this, Ne).audioTracks, "change", a(this, Rt, kp).bind(this));
  }
}
Ua = new WeakMap(), Ne = new WeakMap(), Rt = new WeakSet(), Gn = function() {
  return s(this, Ua).media.audioTracks;
}, $p = function(e) {
  const t = e.track;
  if (t.label === "") return;
  const i = t.id.toString() || `native-audio-${s(this, Ne).audioTracks.length}`, r = {
    id: i,
    label: t.label,
    language: t.language,
    kind: t.kind,
    selected: !1
  };
  s(this, Ne).audioTracks[D.add](r, e), t.enabled && (r.selected = !0);
}, vp = function(e) {
  const t = s(this, Ne).audioTracks.getById(e.track.id);
  t && s(this, Ne).audioTracks[D.remove](t, e);
}, Sp = function(e) {
  let t = a(this, Rt, Kl).call(this);
  if (!t) return;
  const i = s(this, Ne).audioTracks.getById(t.id);
  i && s(this, Ne).audioTracks[D.select](i, !0, e);
}, Kl = function() {
  return Array.from(s(this, Rt, Gn)).find((e) => e.enabled);
}, kp = function(e) {
  const { current: t } = e.detail;
  if (!t) return;
  const i = s(this, Rt, Gn).getTrackById(t.id);
  if (i) {
    const r = a(this, Rt, Kl).call(this);
    r && (r.enabled = !1), i.enabled = !0;
  }
};
var Ce, Ba, ja, cn, _s, Pp, Ep, Cp;
class tv {
  constructor(e, t) {
    c(this, _s);
    c(this, Ce);
    c(this, Ba);
    c(this, ja);
    c(this, cn, V(!1));
    u(this, Ce, e), u(this, Ba, t), a(this, _s, Pp).call(this);
  }
  get supported() {
    return s(this, cn).call(this);
  }
  async prompt() {
    if (!this.supported) throw Error("Not supported on this platform.");
    return this.type === "airplay" && s(this, Ce).webkitShowPlaybackTargetPicker ? s(this, Ce).webkitShowPlaybackTargetPicker() : s(this, Ce).remote.prompt();
  }
}
Ce = new WeakMap(), Ba = new WeakMap(), ja = new WeakMap(), cn = new WeakMap(), _s = new WeakSet(), Pp = function() {
  var e;
  !((e = s(this, Ce)) != null && e.remote) || !this.canPrompt || (s(this, Ce).remote.watchAvailability((t) => {
    s(this, cn).set(t);
  }).catch(() => {
    s(this, cn).set(!1);
  }), b(a(this, _s, Ep).bind(this)));
}, Ep = function() {
  if (!s(this, cn).call(this)) return;
  const e = ["connecting", "connect", "disconnect"], t = a(this, _s, Cp).bind(this);
  t(), ft(s(this, Ce), "playing", t);
  const i = new dt(s(this, Ce).remote);
  for (const r of e)
    i.add(r, t);
}, Cp = function(e) {
  const t = s(this, Ce).remote.state;
  if (t === s(this, ja)) return;
  const i = { type: this.type, state: t };
  s(this, Ba).notify("remote-playback-change", i, e), u(this, ja, t);
};
class Gk extends tv {
  constructor() {
    super(...arguments);
    y(this, "type", "airplay");
  }
  get canPrompt() {
    return "WebKitPlaybackTargetAvailabilityEvent" in window;
  }
}
var mr, gr, ia, xp, Ap;
class Kk {
  constructor(e, t) {
    c(this, ia);
    c(this, mr);
    c(this, gr);
    u(this, mr, e), u(this, gr, t), e.textTracks.onaddtrack = a(this, ia, xp).bind(this), it(a(this, ia, Ap).bind(this));
  }
}
mr = new WeakMap(), gr = new WeakMap(), ia = new WeakSet(), xp = function(e) {
  const t = e.track;
  if (!t || ev(s(this, mr), t)) return;
  const i = new Ns({
    id: t.id,
    kind: t.kind,
    label: t.label ?? "",
    language: t.language,
    type: "vtt"
  });
  i[q.native] = { track: t }, i[q.readyState] = 2, i[q.nativeHLS] = !0;
  let r = 0;
  const o = (h) => {
    if (t.cues)
      for (let l = r; l < t.cues.length; l++)
        i.addCue(t.cues[l], h), r++;
  };
  o(e), t.oncuechange = o, s(this, gr).textTracks.add(i, e), i.setMode(t.mode, e);
}, Ap = function() {
  var e;
  s(this, mr).textTracks.onaddtrack = null;
  for (const t of s(this, gr).textTracks) {
    const i = (e = t[q.native]) == null ? void 0 : e.track;
    i != null && i.oncuechange && (i.oncuechange = null);
  }
};
function ev(n, e) {
  return Array.from(n.children).find((t) => t.track === e);
}
var un, Wa, sa, Mp, Lp, Ga;
class Qk {
  constructor(e, t) {
    c(this, sa);
    c(this, un);
    c(this, Wa);
    c(this, Ga, (e, t) => {
      s(this, Wa).notify("picture-in-picture-change", e, t);
    });
    u(this, un, e), u(this, Wa, t), new dt(e).add("enterpictureinpicture", a(this, sa, Mp).bind(this)).add("leavepictureinpicture", a(this, sa, Lp).bind(this));
  }
  get active() {
    return document.pictureInPictureElement === s(this, un);
  }
  get supported() {
    return qT(s(this, un));
  }
  async enter() {
    return s(this, un).requestPictureInPicture();
  }
  exit() {
    return document.exitPictureInPicture();
  }
}
un = new WeakMap(), Wa = new WeakMap(), sa = new WeakSet(), Mp = function(e) {
  s(this, Ga).call(this, !0, e);
}, Lp = function(e) {
  s(this, Ga).call(this, !1, e);
}, Ga = new WeakMap();
var dn, yr, Ze, Rh, Ip;
class zk {
  constructor(e, t) {
    c(this, Rh);
    c(this, dn);
    c(this, yr);
    c(this, Ze, "inline");
    u(this, dn, e), u(this, yr, t), ft(e, "webkitpresentationmodechanged", a(this, Rh, Ip).bind(this));
  }
  get mode() {
    return s(this, Ze);
  }
  get supported() {
    return OT(s(this, dn));
  }
  async setPresentationMode(e) {
    s(this, Ze) !== e && s(this, dn).webkitSetPresentationMode(e);
  }
}
dn = new WeakMap(), yr = new WeakMap(), Ze = new WeakMap(), Rh = new WeakSet(), Ip = function(e) {
  var i;
  const t = s(this, Ze);
  u(this, Ze, s(this, dn).webkitPresentationMode), (i = s(this, yr).player) == null || i.dispatch(
    new H("video-presentation-change", {
      detail: s(this, Ze),
      trigger: e
    })
  ), ["fullscreen", "picture-in-picture"].forEach((r) => {
    (s(this, Ze) === r || t === r) && s(this, yr).notify(`${r}-change`, s(this, Ze) === r, e);
  });
};
var ls;
class Yk {
  constructor(e) {
    c(this, ls);
    u(this, ls, e);
  }
  get active() {
    return s(this, ls).mode === "fullscreen";
  }
  get supported() {
    return s(this, ls).supported;
  }
  async enter() {
    s(this, ls).setPresentationMode("fullscreen");
  }
  async exit() {
    s(this, ls).setPresentationMode("inline");
  }
}
ls = new WeakMap();
var cs;
class Xk {
  constructor(e) {
    c(this, cs);
    u(this, cs, e);
  }
  get active() {
    return s(this, cs).mode === "picture-in-picture";
  }
  get supported() {
    return s(this, cs).supported;
  }
  async enter() {
    s(this, cs).setPresentationMode("picture-in-picture");
  }
  async exit() {
    s(this, cs).setPresentationMode("inline");
  }
}
cs = new WeakMap();
function hd(n) {
  try {
    return new Intl.DisplayNames(navigator.languages, { type: "language" }).of(n) ?? null;
  } catch {
    return null;
  }
}
const iv = (n) => `dash-${Xh(n)}`;
var us, at, _, br, wr, L, Ws, Rp, qp, Op, Mi, Tr, Dp, Vp, Np, Fp, _p, Hp, Up, Bp, ds, jp, Xo, Ql, Wp, zl, Gp, Kp, Yl;
class Jk {
  constructor(e, t) {
    c(this, L);
    c(this, us);
    c(this, at);
    c(this, _, null);
    c(this, br, /* @__PURE__ */ new Set());
    c(this, wr, null);
    y(this, "config", {});
    c(this, Mi, null);
    c(this, Tr, {});
    c(this, ds, -1);
    u(this, us, e), u(this, at, t);
  }
  get instance() {
    return s(this, _);
  }
  setup(e) {
    u(this, _, e().create());
    const t = a(this, L, Op).bind(this);
    for (const i of Object.values(e.events)) s(this, _).on(i, t);
    s(this, _).on(e.events.ERROR, a(this, L, Hp).bind(this));
    for (const i of s(this, br)) i(s(this, _));
    s(this, at).player.dispatch("dash-instance", {
      detail: s(this, _)
    }), s(this, _).initialize(s(this, us), void 0, !1), s(this, _).updateSettings({
      streaming: {
        text: {
          // Disabling text rendering by dash.
          defaultEnabled: !1,
          dispatchForManualRendering: !0
        },
        buffer: {
          /// Enables buffer replacement when switching bitrates for faster switching.
          fastSwitchEnabled: !0
        }
      },
      ...this.config
    }), s(this, _).on(e.events.FRAGMENT_LOADING_STARTED, a(this, L, Up).bind(this)), s(this, _).on(
      e.events.FRAGMENT_LOADING_COMPLETED,
      a(this, L, Bp).bind(this)
    ), s(this, _).on(e.events.MANIFEST_LOADED, a(this, L, _p).bind(this)), s(this, _).on(e.events.QUALITY_CHANGE_RENDERED, a(this, L, Fp).bind(this)), s(this, _).on(e.events.TEXT_TRACKS_ADDED, a(this, L, Vp).bind(this)), s(this, _).on(e.events.TRACK_CHANGE_RENDERED, a(this, L, Np).bind(this)), s(this, at).qualities[ie.enableAuto] = a(this, L, Wp).bind(this), ft(s(this, at).qualities, "change", a(this, L, Gp).bind(this)), ft(s(this, at).audioTracks, "change", a(this, L, Kp).bind(this)), u(this, wr, b(a(this, L, Rp).bind(this)));
  }
  onInstance(e) {
    return s(this, br).add(e), () => s(this, br).delete(e);
  }
  loadSource(e) {
    var t;
    a(this, L, Yl).call(this), R(e.src) && ((t = s(this, _)) == null || t.attachSource(e.src));
  }
  destroy() {
    var e, t;
    a(this, L, Yl).call(this), (e = s(this, _)) == null || e.destroy(), u(this, _, null), (t = s(this, wr)) == null || t.call(this), u(this, wr, null);
  }
}
us = new WeakMap(), at = new WeakMap(), _ = new WeakMap(), br = new WeakMap(), wr = new WeakMap(), L = new WeakSet(), Ws = function(e) {
  return new H(iv(e.type), { detail: e });
}, Rp = function() {
  if (!s(this, at).$state.live()) return;
  const e = new Nu(a(this, L, qp).bind(this));
  return e.start(), e.stop.bind(e);
}, qp = function() {
  if (!s(this, _)) return;
  const e = s(this, _).duration() - s(this, _).time();
  s(this, at).$state.liveSyncPosition.set(isNaN(e) ? 1 / 0 : e);
}, Op = function(e) {
  var t;
  (t = s(this, at).player) == null || t.dispatch(a(this, L, Ws).call(this, e));
}, Mi = new WeakMap(), Tr = new WeakMap(), Dp = function(e) {
  var l;
  const t = (l = s(this, Mi)) == null ? void 0 : l[q.native], i = (t == null ? void 0 : t.track).cues;
  if (!t || !i) return;
  const r = s(this, Mi).id, o = s(this, Tr)[r] ?? 0, h = a(this, L, Ws).call(this, e);
  for (let d = o; d < i.length; d++) {
    const f = i[d];
    f.positionAlign || (f.positionAlign = "auto"), s(this, Mi).addCue(f, h);
  }
  s(this, Tr)[r] = i.length;
}, Vp = function(e) {
  var o;
  if (!s(this, _)) return;
  const t = e.tracks, i = [...s(this, us).textTracks].filter((h) => "manualMode" in h), r = a(this, L, Ws).call(this, e);
  for (let h = 0; h < i.length; h++) {
    const l = t[h], d = i[h], f = `dash-${l.kind}-${h}`, p = new Ns({
      id: f,
      label: (l == null ? void 0 : l.label) ?? ((o = l.labels.find((m) => m.text)) == null ? void 0 : o.text) ?? ((l == null ? void 0 : l.lang) && hd(l.lang)) ?? (l == null ? void 0 : l.lang) ?? void 0,
      language: l.lang ?? void 0,
      kind: l.kind,
      default: l.defaultTrack
    });
    p[q.native] = {
      managed: !0,
      track: d
    }, p[q.readyState] = 2, p[q.onModeChange] = () => {
      s(this, _) && (p.mode === "showing" ? (s(this, _).setTextTrack(h), u(this, Mi, p)) : (s(this, _).setTextTrack(-1), u(this, Mi, null)));
    }, s(this, at).textTracks.add(p, r);
  }
}, Np = function(e) {
  const { mediaType: t, newMediaInfo: i } = e;
  if (t === "audio") {
    const r = s(this, at).audioTracks.getById(`dash-audio-${i.index}`);
    if (r) {
      const o = a(this, L, Ws).call(this, e);
      s(this, at).audioTracks[D.select](r, !0, o);
    }
  }
}, Fp = function(e) {
  if (e.mediaType !== "video") return;
  const t = s(this, at).qualities[e.newQuality];
  if (t) {
    const i = a(this, L, Ws).call(this, e);
    s(this, at).qualities[D.select](t, !0, i);
  }
}, _p = function(e) {
  if (s(this, at).$state.canPlay() || !s(this, _)) return;
  const { type: t, mediaPresentationDuration: i } = e.data, r = a(this, L, Ws).call(this, e);
  s(this, at).notify("stream-type-change", t !== "static" ? "live" : "on-demand", r), s(this, at).notify("duration-change", i, r), s(this, at).qualities[ie.setAuto](!0, r);
  const o = s(this, _).getVideoElement(), h = s(this, _).getTracksForTypeFromManifest(
    "video",
    e.data
  ), l = [...new Set(h.map((m) => m.mimeType))].find(
    (m) => m && nf(o, m)
  ), d = h.filter(
    (m) => l === m.mimeType
  )[0];
  let f = s(this, _).getTracksForTypeFromManifest(
    "audio",
    e.data
  );
  const p = [...new Set(f.map((m) => m.mimeType))].find(
    (m) => m && sf(o, m)
  );
  if (f = f.filter((m) => p === m.mimeType), d == null || d.bitrateList.forEach((m, w) => {
    var k;
    const P = {
      id: ((k = m.id) == null ? void 0 : k.toString()) ?? `dash-bitrate-${w}`,
      width: m.width ?? 0,
      height: m.height ?? 0,
      bitrate: m.bandwidth ?? 0,
      codec: d.codec,
      index: w
    };
    s(this, at).qualities[D.add](P, r);
  }), Te(d == null ? void 0 : d.index)) {
    const m = s(this, at).qualities[d.index];
    m && s(this, at).qualities[D.select](m, !0, r);
  }
  f.forEach((m, w) => {
    const k = m.labels.find((B) => navigator.languages.some((At) => B.lang && At.toLowerCase().startsWith(B.lang.toLowerCase()))) || m.labels[0], M = {
      id: `dash-audio-${m == null ? void 0 : m.index}`,
      label: (k == null ? void 0 : k.text) ?? (m.lang && hd(m.lang)) ?? m.lang ?? "",
      language: m.lang ?? "",
      kind: "main",
      mimeType: m.mimeType,
      codec: m.codec,
      index: w
    };
    s(this, at).audioTracks[D.add](M, r);
  }), o.dispatchEvent(new H("canplay", { trigger: r }));
}, Hp = function(e) {
  const { type: t, error: i } = e;
  switch (i.code) {
    case 27:
      a(this, L, jp).call(this, i);
      break;
    default:
      a(this, L, Ql).call(this, i);
      break;
  }
}, Up = function() {
  s(this, ds) >= 0 && a(this, L, Xo).call(this);
}, Bp = function(e) {
  e.mediaType === "text" && requestAnimationFrame(a(this, L, Dp).bind(this, e));
}, ds = new WeakMap(), jp = function(e) {
  var t;
  a(this, L, Xo).call(this), (t = s(this, _)) == null || t.play(), u(this, ds, window.setTimeout(() => {
    u(this, ds, -1), a(this, L, Ql).call(this, e);
  }, 5e3));
}, Xo = function() {
  clearTimeout(s(this, ds)), u(this, ds, -1);
}, Ql = function(e) {
  s(this, at).notify("error", {
    message: e.message ?? "",
    code: 1,
    error: e
  });
}, Wp = function() {
  var t;
  a(this, L, zl).call(this, "video", !0);
  const { qualities: e } = s(this, at);
  (t = s(this, _)) == null || t.setQualityFor("video", e.selectedIndex, !0);
}, zl = function(e, t) {
  var i;
  (i = s(this, _)) == null || i.updateSettings({
    streaming: { abr: { autoSwitchBitrate: { [e]: t } } }
  });
}, Gp = function() {
  const { qualities: e } = s(this, at);
  !s(this, _) || e.auto || !e.selected || (a(this, L, zl).call(this, "video", !1), s(this, _).setQualityFor("video", e.selectedIndex, e.switch === "current"), tl && (s(this, us).currentTime = s(this, us).currentTime));
}, Kp = function() {
  if (!s(this, _)) return;
  const { audioTracks: e } = s(this, at), t = s(this, _).getTracksFor("audio").find(
    (i) => e.selected && e.selected.id === `dash-audio-${i.index}`
  );
  t && s(this, _).setCurrentTrack(t);
}, Yl = function() {
  a(this, L, Xo).call(this), u(this, Mi, null), u(this, Tr, {});
};
function ka(n) {
  return n instanceof Error ? n : Error(typeof n == "string" ? n : JSON.stringify(n));
}
function Ti(n, e) {
  if (!n)
    throw Error("Assertion failed.");
}
var fn, ti, Ka, di, Qp, zp, Yp, Xp;
class Zk {
  constructor(e, t, i) {
    c(this, di);
    c(this, fn);
    c(this, ti);
    c(this, Ka);
    u(this, fn, e), u(this, ti, t), u(this, Ka, i), a(this, di, Qp).call(this);
  }
}
fn = new WeakMap(), ti = new WeakMap(), Ka = new WeakMap(), di = new WeakSet(), Qp = async function() {
  const e = {
    onLoadStart: a(this, di, zp).bind(this),
    onLoaded: a(this, di, Yp).bind(this),
    onLoadError: a(this, di, Xp).bind(this)
  };
  let t = await nv(s(this, fn), e);
  if (Et(t) && !R(s(this, fn)) && (t = await sv(s(this, fn), e)), !t) return null;
  if (!window.dashjs.supportsMediaSource()) {
    const i = "[vidstack] `dash.js` is not supported in this environment";
    return s(this, ti).player.dispatch(new H("dash-unsupported")), s(this, ti).notify("error", { message: i, code: 4 }), null;
  }
  return t;
}, zp = function() {
  s(this, ti).player.dispatch(new H("dash-lib-load-start"));
}, Yp = function(e) {
  s(this, ti).player.dispatch(
    new H("dash-lib-loaded", {
      detail: e
    })
  ), s(this, Ka).call(this, e);
}, Xp = function(e) {
  const t = ka(e);
  s(this, ti).player.dispatch(
    new H("dash-lib-load-error", {
      detail: t
    })
  ), s(this, ti).notify("error", {
    message: t.message,
    code: 4,
    error: t
  });
};
async function sv(n, e = {}) {
  var t, i, r, o, h, l, d;
  if (!Et(n)) {
    if ((t = e.onLoadStart) == null || t.call(e), rv(n))
      return (i = e.onLoaded) == null || i.call(e, n), n;
    if (ld(n)) {
      const f = n.MediaPlayer;
      return (r = e.onLoaded) == null || r.call(e, f), f;
    }
    try {
      const f = (o = await n()) == null ? void 0 : o.default;
      if (ld(f))
        return (h = e.onLoaded) == null || h.call(e, f.MediaPlayer), f.MediaPlayer;
      if (f)
        (l = e.onLoaded) == null || l.call(e, f);
      else
        throw Error(
          ""
        );
      return f;
    } catch (f) {
      (d = e.onLoadError) == null || d.call(e, f);
    }
  }
}
async function nv(n, e = {}) {
  var t, i, r;
  if (R(n)) {
    (t = e.onLoadStart) == null || t.call(e);
    try {
      if (await Iu(n), !$e(window.dashjs.MediaPlayer))
        throw Error(
          ""
        );
      const o = window.dashjs.MediaPlayer;
      return (i = e.onLoaded) == null || i.call(e, o), o;
    } catch (o) {
      (r = e.onLoadError) == null || r.call(e, o);
    }
  }
}
function rv(n) {
  return n && n.prototype && n.prototype !== Function;
}
function ld(n) {
  return n && "MediaPlayer" in n;
}
const qh = class qh extends Du {
  constructor() {
    super(...arguments);
    y(this, "name", "dash");
  }
  canPlay(t) {
    return qh.supported && Lu(t);
  }
  async load(t) {
    return new (await import("./vidstack-dash-tR8ufawh.js")).DASHProvider(this.target, t);
  }
};
y(qh, "supported", FT());
let Xl = qh;
class av {
  constructor() {
    y(this, "name", "vimeo");
    y(this, "target");
  }
  preconnect() {
    const e = [
      "https://i.vimeocdn.com",
      "https://f.vimeocdn.com",
      "https://fresnel.vimeocdn.com"
    ];
    for (const t of e)
      el(t);
  }
  canPlay(e) {
    return R(e.src) && e.type === "video/vimeo";
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    return new (await import("./vidstack-vimeo-DzDdm0bI.js").then((t) => t.p)).VimeoProvider(this.target, e);
  }
  async loadPoster(e, t, i) {
    const { resolveVimeoVideoId: r, getVimeoVideoInfo: o } = await import("./vidstack-vimeo-DzDdm0bI.js").then((d) => d.u);
    if (!R(e.src)) return null;
    const { videoId: h, hash: l } = r(e.src);
    return h ? o(h, i, l).then((d) => d ? d.poster : null) : null;
  }
}
class ov {
  constructor() {
    y(this, "name", "youtube");
    y(this, "target");
  }
  preconnect() {
    const e = [
      // Botguard script.
      "https://www.google.com",
      // Posters.
      "https://i.ytimg.com",
      // Ads.
      "https://googleads.g.doubleclick.net",
      "https://static.doubleclick.net"
    ];
    for (const t of e)
      el(t);
  }
  canPlay(e) {
    return R(e.src) && e.type === "video/youtube";
  }
  mediaType() {
    return "video";
  }
  async load(e) {
    return new (await import("./vidstack-youtube-CpDJCw0z.js").then((t) => t.p)).YouTubeProvider(this.target, e);
  }
  async loadPoster(e, t, i) {
    const { findYouTubePoster: r, resolveYouTubeVideoId: o } = await import("./vidstack-youtube-CpDJCw0z.js").then((l) => l.u), h = R(e.src) && o(e.src);
    return h ? r(h, i) : null;
  }
}
function ml(n, e) {
  const t = String(n), i = t.length;
  if (i < e) {
    const o = e - i;
    return `${"0".repeat(o)}${n}`;
  }
  return t;
}
function Jp(n) {
  const e = Math.trunc(n / 3600), t = Math.trunc(n % 3600 / 60), i = Math.trunc(n % 60), r = Number((n - Math.trunc(n)).toPrecision(3));
  return {
    hours: e,
    minutes: t,
    seconds: i,
    fraction: r
  };
}
function Fu(n, { padHrs: e = null, padMins: t = null, showHrs: i = !1, showMs: r = !1 } = {}) {
  const { hours: o, minutes: h, seconds: l, fraction: d } = Jp(n), f = e ? ml(o, 2) : o, p = t || Ki(t) && n >= 3600 ? ml(h, 2) : h, m = ml(l, 2), w = r && d > 0 ? `.${String(d).replace(/^0?\./, "")}` : "", P = `${p}:${m}${w}`;
  return o > 0 || i ? `${f}:${P}` : P;
}
function cd(n) {
  const e = [], { hours: t, minutes: i, seconds: r } = Jp(n);
  return t > 0 && e.push(`${t} hour`), i > 0 && e.push(`${i} min`), (r > 0 || e.length === 0) && e.push(`${r} sec`), e.join(" ");
}
const gl = Symbol(0), hv = [
  "autoPlay",
  "canAirPlay",
  "canFullscreen",
  "canGoogleCast",
  "canLoad",
  "canLoadPoster",
  "canPictureInPicture",
  "canPlay",
  "canSeek",
  "ended",
  "fullscreen",
  "isAirPlayConnected",
  "isGoogleCastConnected",
  "live",
  "liveEdge",
  "loop",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsInline",
  "remotePlaybackState",
  "remotePlaybackType",
  "seeking",
  "started",
  "streamType",
  "viewType",
  "waiting"
], lv = {
  artist: "",
  artwork: null,
  autoplay: !1,
  autoPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  currentTime: 0,
  crossorigin: null,
  crossOrigin: null,
  duration: -1,
  fullscreenOrientation: "landscape",
  googleCast: {},
  load: "visible",
  posterLoad: "visible",
  logLevel: "silent",
  loop: !1,
  muted: !1,
  paused: !0,
  playsinline: !1,
  playsInline: !1,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: !1,
  src: "",
  title: "",
  controlsDelay: 2e3,
  hideControlsOnMouseLeave: !1,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: !1,
  keyTarget: "player",
  keyShortcuts: V$,
  storage: null
};
var Qa, pn;
class ud extends _n {
  constructor(t, i) {
    super();
    c(this, Qa);
    c(this, pn);
    u(this, Qa, t), u(this, pn, i);
  }
  async onAttach(t) {
    const i = this.$props[s(this, Qa)]();
    if (i === "eager")
      requestAnimationFrame(s(this, pn));
    else if (i === "idle")
      PT(s(this, pn));
    else if (i === "visible") {
      let r, o = new IntersectionObserver((h) => {
        this.scope && h[0].isIntersecting && (r == null || r(), r = void 0, s(this, pn).call(this));
      });
      o.observe(t), r = it(() => o.disconnect());
    }
  }
}
Qa = new WeakMap(), pn = new WeakMap();
var za, Fe, Oh, Zp;
class cv {
  constructor(e, t) {
    c(this, Oh);
    c(this, za);
    c(this, Fe);
    u(this, za, e), u(this, Fe, t);
  }
  notify(e, ...t) {
    s(this, za).call(this, new H(e, {
      detail: t == null ? void 0 : t[0],
      trigger: t == null ? void 0 : t[1]
    }));
  }
  async ready(e, t) {
    return Zr(async () => {
      var bi, Xi, Qt, qt, Ji, wt, et;
      s(this, Fe);
      const {
        autoPlay: i,
        canPlay: r,
        started: o,
        duration: h,
        seekable: l,
        buffered: d,
        remotePlaybackInfo: f,
        playsInline: p,
        savedState: m,
        source: w
      } = s(this, Fe).$state;
      if (r()) return;
      const P = {
        duration: (e == null ? void 0 : e.duration) ?? h(),
        seekable: (e == null ? void 0 : e.seekable) ?? l(),
        buffered: (e == null ? void 0 : e.buffered) ?? d(),
        provider: s(this, Fe).$provider()
      };
      this.notify("can-play", P, t), Gi();
      let k = s(this, Fe).$provider(), { storage: M, qualities: B } = s(this, Fe), { muted: At, volume: Ut, clipStartTime: Xt, playbackRate: se } = s(this, Fe).$props;
      await ((bi = M == null ? void 0 : M.onLoad) == null ? void 0 : bi.call(M, w()));
      const Oe = (Xi = m()) == null ? void 0 : Xi.currentTime, De = (Qt = m()) == null ? void 0 : Qt.paused, de = await (M == null ? void 0 : M.getTime()), E = Oe ?? de ?? Xt(), bt = De === !1 || De !== !0 && !o() && i();
      if (k) {
        k.setVolume(await (M == null ? void 0 : M.getVolume()) ?? Ut()), k.setMuted(At() || !!await (M == null ? void 0 : M.getMuted()));
        const Ve = await (M == null ? void 0 : M.getAudioGain()) ?? 1;
        Ve > 1 && ((Ji = (qt = k.audioGain) == null ? void 0 : qt.setGain) == null || Ji.call(qt, Ve)), (wt = k.setPlaybackRate) == null || wt.call(k, await (M == null ? void 0 : M.getPlaybackRate()) ?? se()), (et = k.setPlaysInline) == null || et.call(k, p()), E > 0 && k.setCurrentTime(E);
      }
      const It = await (M == null ? void 0 : M.getVideoQuality());
      if (It && B.length) {
        let Ve = null, Bs = 1 / 0;
        for (const wi of B) {
          const Bn = Math.abs(It.width - wi.width) + Math.abs(It.height - wi.height) + (It.bitrate ? Math.abs(It.bitrate - (wi.bitrate ?? 0)) : 0);
          Bn < Bs && (Ve = wi, Bs = Bn);
        }
        Ve && (Ve.selected = !0);
      }
      r() && bt ? await a(this, Oh, Zp).call(this, t) : de && de > 0 && this.notify("started", void 0, t), f.set(null);
    });
  }
}
za = new WeakMap(), Fe = new WeakMap(), Oh = new WeakSet(), Zp = async function(e) {
  const {
    player: t,
    $state: { autoPlaying: i, muted: r }
  } = s(this, Fe);
  i.set(!0);
  const o = new H("auto-play-attempt", { trigger: e });
  try {
    await t.play(o);
  } catch {
  }
};
var fs;
class uv {
  constructor() {
    c(this, fs, /* @__PURE__ */ new Map());
  }
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  enqueue(e, t) {
    s(this, fs).set(e, t);
  }
  /**
   * Process item in queue for the given `key`.
   */
  serve(e) {
    const t = this.peek(e);
    return s(this, fs).delete(e), t;
  }
  /**
   * Peek at item in queue for the given `key`.
   */
  peek(e) {
    return s(this, fs).get(e);
  }
  /**
   * Removes queued item under the given `key`.
   */
  delete(e) {
    s(this, fs).delete(e);
  }
  /**
   * Clear all items in the queue.
   */
  clear() {
    s(this, fs).clear();
  }
}
fs = new WeakMap();
var ps, $r, _e, Hs, Jl, Zl;
class tm {
  constructor() {
    c(this, Hs);
    c(this, ps, !1);
    c(this, $r, Sl());
    c(this, _e, /* @__PURE__ */ new Map());
  }
  /**
   * The number of callbacks that are currently in queue.
   */
  get size() {
    return s(this, _e).size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get isServing() {
    return s(this, ps);
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async waitForFlush() {
    s(this, ps) || await s(this, $r).promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  enqueue(e, t) {
    if (s(this, ps)) {
      t();
      return;
    }
    s(this, _e).delete(e), s(this, _e).set(e, t);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  serve(e) {
    var t;
    (t = s(this, _e).get(e)) == null || t(), s(this, _e).delete(e);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  start() {
    a(this, Hs, Jl).call(this), u(this, ps, !0), s(this, _e).size > 0 && a(this, Hs, Jl).call(this);
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  stop() {
    u(this, ps, !1);
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  reset() {
    this.stop(), s(this, _e).clear(), a(this, Hs, Zl).call(this);
  }
}
ps = new WeakMap(), $r = new WeakMap(), _e = new WeakMap(), Hs = new WeakSet(), Jl = function() {
  for (const e of s(this, _e).keys()) this.serve(e);
  a(this, Hs, Zl).call(this);
}, Zl = function() {
  s(this, $r).resolve(), u(this, $r, Sl());
};
function dv(n) {
  return n ? "true" : "false";
}
function Hn(n) {
  return () => dv(n());
}
function fv() {
  return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
var Li, O, Ii, mn, Ri, pt, ms, U, em, im, sm, tc, vr, ec, ic, nm, rm, am, om, hm, lm, gn, cm, sc, nc, mv;
class pv extends _n {
  constructor(t, i, r) {
    super();
    c(this, U);
    c(this, Li);
    c(this, O);
    c(this, Ii);
    y(this, "controls");
    c(this, mn);
    c(this, Ri);
    c(this, pt);
    c(this, ms, new tm());
    c(this, vr, !1);
    c(this, gn);
    u(this, Li, t), u(this, O, i), u(this, Ii, r), u(this, pt, r.$provider), this.controls = new j$(), u(this, mn, new W$()), u(this, Ri, new vh());
  }
  onAttach() {
    this.listen("fullscreen-change", a(this, U, cm).bind(this));
  }
  onConnect(t) {
    const i = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), r = new dt(t), o = a(this, U, sm).bind(this);
    for (const h of i)
      h.startsWith("media-") && r.add(h, o);
    a(this, U, em).call(this), b(a(this, U, im).bind(this)), b(a(this, U, nm).bind(this)), b(a(this, U, rm).bind(this)), b(a(this, U, am).bind(this)), b(a(this, U, om).bind(this)), b(a(this, U, hm).bind(this)), b(a(this, U, lm).bind(this));
  }
  onDestroy() {
    try {
      const t = this.createEvent("destroy"), { pictureInPicture: i, fullscreen: r } = this.$state;
      r() && this.exitFullscreen("prefer-media", t), i() && this.exitPictureInPicture(t);
    } catch {
    }
    s(this, ms).reset();
  }
  async play(t) {
    const { canPlay: i, paused: r, autoPlaying: o } = this.$state;
    if (a(this, U, tc).call(this, t) || !v(r)) return;
    t && s(this, O).queue.enqueue("media-play-request", t);
    const h = v(o);
    try {
      const l = v(s(this, pt));
      return yl(l, v(i)), gv(h), await l.play();
    } catch (l) {
      const d = this.createEvent("play-fail", {
        detail: ka(l),
        trigger: t
      });
      throw d.autoPlay = h, s(this, Li).handle(d), l;
    }
  }
  async pause(t) {
    const { canPlay: i, paused: r } = this.$state;
    if (!v(r)) {
      t && s(this, O).queue.enqueue("media-pause-request", t);
      try {
        const o = v(s(this, pt));
        return yl(o, v(i)), await o.pause();
      } catch (o) {
        throw s(this, O).queue.delete("media-pause-request"), o;
      }
    }
  }
  setAudioGain(t, i) {
    const { audioGain: r, canSetAudioGain: o } = this.$state;
    if (r() === t) return;
    const h = s(this, pt).call(this);
    if (!(h != null && h.audioGain) || !o())
      throw Error("[vidstack] audio gain api not available");
    i && s(this, O).queue.enqueue("media-audio-gain-change-request", i), h.audioGain.setGain(t);
  }
  seekToLiveEdge(t) {
    const { canPlay: i, live: r, liveEdge: o, canSeek: h, liveSyncPosition: l, seekableEnd: d, userBehindLiveEdge: f } = this.$state;
    if (f.set(!1), v(() => !r() || o() || !h())) return;
    const p = v(s(this, pt));
    yl(p, v(i)), t && s(this, O).queue.enqueue("media-seek-request", t);
    const m = d() - 2;
    p.setCurrentTime(Math.min(m, l() ?? m));
  }
  async enterFullscreen(t = "prefer-media", i) {
    const r = a(this, U, ec).call(this, t);
    if (dd(t, r), !r.active)
      return v(this.$state.pictureInPicture) && (u(this, vr, !0), await this.exitPictureInPicture(i)), i && s(this, O).queue.enqueue("media-enter-fullscreen-request", i), r.enter();
  }
  async exitFullscreen(t = "prefer-media", i) {
    const r = a(this, U, ec).call(this, t);
    if (dd(t, r), !!r.active) {
      i && s(this, O).queue.enqueue("media-exit-fullscreen-request", i);
      try {
        const o = await r.exit();
        return s(this, vr) && v(this.$state.canPictureInPicture) && await this.enterPictureInPicture(), o;
      } finally {
        u(this, vr, !1);
      }
    }
  }
  async enterPictureInPicture(t) {
    if (a(this, U, ic).call(this), !this.$state.pictureInPicture())
      return t && s(this, O).queue.enqueue("media-enter-pip-request", t), await s(this, pt).call(this).pictureInPicture.enter();
  }
  async exitPictureInPicture(t) {
    if (a(this, U, ic).call(this), !!this.$state.pictureInPicture())
      return t && s(this, O).queue.enqueue("media-exit-pip-request", t), await s(this, pt).call(this).pictureInPicture.exit();
  }
  async "media-airplay-request"(t) {
    try {
      await this.requestAirPlay(t);
    } catch {
    }
  }
  async requestAirPlay(t) {
    var i;
    try {
      const r = (i = s(this, pt).call(this)) == null ? void 0 : i.airPlay;
      if (!(r != null && r.supported))
        throw Error("No AirPlay adapter.");
      return t && s(this, O).queue.enqueue("media-airplay-request", t), await r.prompt();
    } catch (r) {
      throw s(this, O).queue.delete("media-airplay-request"), r;
    }
  }
  async "media-google-cast-request"(t) {
    try {
      await this.requestGoogleCast(t);
    } catch {
    }
  }
  async requestGoogleCast(t) {
    try {
      const { canGoogleCast: i } = this.$state;
      if (!v(i)) {
        const o = Error(
          "Cast not available."
        );
        throw o.code = "CAST_NOT_AVAILABLE", o;
      }
      if (el("https://www.gstatic.com"), !s(this, gn)) {
        const o = await Promise.resolve().then(() => Lk);
        u(this, gn, new o.GoogleCastLoader());
      }
      await s(this, gn).prompt(s(this, Ii)), t && s(this, O).queue.enqueue("media-google-cast-request", t);
      const r = v(this.$state.remotePlaybackState) !== "disconnected";
      r && this.$state.savedState.set({
        paused: v(this.$state.paused),
        currentTime: v(this.$state.currentTime)
      }), this.$state.remotePlaybackLoader.set(r ? s(this, gn) : null);
    } catch (i) {
      throw s(this, O).queue.delete("media-google-cast-request"), i;
    }
  }
  "media-clip-start-change-request"(t) {
    const { clipStartTime: i } = this.$state;
    i.set(t.detail);
  }
  "media-clip-end-change-request"(t) {
    const { clipEndTime: i } = this.$state;
    i.set(t.detail), this.dispatch("duration-change", {
      detail: t.detail,
      trigger: t
    });
  }
  "media-duration-change-request"(t) {
    const { providedDuration: i, clipEndTime: r } = this.$state;
    i.set(t.detail), r() <= 0 && this.dispatch("duration-change", {
      detail: t.detail,
      trigger: t
    });
  }
  "media-audio-track-change-request"(t) {
    const { logger: i, audioTracks: r } = s(this, Ii);
    if (r.readonly)
      return;
    const o = t.detail, h = r[o];
    if (h) {
      const l = t.type;
      s(this, O).queue.enqueue(l, t), h.selected = !0;
    }
  }
  async "media-enter-fullscreen-request"(t) {
    try {
      await this.enterFullscreen(t.detail, t);
    } catch (i) {
      a(this, U, sc).call(this, i, t);
    }
  }
  async "media-exit-fullscreen-request"(t) {
    try {
      await this.exitFullscreen(t.detail, t);
    } catch (i) {
      a(this, U, sc).call(this, i, t);
    }
  }
  async "media-orientation-lock-request"(t) {
    const i = t.type;
    try {
      s(this, O).queue.enqueue(i, t), await s(this, Ri).lock(t.detail);
    } catch {
      s(this, O).queue.delete(i);
    }
  }
  async "media-orientation-unlock-request"(t) {
    const i = t.type;
    try {
      s(this, O).queue.enqueue(i, t), await s(this, Ri).unlock();
    } catch {
      s(this, O).queue.delete(i);
    }
  }
  async "media-enter-pip-request"(t) {
    try {
      await this.enterPictureInPicture(t);
    } catch (i) {
      a(this, U, nc).call(this, i, t);
    }
  }
  async "media-exit-pip-request"(t) {
    try {
      await this.exitPictureInPicture(t);
    } catch (i) {
      a(this, U, nc).call(this, i, t);
    }
  }
  "media-live-edge-request"(t) {
    const { live: i, liveEdge: r, canSeek: o } = this.$state;
    if (!(!i() || r() || !o())) {
      s(this, O).queue.enqueue("media-seek-request", t);
      try {
        this.seekToLiveEdge();
      } catch {
        s(this, O).queue.delete("media-seek-request");
      }
    }
  }
  async "media-loop-request"(t) {
    try {
      s(this, O).looping = !0, s(this, O).replaying = !0, await this.play(t);
    } catch {
      s(this, O).looping = !1;
    }
  }
  "media-user-loop-change-request"(t) {
    this.$state.userPrefersLoop.set(t.detail);
  }
  async "media-pause-request"(t) {
    if (!this.$state.paused())
      try {
        await this.pause(t);
      } catch {
      }
  }
  async "media-play-request"(t) {
    if (this.$state.paused())
      try {
        await this.play(t);
      } catch {
      }
  }
  "media-rate-change-request"(t) {
    const { playbackRate: i, canSetPlaybackRate: r } = this.$state;
    if (i() === t.detail || !r()) return;
    const o = s(this, pt).call(this);
    o != null && o.setPlaybackRate && (s(this, O).queue.enqueue("media-rate-change-request", t), o.setPlaybackRate(t.detail));
  }
  "media-audio-gain-change-request"(t) {
    try {
      this.setAudioGain(t.detail, t);
    } catch {
    }
  }
  "media-quality-change-request"(t) {
    var l, d;
    const { qualities: i, storage: r, logger: o } = s(this, Ii);
    if (i.readonly)
      return;
    s(this, O).queue.enqueue("media-quality-change-request", t);
    const h = t.detail;
    if (h < 0)
      i.autoSelect(t), t.isOriginTrusted && ((l = r == null ? void 0 : r.setVideoQuality) == null || l.call(r, null));
    else {
      const f = i[h];
      f && (f.selected = !0, t.isOriginTrusted && ((d = r == null ? void 0 : r.setVideoQuality) == null || d.call(r, {
        id: f.id,
        width: f.width,
        height: f.height,
        bitrate: f.bitrate
      })));
    }
  }
  "media-pause-controls-request"(t) {
    const i = t.type;
    s(this, O).queue.enqueue(i, t), this.controls.pause(t);
  }
  "media-resume-controls-request"(t) {
    const i = t.type;
    s(this, O).queue.enqueue(i, t), this.controls.resume(t);
  }
  "media-seek-request"(t) {
    const { canSeek: i, ended: r, live: o, seekableEnd: h, userBehindLiveEdge: l } = this.$state, d = t.detail;
    r() && (s(this, O).replaying = !0);
    const f = t.type;
    s(this, O).seeking = !1, s(this, O).queue.delete(f);
    const p = uf(d, this.$state);
    !Number.isFinite(p) || !i() || (s(this, O).queue.enqueue(f, t), s(this, pt).call(this).setCurrentTime(p), o() && t.isOriginTrusted && Math.abs(h() - p) >= 2 && l.set(!0));
  }
  "media-seeking-request"(t) {
    const i = t.type;
    s(this, O).queue.enqueue(i, t), this.$state.seeking.set(!0), s(this, O).seeking = !0;
  }
  "media-start-loading"(t) {
    if (this.$state.canLoad()) return;
    const i = t.type;
    s(this, O).queue.enqueue(i, t), s(this, Li).handle(this.createEvent("can-load"));
  }
  "media-poster-start-loading"(t) {
    if (this.$state.canLoadPoster()) return;
    const i = t.type;
    s(this, O).queue.enqueue(i, t), s(this, Li).handle(this.createEvent("can-load-poster"));
  }
  "media-text-track-change-request"(t) {
    const { index: i, mode: r } = t.detail, o = s(this, Ii).textTracks[i];
    if (o) {
      const h = t.type;
      s(this, O).queue.enqueue(h, t), o.setMode(r, t);
    }
  }
  "media-mute-request"(t) {
    if (this.$state.muted()) return;
    const i = t.type;
    s(this, O).queue.enqueue(i, t), s(this, pt).call(this).setMuted(!0);
  }
  "media-unmute-request"(t) {
    const { muted: i, volume: r } = this.$state;
    if (!i()) return;
    const o = t.type;
    s(this, O).queue.enqueue(o, t), s(this, Ii).$provider().setMuted(!1), r() === 0 && (s(this, O).queue.enqueue(o, t), s(this, pt).call(this).setVolume(0.25));
  }
  "media-volume-change-request"(t) {
    const { muted: i, volume: r } = this.$state, o = t.detail;
    if (r() === o) return;
    const h = t.type;
    s(this, O).queue.enqueue(h, t), s(this, pt).call(this).setVolume(o), o > 0 && i() && (s(this, O).queue.enqueue(h, t), s(this, pt).call(this).setMuted(!1));
  }
}
Li = new WeakMap(), O = new WeakMap(), Ii = new WeakMap(), mn = new WeakMap(), Ri = new WeakMap(), pt = new WeakMap(), ms = new WeakMap(), U = new WeakSet(), em = function() {
  const { load: t } = this.$props, { canLoad: i } = this.$state;
  if (t() !== "play" || i()) return;
  const r = this.listen("media-play-request", (o) => {
    a(this, U, tc).call(this, o), r();
  });
}, im = function() {
  const t = s(this, pt).call(this), i = this.$state.canPlay();
  return t && i && s(this, ms).start(), () => {
    s(this, ms).stop();
  };
}, sm = function(t) {
  t.stopPropagation(), !t.defaultPrevented && this[t.type] && (v(s(this, pt)) ? this[t.type](t) : s(this, ms).enqueue(t.type, () => {
    v(s(this, pt)) && this[t.type](t);
  }));
}, tc = function(t) {
  const { load: i } = this.$props, { canLoad: r } = this.$state;
  if (i() === "play" && !r()) {
    const o = this.createEvent("media-start-loading", { trigger: t });
    return this.dispatchEvent(o), s(this, ms).enqueue("media-play-request", async () => {
      try {
        await this.play(o);
      } catch {
      }
    }), !0;
  }
  return !1;
}, vr = new WeakMap(), ec = function(t) {
  const i = v(s(this, pt));
  return t === "prefer-media" && s(this, mn).supported || t === "media" ? s(this, mn) : i == null ? void 0 : i.fullscreen;
}, ic = function() {
  if (!this.$state.canPictureInPicture())
    throw Error(
      "[vidstack] no pip support"
    );
}, nm = function() {
  this.controls.defaultDelay = this.$props.controlsDelay();
}, rm = function() {
  var r, o;
  const { canSetAudioGain: t } = this.$state, i = !!((o = (r = s(this, pt).call(this)) == null ? void 0 : r.audioGain) != null && o.supported);
  t.set(i);
}, am = function() {
  var r, o;
  const { canAirPlay: t } = this.$state, i = !!((o = (r = s(this, pt).call(this)) == null ? void 0 : r.airPlay) != null && o.supported);
  t.set(i);
}, om = function() {
  const { canGoogleCast: t, source: i } = this.$state, r = tl && !Zh && of(i());
  t.set(r);
}, hm = function() {
  var r, o;
  const { canFullscreen: t } = this.$state, i = s(this, mn).supported || !!((o = (r = s(this, pt).call(this)) == null ? void 0 : r.fullscreen) != null && o.supported);
  t.set(i);
}, lm = function() {
  var r, o;
  const { canPictureInPicture: t } = this.$state, i = !!((o = (r = s(this, pt).call(this)) == null ? void 0 : r.pictureInPicture) != null && o.supported);
  t.set(i);
}, gn = new WeakMap(), cm = async function(t) {
  const i = v(this.$props.fullscreenOrientation), r = t.detail;
  if (!(Et(i) || i === "none" || !s(this, Ri).supported))
    if (r) {
      if (s(this, Ri).locked) return;
      this.dispatch("media-orientation-lock-request", {
        detail: i,
        trigger: t
      });
    } else s(this, Ri).locked && this.dispatch("media-orientation-unlock-request", {
      trigger: t
    });
}, sc = function(t, i) {
  s(this, Li).handle(
    this.createEvent("fullscreen-error", {
      detail: ka(t)
    })
  );
}, nc = function(t, i) {
  s(this, Li).handle(
    this.createEvent("picture-in-picture-error", {
      detail: ka(t)
    })
  );
}, mv = function(t, i, r) {
};
function yl(n, e) {
  if (!(n && e))
    throw Error(
      "[vidstack] media not ready"
    );
}
function dd(n, e) {
  if (!(e != null && e.supported))
    throw Error(
      "[vidstack] no fullscreen support"
    );
}
function gv(n) {
  if (!(!fv() || !n))
    throw Error(
      "[vidstack] autoplay blocked"
    );
}
class yv {
  constructor() {
    y(this, "seeking", !1);
    y(this, "looping", !1);
    y(this, "replaying", !1);
    y(this, "queue", new uv());
  }
}
const bv = /* @__PURE__ */ new Set([
  "auto-play",
  "auto-play-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);
var Jt, Y, ot, yn, Sr, bn, wn, qi, gs, T, um, dm, es, $t, fm, pm, mm, Jo, rc, ac, gm, oc, ym, bm, kr, hc, Zo, wm, Tm, $m, lc, cc, uc, vm, dc, Sm, Pr, km, fc;
class wv extends _n {
  constructor(t, i) {
    super();
    c(this, T);
    c(this, Jt);
    c(this, Y);
    c(this, ot, /* @__PURE__ */ new Map());
    c(this, yn, !1);
    c(this, Sr, []);
    c(this, bn, [-1, -1]);
    c(this, wn, !1);
    c(this, qi);
    c(this, gs, !1);
    c(this, kr, null);
    y(this, "seeking", xo(
      (t) => {
        const { seeking: i, realCurrentTime: r, paused: o } = this.$state;
        i.set(!0), r.set(t.detail), a(this, T, $t).call(this, "media-seeking-request", t), o() && (u(this, qi, t), s(this, Pr).call(this)), u(this, bn, [-1, -1]);
      },
      150,
      { leading: !0 }
    ));
    c(this, Pr, Ou(() => {
      if (!s(this, qi)) return;
      u(this, wn, !0);
      const { waiting: t, playing: i } = this.$state;
      t.set(!0), i.set(!1);
      const r = this.createEvent("waiting", { trigger: s(this, qi) });
      s(this, ot).set("waiting", r), this.dispatch(r), u(this, qi, void 0), u(this, wn, !1);
    }, 300));
    u(this, Jt, t), u(this, Y, i);
  }
  onAttach(t) {
    t.setAttribute("aria-busy", "true"), new dt(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
  }
  onConnect(t) {
    b(a(this, T, Tm).bind(this)), a(this, T, fm).call(this), a(this, T, pm).call(this), a(this, T, mm).call(this), a(this, T, um).call(this), it(a(this, T, dm).bind(this));
  }
  onDestroy() {
    const { audioTracks: t, qualities: i, textTracks: r } = s(this, Y);
    t[D.reset](), i[D.reset](), r[D.reset](), a(this, T, Zo).call(this);
  }
  handle(t) {
    if (!this.scope) return;
    const i = t.type;
    Zr(() => {
      var r;
      return (r = this[t.type]) == null ? void 0 : r.call(this, t);
    }), bv.has(i) && s(this, ot).set(i, t), this.dispatch(t);
  }
  "provider-change"(t) {
    var o, h;
    const i = s(this, Y).$provider(), r = t.detail;
    (i == null ? void 0 : i.type) !== (r == null ? void 0 : r.type) && ((o = i == null ? void 0 : i.destroy) == null || o.call(i), (h = i == null ? void 0 : i.scope) == null || h.dispose(), s(this, Y).$provider.set(t.detail), i && t.detail === null && a(this, T, lc).call(this, t));
  }
  "provider-loader-change"(t) {
  }
  "auto-play"(t) {
    this.$state.autoPlayError.set(null);
  }
  "auto-play-fail"(t) {
    this.$state.autoPlayError.set(t.detail), a(this, T, es).call(this);
  }
  "can-load"(t) {
    this.$state.canLoad.set(!0), s(this, ot).set("can-load", t), s(this, Y).textTracks[q.canLoad](), a(this, T, $t).call(this, "media-start-loading", t);
  }
  "can-load-poster"(t) {
    this.$state.canLoadPoster.set(!0), s(this, ot).set("can-load-poster", t), a(this, T, $t).call(this, "media-poster-start-loading", t);
  }
  "media-type-change"(t) {
    const i = s(this, ot).get("source-change");
    i && t.triggers.add(i);
    const r = this.$state.viewType();
    this.$state.mediaType.set(t.detail);
    const o = this.$state.providedViewType(), h = o === "unknown" ? t.detail : o;
    r !== h && setTimeout(() => {
      requestAnimationFrame(() => {
        this.scope && (this.$state.inferredViewType.set(t.detail), this.dispatch("view-type-change", {
          detail: h,
          trigger: t
        }));
      });
    }, 0);
  }
  "stream-type-change"(t) {
    const i = s(this, ot).get("source-change");
    i && t.triggers.add(i);
    const { streamType: r, inferredStreamType: o } = this.$state;
    o.set(t.detail), t.detail = r();
  }
  "rate-change"(t) {
    var o;
    const { storage: i } = s(this, Y), { canPlay: r } = this.$state;
    this.$state.playbackRate.set(t.detail), a(this, T, $t).call(this, "media-rate-change-request", t), r() && ((o = i == null ? void 0 : i.setPlaybackRate) == null || o.call(i, t.detail));
  }
  "remote-playback-change"(t) {
    const { remotePlaybackState: i, remotePlaybackType: r } = this.$state, { type: o, state: h } = t.detail, l = h === "connected";
    r.set(o), i.set(h);
    const d = o === "airplay" ? "media-airplay-request" : "media-google-cast-request";
    if (l)
      a(this, T, $t).call(this, d, t);
    else {
      const f = s(this, Jt).queue.peek(d);
      f && (t.request = f, t.triggers.add(f));
    }
  }
  "sources-change"(t) {
    const i = this.$state.sources(), r = t.detail;
    this.$state.sources.set(r), a(this, T, $m).call(this, i, r, t);
  }
  "source-change"(t) {
    var r, o;
    t.isQualityChange = ((r = t.originEvent) == null ? void 0 : r.type) === "quality-change";
    const i = t.detail;
    a(this, T, lc).call(this, t, t.isQualityChange), s(this, ot).set(t.type, t), this.$state.source.set(i), (o = this.el) == null || o.setAttribute("aria-busy", "true");
  }
  abort(t) {
    const i = s(this, ot).get("source-change");
    i && t.triggers.add(i);
    const r = s(this, ot).get("can-load");
    r && !t.triggers.hasType("can-load") && t.triggers.add(r);
  }
  "load-start"(t) {
    const i = s(this, ot).get("source-change");
    i && t.triggers.add(i);
  }
  error(t) {
    this.$state.error.set(t.detail);
    const i = s(this, ot).get("abort");
    i && t.triggers.add(i);
  }
  "loaded-metadata"(t) {
    const i = s(this, ot).get("load-start");
    i && t.triggers.add(i);
  }
  "loaded-data"(t) {
    const i = s(this, ot).get("load-start");
    i && t.triggers.add(i);
  }
  "can-play"(t) {
    var r;
    const i = s(this, ot).get("loaded-metadata");
    i && t.triggers.add(i), a(this, T, cc).call(this, t.detail), (r = this.el) == null || r.setAttribute("aria-busy", "false");
  }
  "can-play-through"(t) {
    a(this, T, cc).call(this, t.detail);
    const i = s(this, ot).get("can-play");
    i && t.triggers.add(i);
  }
  "duration-change"(t) {
    const { live: i, intrinsicDuration: r, providedDuration: o, clipEndTime: h, ended: l } = this.$state, d = t.detail;
    if (!i()) {
      const f = Number.isNaN(d) ? 0 : d;
      r.set(f), l() && a(this, T, dc).call(this, t);
    }
    (o() > 0 || h() > 0) && t.stopImmediatePropagation();
  }
  progress(t) {
    const { buffered: i, seekable: r } = this.$state, { buffered: o, seekable: h } = t.detail, l = zs(o), d = o.length !== i().length, f = l !== zs(i()), p = zs(h), m = h.length !== r().length, w = p !== zs(r());
    (d || f) && i.set(o), (m || w) && r.set(h);
  }
  play(t) {
    const {
      paused: i,
      autoPlayError: r,
      ended: o,
      autoPlaying: h,
      playsInline: l,
      pointer: d,
      muted: f,
      viewType: p,
      live: m,
      userBehindLiveEdge: w
    } = this.$state;
    if (a(this, T, uc).call(this), !i()) {
      t.stopImmediatePropagation();
      return;
    }
    t.autoPlay = h();
    const P = s(this, ot).get("waiting");
    P && t.triggers.add(P), a(this, T, $t).call(this, "media-play-request", t), s(this, ot).set("play", t), i.set(!1), r.set(null), t.autoPlay && (this.handle(
      this.createEvent("auto-play", {
        detail: { muted: f() },
        trigger: t
      })
    ), h.set(!1)), (o() || s(this, Jt).replaying) && (s(this, Jt).replaying = !1, o.set(!1), this.handle(this.createEvent("replay", { trigger: t }))), !l() && p() === "video" && d() === "coarse" && s(this, Y).remote.enterFullscreen("prefer-media", t), m() && !w() && s(this, Y).remote.seekToLiveEdge(t);
  }
  "play-fail"(t) {
    const { muted: i, autoPlaying: r } = this.$state, o = s(this, ot).get("play");
    o && t.triggers.add(o), a(this, T, $t).call(this, "media-play-request", t);
    const { paused: h, playing: l } = this.$state;
    h.set(!0), l.set(!1), a(this, T, es).call(this), s(this, ot).set("play-fail", t), t.autoPlay && (this.handle(
      this.createEvent("auto-play-fail", {
        detail: {
          muted: i(),
          error: t.detail
        },
        trigger: t
      })
    ), r.set(!1));
  }
  playing(t) {
    const i = s(this, ot).get("play"), r = s(this, ot).get("seeked");
    i ? t.triggers.add(i) : r && t.triggers.add(r), setTimeout(() => a(this, T, es).call(this), 0);
    const {
      paused: o,
      playing: h,
      live: l,
      liveSyncPosition: d,
      seekableEnd: f,
      started: p,
      currentTime: m,
      seeking: w,
      ended: P
    } = this.$state;
    if (o.set(!1), h.set(!0), w.set(!1), P.set(!1), s(this, Jt).looping) {
      s(this, Jt).looping = !1;
      return;
    }
    if (l() && !p() && m() === 0) {
      const k = d() ?? f() - 2;
      Number.isFinite(k) && s(this, Y).$provider().setCurrentTime(k);
    }
    this.started(t);
  }
  started(t) {
    const { started: i } = this.$state;
    i() || (i.set(!0), this.handle(this.createEvent("started", { trigger: t })));
  }
  pause(t) {
    var h;
    (h = this.el) != null && h.isConnected || u(this, gs, !0), a(this, T, $t).call(this, "media-pause-request", t);
    const i = s(this, ot).get("seeked");
    i && t.triggers.add(i);
    const { paused: r, playing: o } = this.$state;
    r.set(!0), o.set(!1), s(this, yn) && setTimeout(() => {
      this.handle(this.createEvent("end", { trigger: t })), u(this, yn, !1);
    }, 0), a(this, T, es).call(this);
  }
  "time-change"(t) {
    if (s(this, Jt).looping) {
      t.stopImmediatePropagation();
      return;
    }
    let { waiting: i, played: r, clipEndTime: o, realCurrentTime: h, currentTime: l } = this.$state, d = t.detail, f = o();
    h.set(d), a(this, T, vm).call(this), i.set(!1);
    for (const p of s(this, Y).textTracks)
      p[q.updateActiveCues](d, t);
    f > 0 && d >= f && (u(this, yn, !0), this.dispatch("media-pause-request", { trigger: t })), a(this, T, Sm).call(this), this.dispatch("time-update", {
      detail: { currentTime: l(), played: r() },
      trigger: t
    });
  }
  "audio-gain-change"(t) {
    var h;
    const { storage: i } = s(this, Y), { canPlay: r, audioGain: o } = this.$state;
    o.set(t.detail), a(this, T, $t).call(this, "media-audio-gain-change-request", t), r() && ((h = i == null ? void 0 : i.setAudioGain) == null || h.call(i, o()));
  }
  "volume-change"(t) {
    var d, f;
    const { storage: i } = s(this, Y), { volume: r, muted: o, canPlay: h } = this.$state, l = t.detail;
    r.set(l.volume), o.set(l.muted || l.volume === 0), a(this, T, $t).call(this, "media-volume-change-request", t), a(this, T, $t).call(this, l.muted ? "media-mute-request" : "media-unmute-request", t), h() && ((d = i == null ? void 0 : i.setVolume) == null || d.call(i, r()), (f = i == null ? void 0 : i.setMuted) == null || f.call(i, o()));
  }
  seeked(t) {
    const { seeking: i, currentTime: r, realCurrentTime: o, paused: h, seekableEnd: l, ended: d, live: f } = this.$state;
    if (s(this, Jt).seeking)
      i.set(!0), t.stopImmediatePropagation();
    else if (i()) {
      const p = s(this, ot).get("waiting");
      p && t.triggers.add(p);
      const m = s(this, ot).get("seeking");
      m && !t.triggers.has(m) && t.triggers.add(m), h() && a(this, T, fc).call(this), i.set(!1), o.set(t.detail), a(this, T, $t).call(this, "media-seek-request", t);
      const w = t == null ? void 0 : t.originEvent;
      w != null && w.isTrusted && !(w instanceof MessageEvent) && !/seek/.test(w.type) && this.started(t);
    }
    f() || (Math.floor(r()) !== Math.floor(l()) ? d.set(!1) : this.end(t));
  }
  waiting(t) {
    s(this, wn) || s(this, Jt).seeking || (t.stopImmediatePropagation(), u(this, qi, t), s(this, Pr).call(this));
  }
  end(t) {
    const { loop: i, ended: r } = this.$state;
    if (!(!i() && r())) {
      if (i()) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            a(this, T, uc).call(this, t), this.dispatch("media-loop-request", { trigger: t });
          });
        }, 10);
        return;
      }
      setTimeout(() => a(this, T, km).call(this, t), 0);
    }
  }
  "fullscreen-change"(t) {
    const i = t.detail;
    this.$state.fullscreen.set(i), a(this, T, $t).call(this, i ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request", t);
  }
  "fullscreen-error"(t) {
    a(this, T, $t).call(this, "media-enter-fullscreen-request", t), a(this, T, $t).call(this, "media-exit-fullscreen-request", t);
  }
  "orientation-change"(t) {
    const i = t.detail.lock;
    a(this, T, $t).call(this, i ? "media-orientation-lock-request" : "media-orientation-unlock-request", t);
  }
  "picture-in-picture-change"(t) {
    const i = t.detail;
    this.$state.pictureInPicture.set(i), a(this, T, $t).call(this, i ? "media-enter-pip-request" : "media-exit-pip-request", t);
  }
  "picture-in-picture-error"(t) {
    a(this, T, $t).call(this, "media-enter-pip-request", t), a(this, T, $t).call(this, "media-exit-pip-request", t);
  }
  "title-change"(t) {
    t.trigger && (t.stopImmediatePropagation(), this.$state.inferredTitle.set(t.detail));
  }
  "poster-change"(t) {
    t.trigger && (t.stopImmediatePropagation(), this.$state.inferredPoster.set(t.detail));
  }
}
Jt = new WeakMap(), Y = new WeakMap(), ot = new WeakMap(), yn = new WeakMap(), Sr = new WeakMap(), bn = new WeakMap(), wn = new WeakMap(), qi = new WeakMap(), gs = new WeakMap(), T = new WeakSet(), um = function() {
  s(this, gs) && (requestAnimationFrame(() => {
    this.scope && s(this, Y).remote.play(new H("dom-connect"));
  }), u(this, gs, !1));
}, dm = function() {
  var t;
  s(this, gs) || (u(this, gs, !this.$state.paused()), (t = s(this, Y).$provider()) == null || t.pause());
}, es = function() {
  a(this, T, fc).call(this), u(this, yn, !1), s(this, Jt).replaying = !1, s(this, Jt).looping = !1, u(this, wn, !1), u(this, qi, void 0), s(this, ot).clear();
}, $t = function(t, i) {
  const r = s(this, Jt).queue.serve(t);
  r && (i.request = r, i.triggers.add(r));
}, fm = function() {
  a(this, T, Jo).call(this), a(this, T, rc).call(this);
  const t = s(this, Y).textTracks;
  new dt(t).add("add", a(this, T, Jo).bind(this)).add("remove", a(this, T, Jo).bind(this)).add("mode-change", a(this, T, rc).bind(this));
}, pm = function() {
  const t = s(this, Y).qualities;
  new dt(t).add("add", a(this, T, oc).bind(this)).add("remove", a(this, T, oc).bind(this)).add("change", a(this, T, ym).bind(this)).add("auto-change", a(this, T, bm).bind(this)).add("readonly-change", a(this, T, wm).bind(this));
}, mm = function() {
  const t = s(this, Y).audioTracks;
  new dt(t).add("add", a(this, T, ac).bind(this)).add("remove", a(this, T, ac).bind(this)).add("change", a(this, T, gm).bind(this));
}, Jo = function(t) {
  const { textTracks: i } = this.$state;
  i.set(s(this, Y).textTracks.toArray()), this.dispatch("text-tracks-change", {
    detail: i(),
    trigger: t
  });
}, rc = function(t) {
  t && a(this, T, $t).call(this, "media-text-track-change-request", t);
  const i = s(this, Y).textTracks.selected, { textTrack: r } = this.$state;
  r() !== i && (r.set(i), this.dispatch("text-track-change", {
    detail: i,
    trigger: t
  }));
}, ac = function(t) {
  const { audioTracks: i } = this.$state;
  i.set(s(this, Y).audioTracks.toArray()), this.dispatch("audio-tracks-change", {
    detail: i(),
    trigger: t
  });
}, gm = function(t) {
  const { audioTrack: i } = this.$state;
  i.set(s(this, Y).audioTracks.selected), t && a(this, T, $t).call(this, "media-audio-track-change-request", t), this.dispatch("audio-track-change", {
    detail: i(),
    trigger: t
  });
}, oc = function(t) {
  const { qualities: i } = this.$state;
  i.set(s(this, Y).qualities.toArray()), this.dispatch("qualities-change", {
    detail: i(),
    trigger: t
  });
}, ym = function(t) {
  const { quality: i } = this.$state;
  i.set(s(this, Y).qualities.selected), t && a(this, T, $t).call(this, "media-quality-change-request", t), this.dispatch("quality-change", {
    detail: i(),
    trigger: t
  });
}, bm = function() {
  const { qualities: t } = s(this, Y), i = t.auto;
  this.$state.autoQuality.set(i), i || a(this, T, Zo).call(this);
}, kr = new WeakMap(), hc = function() {
  a(this, T, Zo).call(this), u(this, kr, b(() => {
    const { qualities: t } = s(this, Y), { mediaWidth: i, mediaHeight: r } = this.$state, o = i(), h = r();
    if (o === 0 || h === 0) return;
    let l = null, d = 1 / 0;
    for (const f of t) {
      const p = Math.abs(f.width - o) + Math.abs(f.height - h);
      p < d && (d = p, l = f);
    }
    l && t[D.select](
      l,
      !0,
      new H("resize", { detail: { width: o, height: h } })
    );
  }));
}, Zo = function() {
  var t;
  (t = s(this, kr)) == null || t.call(this), u(this, kr, null);
}, wm = function() {
  this.$state.canSetQuality.set(!s(this, Y).qualities.readonly);
}, Tm = function() {
  const { canSetVolume: t, isGoogleCastConnected: i } = this.$state;
  if (i()) {
    t.set(!1);
    return;
  }
  DT().then(t.set);
}, $m = function(t, i, r) {
  let { qualities: o } = s(this, Y), h = !1, l = !1;
  for (const d of t) {
    if (!kl(d)) continue;
    if (!i.some((p) => p.src === d.src)) {
      const p = o.getBySrc(d.src);
      p && (o[D.remove](p, r), l = !0);
    }
  }
  l && !o.length && (this.$state.savedState.set(null), o[D.reset](r));
  for (const d of i) {
    if (!kl(d) || o.getBySrc(d.src)) continue;
    const f = {
      id: d.id ?? d.height + "p",
      bitrate: null,
      codec: null,
      ...d,
      selected: !1
    };
    o[D.add](f, r), h = !0;
  }
  h && !o[ie.enableAuto] && (a(this, T, hc).call(this), o[ie.enableAuto] = a(this, T, hc).bind(this), o[ie.setAuto](!0, r));
}, lc = function(t, i = !1) {
  const { audioTracks: r, qualities: o } = s(this, Y);
  if (!i) {
    u(this, Sr, []), u(this, bn, [-1, -1]), r[D.reset](t), o[D.reset](t), sd(this.$state, i), a(this, T, es).call(this);
    return;
  }
  sd(this.$state, i), a(this, T, es).call(this);
}, cc = function(t) {
  const { seekable: i, buffered: r, intrinsicDuration: o, canPlay: h } = this.$state;
  h.set(!0), r.set(t.buffered), i.set(t.seekable);
  const l = zs(t.seekable) ?? 1 / 0;
  o.set(l);
}, uc = function(t) {
  if (!v(s(this, Y).$provider)) return;
  const { ended: r, seekableStart: o, clipEndTime: h, currentTime: l, realCurrentTime: d, duration: f } = this.$state, p = r() || d() < o() || h() > 0 && d() >= h() || Math.abs(l() - f()) < 0.1;
  return p && this.dispatch("media-seek-request", {
    detail: o(),
    trigger: t
  }), p;
}, vm = function() {
  const { currentTime: t, played: i, paused: r } = this.$state;
  r() || (u(this, bn, HT(
    s(this, Sr),
    s(this, bn),
    t()
  )), i.set(new Go(s(this, Sr))));
}, // Called to update time again incase duration precision has changed.
dc = function(t) {
  const { clipStartTime: i, clipEndTime: r, duration: o } = this.$state;
  i() > 0 || r() > 0 || this.handle(
    this.createEvent("time-change", {
      detail: o(),
      trigger: t
    })
  );
}, Sm = function() {
  var o;
  const { storage: t } = s(this, Y), { canPlay: i, realCurrentTime: r } = this.$state;
  i() && ((o = t == null ? void 0 : t.setTime) == null || o.call(t, r()));
}, Pr = new WeakMap(), km = function(t) {
  var d;
  const { storage: i } = s(this, Y), { paused: r, seeking: o, ended: h, duration: l } = this.$state;
  a(this, T, dc).call(this, t), r() || this.dispatch("pause", { trigger: t }), o() && this.dispatch("seeked", {
    detail: l(),
    trigger: t
  }), h.set(!0), a(this, T, es).call(this), (d = i == null ? void 0 : i.setTime) == null || d.call(i, l(), !0), this.dispatch("ended", {
    trigger: t
  });
}, fc = function() {
  s(this, Pr).cancel(), this.$state.waiting.set(!1);
};
var z, Pm, Em, $v, Cm, xm, Am, Mm, Lm, Im, Rm, qm, Om, Dm, Vm, Nm, Fm, _m;
class Tv extends _n {
  constructor() {
    super(...arguments);
    c(this, z);
  }
  onSetup() {
    a(this, z, Pm).call(this);
    const t = [
      a(this, z, Cm),
      a(this, z, Am),
      a(this, z, Dm),
      a(this, z, Vm),
      a(this, z, Lm),
      a(this, z, Rm),
      a(this, z, qm),
      a(this, z, Nm),
      a(this, z, _m),
      a(this, z, Fm),
      a(this, z, Mm),
      a(this, z, Om),
      a(this, z, Im),
      a(this, z, Em),
      a(this, z, xm)
    ];
    for (const i of t)
      b(i.bind(this));
  }
}
z = new WeakSet(), Pm = function() {
  var r;
  const t = {
    duration: "providedDuration",
    loop: "providedLoop",
    poster: "providedPoster",
    streamType: "providedStreamType",
    title: "providedTitle",
    viewType: "providedViewType"
  }, i = /* @__PURE__ */ new Set([
    "currentTime",
    "paused",
    "playbackRate",
    "volume"
  ]);
  for (const o of Object.keys(this.$props))
    i.has(o) || (r = this.$state[t[o] ?? o]) == null || r.set(this.$props[o]());
  this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
}, // Sync "provided" props with internal state. Provided props are used to differentiate from
// provider inferred values.
Em = function() {
  const { viewType: t, streamType: i, title: r, poster: o, loop: h } = this.$props, l = this.$state;
  l.providedPoster.set(o()), l.providedStreamType.set(i()), l.providedViewType.set(t()), l.providedTitle.set(r()), l.providedLoop.set(h());
}, $v = function() {
}, Cm = function() {
  const { artist: t, artwork: i } = this.$props;
  this.$state.artist.set(t()), this.$state.artwork.set(i());
}, xm = function() {
  const { title: t } = this.$state;
  this.dispatch("title-change", { detail: t() });
}, Am = function() {
  const t = this.$props.autoPlay() || this.$props.autoplay();
  this.$state.autoPlay.set(t), this.dispatch("auto-play-change", { detail: t });
}, Mm = function() {
  const t = this.$state.loop();
  this.dispatch("loop-change", { detail: t });
}, Lm = function() {
  const t = this.$props.controls();
  this.$state.controls.set(t);
}, Im = function() {
  const { poster: t } = this.$state;
  this.dispatch("poster-change", { detail: t() });
}, Rm = function() {
  const t = this.$props.crossOrigin() ?? this.$props.crossorigin(), i = t === !0 ? "" : t;
  this.$state.crossOrigin.set(i);
}, qm = function() {
  const { duration: t } = this.$props;
  this.dispatch("media-duration-change-request", {
    detail: t()
  });
}, Om = function() {
  const t = this.$props.playsInline() || this.$props.playsinline();
  this.$state.playsInline.set(t), this.dispatch("plays-inline-change", { detail: t });
}, Dm = function() {
  const { clipStartTime: t } = this.$props;
  this.dispatch("media-clip-start-change-request", {
    detail: t()
  });
}, Vm = function() {
  const { clipEndTime: t } = this.$props;
  this.dispatch("media-clip-end-change-request", {
    detail: t()
  });
}, Nm = function() {
  this.dispatch("live-change", { detail: this.$state.live() });
}, Fm = function() {
  this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance()), this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
}, _m = function() {
  this.dispatch("live-edge-change", { detail: this.$state.liveEdge() });
};
const fd = ["play", "pause", "seekforward", "seekbackward", "seekto"];
var fi, Hm, Um, Bm, jm;
class vv extends _n {
  constructor() {
    super(...arguments);
    c(this, fi);
  }
  onConnect() {
    b(a(this, fi, Um).bind(this)), b(a(this, fi, Bm).bind(this));
    const t = a(this, fi, jm).bind(this);
    for (const i of fd)
      navigator.mediaSession.setActionHandler(i, t);
    it(a(this, fi, Hm).bind(this));
  }
}
fi = new WeakSet(), Hm = function() {
  for (const t of fd)
    navigator.mediaSession.setActionHandler(t, null);
}, Um = function() {
  const { title: t, artist: i, artwork: r, poster: o } = this.$state;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: t(),
    artist: i(),
    artwork: r() ?? [{ src: o() }]
  });
}, Bm = function() {
  const { canPlay: t, paused: i } = this.$state;
  navigator.mediaSession.playbackState = t() ? i() ? "paused" : "playing" : "none";
}, jm = function(t) {
  const i = new H("media-session-action", { detail: t });
  switch (t.action) {
    case "play":
      this.dispatch("media-play-request", { trigger: i });
      break;
    case "pause":
      this.dispatch("media-pause-request", { trigger: i });
      break;
    case "seekto":
    case "seekforward":
    case "seekbackward":
      this.dispatch("media-seek-request", {
        detail: Te(t.seekTime) ? t.seekTime : this.$state.currentTime() + (t.seekOffset ?? (t.action === "seekforward" ? 10 : -10)),
        trigger: i
      });
      break;
  }
};
let pc = V(!1);
ft(document, "pointerdown", () => {
  pc.set(!1);
}), ft(document, "keydown", (n) => {
  n.metaKey || n.altKey || n.ctrlKey || pc.set(!0);
});
var ys, pi, Wm, Gm, Km, Qm;
class Ao extends qe {
  constructor() {
    super(...arguments);
    c(this, pi);
    c(this, ys, V(!1));
  }
  onConnect(t) {
    b(() => {
      const i = new dt(t);
      if (!pc()) {
        s(this, ys).set(!1), _o(t, !1), i.add("pointerenter", a(this, pi, Km).bind(this)).add("pointerleave", a(this, pi, Qm).bind(this));
        return;
      }
      const r = document.activeElement === t;
      s(this, ys).set(r), _o(t, r), i.add("focus", a(this, pi, Wm).bind(this)).add("blur", a(this, pi, Gm).bind(this));
    });
  }
  focused() {
    return s(this, ys).call(this);
  }
}
ys = new WeakMap(), pi = new WeakSet(), Wm = function() {
  s(this, ys).set(!0), _o(this.el, !0);
}, Gm = function() {
  s(this, ys).set(!1), _o(this.el, !1);
}, Km = function() {
  pd(this.el, !0);
}, Qm = function() {
  pd(this.el, !1);
};
function _o(n, e) {
  W(n, "data-focus", e), W(n, "data-hocus", e);
}
function pd(n, e) {
  W(n, "data-hocus", e), W(n, "data-hover", e);
}
var Sv = Object.defineProperty, kv = Object.getOwnPropertyDescriptor, lt = (n, e, t, i) => {
  for (var r = i > 1 ? void 0 : i ? kv(e, t) : e, o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = (i ? h(e, t, r) : h(r)) || r);
  return i && r && Sv(e, t, r), r;
}, hi, jt, Tn, Wt, S, pe, th, Er, zm, Ym, Xm, Jm, Zm, wa, mc, tg, gc, eg, yc, ig, bc, sg, wc, ng, Tc, rg, ag, og, hg;
const rt = (hi = class extends Lt {
  constructor() {
    super();
    c(this, S);
    c(this, jt);
    c(this, Tn);
    c(this, Wt);
    y(this, "canPlayQueue", new tm());
    y(this, "remoteControl");
    c(this, Er, !1);
    y(this, "orientation");
    new Tv();
    const t = {
      player: this,
      qualities: new M$(),
      audioTracks: new w$(),
      storage: null,
      $provider: V(null),
      $providerSetup: V(!1),
      $props: this.$props,
      $state: this.$state
    };
    t.remote = this.remoteControl = new df(
      void 0
    ), t.remote.setPlayer(this), t.textTracks = new C$(), t.textTracks[q.crossOrigin] = this.$state.crossOrigin, t.textRenderers = new P$(t), t.ariaKeys = {}, u(this, jt, t), Qi(Ru, t), this.orientation = new vh(), new Ao(), new F$(t);
    const i = new yv();
    u(this, Tn, new wv(i, t)), u(this, Wt, new pv(s(this, Tn), i, t)), t.delegate = new cv(s(this, Tn).handle.bind(s(this, Tn)), t), t.notify = t.delegate.notify.bind(t.delegate), typeof navigator < "u" && "mediaSession" in navigator && new vv(), new ud("load", this.startLoading.bind(this)), new ud("posterLoad", this.startLoadingPoster.bind(this));
  }
  onSetup() {
    a(this, S, Jm).call(this), b(a(this, S, Xm).bind(this)), b(a(this, S, eg).bind(this)), b(a(this, S, tg).bind(this)), b(a(this, S, sg).bind(this)), b(a(this, S, ig).bind(this)), b(a(this, S, rg).bind(this)), b(a(this, S, ng).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-player", ""), Vt(t, "tabindex", "0"), Vt(t, "role", "region"), b(a(this, S, og).bind(this)), b(a(this, S, zm).bind(this)), b(a(this, S, Ym).bind(this)), ft(t, "find-media-player", a(this, S, Zm).bind(this));
  }
  onConnect(t) {
    tf && W(t, "data-iphone", "");
    const i = window.matchMedia("(pointer: coarse)");
    a(this, S, mc).call(this, i), i.onchange = a(this, S, mc).bind(this);
    const r = new ResizeObserver(oa(a(this, S, wa).bind(this)));
    r.observe(t), b(a(this, S, wa).bind(this)), this.dispatch("media-player-connect", {
      detail: this,
      bubbles: !0,
      composed: !0
    }), it(() => {
      r.disconnect(), i.onchange = null;
    });
  }
  onDestroy() {
    s(this, jt).player = null, this.canPlayQueue.reset();
  }
  get provider() {
    return s(this, S, pe);
  }
  get controls() {
    return s(this, Wt).controls;
  }
  set controls(t) {
    s(this, S, th).controls.set(t);
  }
  get title() {
    return v(this.$state.title);
  }
  set title(t) {
    if (s(this, Er)) {
      u(this, Er, !1);
      return;
    }
    s(this, S, th).title.set(t);
  }
  get qualities() {
    return s(this, jt).qualities;
  }
  get audioTracks() {
    return s(this, jt).audioTracks;
  }
  get textTracks() {
    return s(this, jt).textTracks;
  }
  get textRenderers() {
    return s(this, jt).textRenderers;
  }
  get duration() {
    return this.$state.duration();
  }
  set duration(t) {
    s(this, S, th).duration.set(t);
  }
  get paused() {
    return v(this.$state.paused);
  }
  set paused(t) {
    a(this, S, gc).call(this, t);
  }
  get muted() {
    return v(this.$state.muted);
  }
  set muted(t) {
    a(this, S, yc).call(this, t);
  }
  get currentTime() {
    return v(this.$state.currentTime);
  }
  set currentTime(t) {
    a(this, S, bc).call(this, t);
  }
  get volume() {
    return v(this.$state.volume);
  }
  set volume(t) {
    a(this, S, wc).call(this, t);
  }
  get playbackRate() {
    return v(this.$state.playbackRate);
  }
  set playbackRate(t) {
    a(this, S, Tc).call(this, t);
  }
  async play(t) {
    return s(this, Wt).play(t);
  }
  async pause(t) {
    return s(this, Wt).pause(t);
  }
  async enterFullscreen(t, i) {
    return s(this, Wt).enterFullscreen(t, i);
  }
  async exitFullscreen(t, i) {
    return s(this, Wt).exitFullscreen(t, i);
  }
  enterPictureInPicture(t) {
    return s(this, Wt).enterPictureInPicture(t);
  }
  exitPictureInPicture(t) {
    return s(this, Wt).exitPictureInPicture(t);
  }
  seekToLiveEdge(t) {
    s(this, Wt).seekToLiveEdge(t);
  }
  startLoading(t) {
    s(this, jt).notify("can-load", void 0, t);
  }
  startLoadingPoster(t) {
    s(this, jt).notify("can-load-poster", void 0, t);
  }
  requestAirPlay(t) {
    return s(this, Wt).requestAirPlay(t);
  }
  requestGoogleCast(t) {
    return s(this, Wt).requestGoogleCast(t);
  }
  setAudioGain(t, i) {
    return s(this, Wt).setAudioGain(t, i);
  }
  destroy() {
    super.destroy(), s(this, jt).remote.setPlayer(null), this.dispatch("destroy");
  }
}, jt = new WeakMap(), Tn = new WeakMap(), Wt = new WeakMap(), S = new WeakSet(), pe = function() {
  return s(this, jt).$provider();
}, th = function() {
  return this.$props;
}, Er = new WeakMap(), zm = function() {
  const t = this.$el, { title: i, live: r, viewType: o, providedTitle: h } = this.$state, l = r(), d = Qd(o()), f = d !== "Unknown" ? `${l ? "Live " : ""}${d}` : l ? "Live" : "Media", p = i();
  W(
    this.el,
    "aria-label",
    `${f} Player` + (p ? ` - ${p}` : "")
  ), t != null && t.hasAttribute("title") && (u(this, Er, !0), t == null || t.removeAttribute("title"));
}, Ym = function() {
  const t = this.orientation.landscape ? "landscape" : "portrait";
  this.$state.orientation.set(t), W(this.el, "data-orientation", t), a(this, S, wa).call(this);
}, Xm = function() {
  this.$state.canPlay() && s(this, S, pe) ? this.canPlayQueue.start() : this.canPlayQueue.stop();
}, Jm = function() {
  if (hi[gl]) {
    this.setAttributes(hi[gl]);
    return;
  }
  const t = {
    "data-load": function() {
      return this.$props.load();
    },
    "data-captions": function() {
      const r = this.$state.textTrack();
      return !!r && le(r);
    },
    "data-ios-controls": function() {
      return this.$state.iOSControls();
    },
    "data-controls": function() {
      return this.controls.showing;
    },
    "data-buffering": function() {
      const { canLoad: r, canPlay: o, waiting: h } = this.$state;
      return r() && (!o() || h());
    },
    "data-error": function() {
      const { error: r } = this.$state;
      return !!r();
    },
    "data-autoplay-error": function() {
      const { autoPlayError: r } = this.$state;
      return !!r();
    }
  }, i = {
    autoPlay: "autoplay",
    canAirPlay: "can-airplay",
    canPictureInPicture: "can-pip",
    pictureInPicture: "pip",
    playsInline: "playsinline",
    remotePlaybackState: "remote-state",
    remotePlaybackType: "remote-type",
    isAirPlayConnected: "airplay",
    isGoogleCastConnected: "google-cast"
  };
  for (const r of hv) {
    const o = "data-" + (i[r] ?? Xh(r));
    t[o] = function() {
      return this.$state[r]();
    };
  }
  delete t.title, hi[gl] = t, this.setAttributes(t);
}, Zm = function(t) {
  t.detail(this);
}, wa = function() {
  if (!this.el) return;
  const t = this.el.clientWidth, i = this.el.clientHeight;
  this.$state.width.set(t), this.$state.height.set(i), Vs(this.el, "--player-width", t + "px"), Vs(this.el, "--player-height", i + "px");
}, mc = function(t) {
  const i = t.matches ? "coarse" : "fine";
  W(this.el, "data-pointer", i), this.$state.pointer.set(i), a(this, S, wa).call(this);
}, tg = function() {
  a(this, S, gc).call(this, this.$props.paused());
}, gc = function(t) {
  t ? this.canPlayQueue.enqueue("paused", () => s(this, Wt).pause()) : this.canPlayQueue.enqueue("paused", () => s(this, Wt).play());
}, eg = function() {
  a(this, S, yc).call(this, this.$props.muted());
}, yc = function(t) {
  this.canPlayQueue.enqueue("muted", () => {
    s(this, S, pe) && s(this, S, pe).setMuted(t);
  });
}, ig = function() {
  a(this, S, bc).call(this, this.$props.currentTime());
}, bc = function(t) {
  this.canPlayQueue.enqueue("currentTime", () => {
    const { currentTime: i } = this.$state;
    t !== v(i) && v(() => {
      if (!s(this, S, pe)) return;
      const r = uf(t, this.$state);
      Number.isFinite(r) && s(this, S, pe).setCurrentTime(r);
    });
  });
}, sg = function() {
  a(this, S, wc).call(this, this.$props.volume());
}, wc = function(t) {
  const i = qu(0, t, 1);
  this.canPlayQueue.enqueue("volume", () => {
    s(this, S, pe) && s(this, S, pe).setVolume(i);
  });
}, ng = function() {
  a(this, S, Tc).call(this, this.$props.playbackRate());
}, Tc = function(t) {
  this.canPlayQueue.enqueue("rate", () => {
    var i, r;
    s(this, S, pe) && ((r = (i = s(this, S, pe)).setPlaybackRate) == null || r.call(i, t));
  });
}, rg = function() {
  a(this, S, ag).call(this, this.$props.playsInline());
}, ag = function(t) {
  this.canPlayQueue.enqueue("playsinline", () => {
    var i, r;
    s(this, S, pe) && ((r = (i = s(this, S, pe)).setPlaysInline) == null || r.call(i, t));
  });
}, og = function() {
  var r;
  let t = this.$props.storage(), i = R(t) ? new l$() : t;
  if (i != null && i.onChange) {
    const { source: o } = this.$state, h = R(t) ? t : (r = this.el) == null ? void 0 : r.id, l = Eo(a(this, S, hg).bind(this));
    b(() => i.onChange(o(), l(), h || void 0));
  }
  s(this, jt).storage = i, s(this, jt).textTracks.setStorage(i), it(() => {
    var o;
    (o = i == null ? void 0 : i.onDestroy) == null || o.call(i), s(this, jt).storage = null, s(this, jt).textTracks.setStorage(null);
  });
}, hg = function() {
  const { clipStartTime: t, clipEndTime: i } = this.$props, { source: r } = this.$state, o = r();
  return o.src ? `${o.src}:${t()}:${i()}` : null;
}, y(hi, "props", lv), y(hi, "state", ua), hi);
lt([
  nt
], rt.prototype, "canPlayQueue", 2);
lt([
  nt
], rt.prototype, "remoteControl", 2);
lt([
  nt
], rt.prototype, "provider", 1);
lt([
  nt
], rt.prototype, "controls", 1);
lt([
  nt
], rt.prototype, "orientation", 2);
lt([
  nt
], rt.prototype, "title", 1);
lt([
  nt
], rt.prototype, "qualities", 1);
lt([
  nt
], rt.prototype, "audioTracks", 1);
lt([
  nt
], rt.prototype, "textTracks", 1);
lt([
  nt
], rt.prototype, "textRenderers", 1);
lt([
  nt
], rt.prototype, "duration", 1);
lt([
  nt
], rt.prototype, "paused", 1);
lt([
  nt
], rt.prototype, "muted", 1);
lt([
  nt
], rt.prototype, "currentTime", 1);
lt([
  nt
], rt.prototype, "volume", 1);
lt([
  nt
], rt.prototype, "playbackRate", 1);
lt([
  _t
], rt.prototype, "play", 1);
lt([
  _t
], rt.prototype, "pause", 1);
lt([
  _t
], rt.prototype, "enterFullscreen", 1);
lt([
  _t
], rt.prototype, "exitFullscreen", 1);
lt([
  _t
], rt.prototype, "enterPictureInPicture", 1);
lt([
  _t
], rt.prototype, "exitPictureInPicture", 1);
lt([
  _t
], rt.prototype, "seekToLiveEdge", 1);
lt([
  _t
], rt.prototype, "startLoading", 1);
lt([
  _t
], rt.prototype, "startLoadingPoster", 1);
lt([
  _t
], rt.prototype, "requestAirPlay", 1);
lt([
  _t
], rt.prototype, "requestGoogleCast", 1);
lt([
  _t
], rt.prototype, "setAudioGain", 1);
let Pv = rt;
function Ev(n, e) {
  return fetch(n, e).then((t) => t.text()).then((t) => /type="static"/.test(t) ? "on-demand" : "live");
}
function lg(n, e) {
  return fetch(n, e).then((t) => t.text()).then((t) => {
    const i = Cv(t);
    if (i)
      return lg(
        /^https?:/.test(i) ? i : new URL(i, n).href,
        e
      );
    const r = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(t) ? "on-demand" : "live";
    return r === "live" && xv(t) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(t) || t.includes("#EXT-X-DISCONTINUITY")) ? "live:dvr" : r;
  });
}
function Cv(n) {
  const e = n.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
  return e ? e[0].split(`
`)[1].trim() : null;
}
function xv(n) {
  const e = n.split(`
`);
  for (const t of e)
    if (t.startsWith("#EXT-X-TARGETDURATION")) {
      const i = parseFloat(t.split(":")[1]);
      if (!isNaN(i))
        return i;
    }
  return -1;
}
const $c = /* @__PURE__ */ new Map();
var Cr, xr, Ya, X, Oi, xt, cg, ug, vc, Sc, kc, dg, fg, pg;
class Av {
  constructor(e, t, i, r = []) {
    c(this, xt);
    c(this, Cr, !1);
    c(this, xr);
    c(this, Ya);
    c(this, X);
    c(this, Oi);
    u(this, Ya, e), u(this, X, t), u(this, Oi, i);
    const o = new Xl(), h = new Bl(), l = new Du(), d = new G$(), f = new ov(), p = new av(), m = [f, p];
    u(this, xr, Eo(() => {
      const P = t.$state.remotePlaybackLoader(), k = t.$props.preferNativeHLS() ? [l, d, o, h, ...m, ...r] : [h, l, d, o, ...m, ...r];
      return P ? [P, ...k] : k;
    }));
    const { $state: w } = t;
    w.sources.set(md(t.$props.src()));
    for (const P of w.sources()) {
      const k = s(this, xr).call(this).find((B) => B.canPlay(P));
      if (!k) continue;
      const M = k.mediaType(P);
      t.$state.source.set(P), t.$state.mediaType.set(M), t.$state.inferredViewType.set(M), s(this, Oi).set(k), u(this, Cr, !0);
      break;
    }
  }
  connect() {
    const e = s(this, Oi).call(this);
    s(this, Cr) && (a(this, xt, Sc).call(this, s(this, X).$state.source(), e), a(this, xt, kc).call(this, e), u(this, Cr, !1)), b(a(this, xt, cg).bind(this)), b(a(this, xt, ug).bind(this)), b(a(this, xt, dg).bind(this)), b(a(this, xt, fg).bind(this)), b(a(this, xt, pg).bind(this));
  }
}
Cr = new WeakMap(), xr = new WeakMap(), Ya = new WeakMap(), X = new WeakMap(), Oi = new WeakMap(), xt = new WeakSet(), cg = function() {
  s(this, X).notify("sources-change", [
    ...md(s(this, X).$props.src()),
    ...s(this, Ya).call(this)
  ]);
}, ug = function() {
  var h;
  const { $state: e } = s(this, X), t = e.sources(), i = v(e.source), r = a(this, xt, vc).call(this, i, t);
  if (((h = t[0]) == null ? void 0 : h.src) && !r.src && !r.type) {
    const { crossOrigin: l } = e, d = Sa(l()), f = new AbortController();
    return Promise.all(
      t.map(
        (p) => R(p.src) && p.type === "?" ? fetch(p.src, {
          method: "HEAD",
          credentials: d,
          signal: f.signal
        }).then((m) => (p.type = m.headers.get("content-type") || "??", $c.set(p.src, p.type), p)).catch(() => p) : p
      )
    ).then((p) => {
      if (f.signal.aborted) return;
      const m = a(this, xt, vc).call(this, v(e.source), p);
      Gi(), m.src || s(this, X).notify("error", {
        message: "Failed to load resource.",
        code: 4
      });
    }), () => f.abort();
  }
  Gi();
}, vc = function(e, t) {
  let i = { src: "", type: "" }, r = null, o = new H("sources-change", { detail: { sources: t } }), h = s(this, xr).call(this), { started: l, paused: d, currentTime: f, quality: p, savedState: m } = s(this, X).$state;
  for (const w of t) {
    const P = h.find((k) => k.canPlay(w));
    if (P) {
      i = w, r = P;
      break;
    }
  }
  if (kl(i)) {
    const w = p(), P = t.find((k) => k.src === (w == null ? void 0 : w.src));
    v(l) ? m.set({
      paused: v(d),
      currentTime: v(f)
    }) : m.set(null), P && (i = P, o = new H("quality-change", {
      detail: { quality: w }
    }));
  }
  return yd(e, i) || a(this, xt, Sc).call(this, i, r, o), r !== v(s(this, Oi)) && a(this, xt, kc).call(this, r, o), i;
}, Sc = function(e, t, i) {
  s(this, X).notify("source-change", e, i), s(this, X).notify("media-type-change", (t == null ? void 0 : t.mediaType(e)) || "unknown", i);
}, kc = function(e, t) {
  s(this, X).$providerSetup.set(!1), s(this, X).notify("provider-change", null, t), e && v(() => {
    var i;
    return (i = e.preconnect) == null ? void 0 : i.call(e, s(this, X));
  }), s(this, Oi).set(e), s(this, X).notify("provider-loader-change", e, t);
}, dg = function() {
  const e = s(this, X).$provider();
  if (!(!e || v(s(this, X).$providerSetup))) {
    if (s(this, X).$state.canLoad()) {
      Ke(() => e.setup(), e.scope), s(this, X).$providerSetup.set(!0);
      return;
    }
    v(() => {
      var t;
      return (t = e.preconnect) == null ? void 0 : t.call(e);
    });
  }
}, fg = function() {
  if (!s(this, X).$providerSetup()) return;
  const e = s(this, X).$provider(), t = s(this, X).$state.source(), i = v(s(this, X).$state.crossOrigin), r = v(s(this, X).$props.preferNativeHLS);
  if (!yd(e == null ? void 0 : e.currentSrc, t)) {
    if (s(this, X).$state.canLoad()) {
      const o = new AbortController();
      return ca(t) ? (r || !Mu()) && lg(t.src, {
        credentials: Sa(i),
        signal: o.signal
      }).then((h) => {
        s(this, X).notify("stream-type-change", h);
      }).catch(bh) : Lu(t) ? Ev(t.src, {
        credentials: Sa(i),
        signal: o.signal
      }).then((h) => {
        s(this, X).notify("stream-type-change", h);
      }).catch(bh) : s(this, X).notify("stream-type-change", "on-demand"), v(() => {
        const h = v(s(this, X).$state.preload);
        return e == null ? void 0 : e.loadSource(t, h).catch((l) => {
        });
      }), () => o.abort();
    }
    try {
      R(t.src) && el(new URL(t.src).origin);
    } catch {
    }
  }
}, pg = function() {
  const e = s(this, Oi).call(this), { providedPoster: t, source: i, canLoadPoster: r } = s(this, X).$state;
  if (!e || !e.loadPoster || !i() || !r() || t()) return;
  const o = new AbortController(), h = new H("source-change", { detail: i });
  return e.loadPoster(i(), s(this, X), o).then((l) => {
    s(this, X).notify("poster-change", l || "", h);
  }).catch(() => {
    s(this, X).notify("poster-change", "", h);
  }), () => {
    o.abort();
  };
};
function md(n) {
  return (zt(n) ? n : [n]).map((e) => R(e) ? { src: e, type: gd(e) } : { ...e, type: gd(e.src, e.type) });
}
function gd(n, e) {
  return R(e) && e.length ? e : R(n) && $c.has(n) ? $c.get(n) : !e && ca({ src: n, type: "" }) ? "application/x-mpegurl" : !e && Lu({ src: n, type: "" }) ? "application/dash+xml" : !R(n) || n.startsWith("blob:") ? "video/object" : n.includes("youtube") || n.includes("youtu.be") ? "video/youtube" : n.includes("vimeo") && !n.includes("progressive_redirect") && !n.includes(".m3u8") ? "video/vimeo" : "?";
}
function yd(n, e) {
  return (n == null ? void 0 : n.src) === (e == null ? void 0 : e.src) && (n == null ? void 0 : n.type) === (e == null ? void 0 : e.type);
}
var Xa, bs, Ja, Dh, mg;
class Mv {
  constructor(e, t) {
    c(this, Dh);
    c(this, Xa);
    c(this, bs);
    c(this, Ja, []);
    u(this, Xa, e), u(this, bs, t), b(a(this, Dh, mg).bind(this));
  }
}
Xa = new WeakMap(), bs = new WeakMap(), Ja = new WeakMap(), Dh = new WeakSet(), mg = function() {
  const e = s(this, Xa).call(this);
  for (const t of s(this, Ja))
    if (!e.some((i) => i.id === t.id)) {
      const i = t.id && s(this, bs).textTracks.getById(t.id);
      i && s(this, bs).textTracks.remove(i);
    }
  for (const t of e) {
    const i = t.id || Ns.createId(t);
    s(this, bs).textTracks.getById(i) || (t.id = i, s(this, bs).textTracks.add(t));
  }
  u(this, Ja, e);
};
var Lv = Object.defineProperty, Iv = Object.getOwnPropertyDescriptor, Rv = (n, e, t, i) => {
  for (var r = Iv(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && Lv(e, t, r), r;
}, jo, He, Za, to, eo, Ar, Mr, Se, yg, Pc, Ec, Cc;
let gg = (jo = class extends Lt {
  constructor() {
    super(...arguments);
    c(this, Se);
    c(this, He);
    c(this, Za);
    c(this, to, V([]));
    c(this, eo, V([]));
    c(this, Ar, null);
    c(this, Mr, -1);
  }
  onSetup() {
    u(this, He, ue()), u(this, Za, new Av(
      s(this, to),
      s(this, He),
      this.$state.loader,
      this.$props.loaders()
    ));
  }
  onAttach(t) {
    t.setAttribute("data-media-provider", "");
  }
  onConnect(t) {
    s(this, Za).connect(), new Mv(s(this, eo), s(this, He));
    const i = new ResizeObserver(oa(a(this, Se, Ec).bind(this)));
    i.observe(t);
    const r = new MutationObserver(a(this, Se, Cc).bind(this));
    r.observe(t, { attributes: !0, childList: !0 }), a(this, Se, Ec).call(this), a(this, Se, Cc).call(this), it(() => {
      i.disconnect(), r.disconnect();
    });
  }
  load(t) {
    t == null || t.setAttribute("aria-hidden", "true"), window.cancelAnimationFrame(s(this, Mr)), u(this, Mr, requestAnimationFrame(() => a(this, Se, yg).call(this, t))), it(() => {
      window.cancelAnimationFrame(s(this, Mr));
    });
  }
  onDestroy() {
    u(this, Ar, null), a(this, Se, Pc).call(this);
  }
}, He = new WeakMap(), Za = new WeakMap(), to = new WeakMap(), eo = new WeakMap(), Ar = new WeakMap(), Mr = new WeakMap(), Se = new WeakSet(), yg = function(t) {
  if (!this.scope) return;
  const i = this.$state.loader(), { $provider: r } = s(this, He);
  s(this, Ar) === i && (i == null ? void 0 : i.target) === t && v(r) || (a(this, Se, Pc).call(this), u(this, Ar, i), i && (i.target = t || null), !(!i || !t) && i.load(s(this, He)).then((o) => {
    this.scope && v(this.$state.loader) === i && s(this, He).notify("provider-change", o);
  }));
}, Pc = function() {
  var t;
  (t = s(this, He)) == null || t.notify("provider-change", null);
}, Ec = function() {
  if (!this.el) return;
  const { player: t, $state: i } = s(this, He), r = this.el.offsetWidth, o = this.el.offsetHeight;
  t && (i.mediaWidth.set(r), i.mediaHeight.set(o), t.el && (Vs(t.el, "--media-width", r + "px"), Vs(t.el, "--media-height", o + "px")));
}, Cc = function() {
  const t = [], i = [], r = this.el.children;
  for (const o of r)
    if (!o.hasAttribute("data-vds")) {
      if (o instanceof HTMLSourceElement) {
        const h = {
          id: o.id,
          src: o.src,
          type: o.type
        };
        for (const l of ["id", "src", "width", "height", "bitrate", "codec"]) {
          const d = o.getAttribute(`data-${l}`);
          R(d) && (h[l] = /id|src|codec/.test(l) ? d : Number(d));
        }
        t.push(h);
      } else if (o instanceof HTMLTrackElement) {
        const h = {
          src: o.src,
          kind: o.track.kind,
          language: o.srclang,
          label: o.label,
          default: o.default,
          type: o.getAttribute("data-type")
        };
        i.push({
          id: o.id || Ns.createId(h),
          ...h
        });
      }
    }
  s(this, to).set(t), s(this, eo).set(i), Gi();
}, y(jo, "props", {
  loaders: []
}), y(jo, "state", new la({
  loader: null
})), jo);
Rv([
  _t
], gg.prototype, "load");
var Ue, Ds, bg, $n, vn, ei, eh;
class qv extends qe {
  constructor(t) {
    super();
    c(this, Ds);
    c(this, Ue);
    c(this, $n, -1);
    c(this, vn, -1);
    c(this, ei, null);
    u(this, Ue, t), b(a(this, Ds, bg).bind(this));
  }
  onDestroy() {
    var t;
    (t = s(this, ei)) == null || t.call(this), u(this, ei, null);
  }
  show(t) {
    var i, r, o;
    a(this, Ds, eh).call(this), window.cancelAnimationFrame(s(this, vn)), u(this, vn, -1), (i = s(this, ei)) == null || i.call(this), u(this, ei, null), u(this, $n, window.setTimeout(() => {
      u(this, $n, -1);
      const h = s(this, Ue).content();
      h && h.style.removeProperty("display"), v(() => s(this, Ue).onChange(!0, t));
    }, ((o = (r = s(this, Ue)).showDelay) == null ? void 0 : o.call(r)) ?? 0));
  }
  hide(t) {
    a(this, Ds, eh).call(this), v(() => s(this, Ue).onChange(!1, t)), u(this, vn, requestAnimationFrame(() => {
      var r;
      a(this, Ds, eh).call(this), u(this, vn, -1);
      const i = s(this, Ue).content();
      if (i) {
        const o = () => {
          i.style.display = "none", u(this, ei, null);
        };
        if (S$(i)) {
          (r = s(this, ei)) == null || r.call(this);
          const l = ft(i, "animationend", o, { once: !0 });
          u(this, ei, l);
        } else
          o();
      }
    }));
  }
}
Ue = new WeakMap(), Ds = new WeakSet(), bg = function() {
  const t = s(this, Ue).trigger();
  if (!t) {
    this.hide();
    return;
  }
  const i = this.show.bind(this), r = this.hide.bind(this);
  s(this, Ue).listen(t, i, r);
}, $n = new WeakMap(), vn = new WeakMap(), ei = new WeakMap(), eh = function() {
  window.clearTimeout(s(this, $n)), u(this, $n, -1);
};
var Di, mi, wg, Tg, $g, vg;
class Ph extends qe {
  constructor(t) {
    super();
    c(this, mi);
    c(this, Di);
    u(this, Di, t), new Ao(), t.keyShortcut && new B$(t.keyShortcut);
  }
  onSetup() {
    const { disabled: t } = this.$props;
    this.setAttributes({
      "data-pressed": s(this, Di).isPresssed,
      "aria-pressed": a(this, mi, wg).bind(this),
      "aria-disabled": () => t() ? "true" : null
    });
  }
  onAttach(t) {
    Vt(t, "tabindex", "0"), Vt(t, "role", "button"), Vt(t, "type", "button");
  }
  onConnect(t) {
    const i = ea(t, a(this, mi, $g).bind(this));
    for (const r of ["click", "touchstart"])
      i.add(r, a(this, mi, vg).bind(this), {
        passive: !0
      });
  }
}
Di = new WeakMap(), mi = new WeakSet(), wg = function() {
  return wh(s(this, Di).isPresssed());
}, Tg = function(t) {
  CT(s(this, Di).isPresssed) && s(this, Di).isPresssed.set((i) => !i);
}, $g = function(t) {
  if (this.$props.disabled() || this.el.hasAttribute("data-disabled")) {
    t.preventDefault(), t.stopImmediatePropagation();
    return;
  }
  t.preventDefault(), (s(this, Di).onPress ?? a(this, mi, Tg)).call(this, t);
}, vg = function(t) {
  this.$props.disabled() && (t.preventDefault(), t.stopImmediatePropagation());
}, y(Ph, "props", {
  disabled: !1
});
var Ov = Object.defineProperty, Dv = Object.getOwnPropertyDescriptor, Vv = (n, e, t, i) => {
  for (var r = Dv(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && Ov(e, t, r), r;
}, io;
class Sg extends Lt {
  constructor() {
    super();
    c(this, io, V(!1));
    new Ph({
      isPresssed: s(this, io)
    });
  }
  get pressed() {
    return s(this, io).call(this);
  }
}
io = new WeakMap(), y(Sg, "props", {
  disabled: !1,
  defaultPressed: !1
});
Vv([
  nt
], Sg.prototype, "pressed");
var Tl, ws, zi, kg, xc, Pg;
let Nv = (Tl = class extends Lt {
  constructor() {
    super();
    c(this, zi);
    c(this, ws);
    new Ph({
      isPresssed: a(this, zi, xc).bind(this),
      keyShortcut: "toggleFullscreen",
      onPress: a(this, zi, kg).bind(this)
    });
  }
  onSetup() {
    u(this, ws, ue());
    const { fullscreen: t } = s(this, ws).$state, i = a(this, zi, Pg).bind(this);
    this.setAttributes({
      "data-active": t,
      "data-supported": i,
      "aria-hidden": Hn(() => !i())
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "fullscreen"), $$(t, "Fullscreen");
  }
}, ws = new WeakMap(), zi = new WeakSet(), kg = function(t) {
  const i = s(this, ws).remote, r = this.$props.target();
  a(this, zi, xc).call(this) ? i.exitFullscreen(r, t) : i.enterFullscreen(r, t);
}, xc = function() {
  const { fullscreen: t } = s(this, ws).$state;
  return t();
}, Pg = function() {
  const { canFullscreen: t } = s(this, ws).$state;
  return t();
}, y(Tl, "props", {
  ...Ph.props,
  target: "prefer-media"
}), Tl);
const il = new la({
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  pointerValue: 0,
  focused: !1,
  dragging: !1,
  pointing: !1,
  hidden: !1,
  get active() {
    return this.dragging || this.focused || this.pointing;
  },
  get fillRate() {
    return bd(this.min, this.max, this.value);
  },
  get fillPercent() {
    return this.fillRate * 100;
  },
  get pointerRate() {
    return bd(this.min, this.max, this.pointerValue);
  },
  get pointerPercent() {
    return this.pointerRate * 100;
  }
});
function bd(n, e, t) {
  const i = e - n, r = t - n;
  return i > 0 ? r / i : 0;
}
var Lr, Ts, Vh, Cg;
class Eg extends qe {
  constructor(t) {
    super();
    c(this, Vh);
    c(this, Lr);
    c(this, Ts);
    u(this, Lr, t);
  }
  onConnect(t) {
    u(this, Ts, new IntersectionObserver((i) => {
      var r, o;
      (o = (r = s(this, Lr)).callback) == null || o.call(r, i, s(this, Ts));
    }, s(this, Lr))), s(this, Ts).observe(t), it(a(this, Vh, Cg).bind(this));
  }
}
Lr = new WeakMap(), Ts = new WeakMap(), Vh = new WeakSet(), /**
 * Disconnect any active intersection observers.
 */
Cg = function() {
  var t;
  (t = s(this, Ts)) == null || t.disconnect(), u(this, Ts, void 0);
};
const _u = ha(), Pa = ha();
function Fv(n, e, t, i) {
  return qu(n, ce(t, Al(i)), e);
}
function _v(n, e, t, i) {
  const r = qu(0, t, 1), o = e - n, h = o * r, l = h / i, d = i * Math.round(l);
  return n + d;
}
const bl = {
  Left: -1,
  ArrowLeft: -1,
  Up: 1,
  ArrowUp: 1,
  Right: 1,
  ArrowRight: 1,
  Down: -1,
  ArrowDown: -1
};
var Gt, $s, Ir, C, xg, vs, Be, Vi, Ag, Mg, Lg, Ig, Rg, ih, is, Ta, qg, Og, Dg, Vg, sh, Ac, Rr, Ni, Ng, Fg, Mc, Lc, _g, Hg, Nh;
class Hv extends qe {
  constructor(t, i) {
    super();
    c(this, C);
    c(this, Gt);
    c(this, $s);
    c(this, Ir);
    c(this, vs, null);
    c(this, Be, null);
    c(this, Vi, null);
    // -------------------------------------------------------------------------------------------
    // Keyboard Events
    // -------------------------------------------------------------------------------------------
    c(this, Rr);
    c(this, Ni, !1);
    c(this, Nh, xo(
      (t) => {
        a(this, C, is).call(this, a(this, C, Ta).call(this, t), t);
      },
      20,
      { leading: !0 }
    ));
    u(this, Gt, t), u(this, $s, i);
  }
  onSetup() {
    On(Pa) && u(this, Ir, Me(Pa));
  }
  onConnect(t) {
    b(a(this, C, Lg).bind(this, t)), b(a(this, C, Ig).bind(this, t)), s(this, Gt).swipeGesture && b(a(this, C, xg).bind(this));
  }
}
Gt = new WeakMap(), $s = new WeakMap(), Ir = new WeakMap(), C = new WeakSet(), xg = function() {
  var i;
  const { pointer: t } = s(this, $s).$state;
  if (t() !== "coarse" || !s(this, Gt).swipeGesture()) {
    u(this, vs, null);
    return;
  }
  u(this, vs, (i = s(this, $s).player.el) == null ? void 0 : i.querySelector(
    "media-provider,[data-media-provider]"
  )), s(this, vs) && new dt(s(this, vs)).add("touchstart", a(this, C, Ag).bind(this), {
    passive: !0
  }).add("touchmove", a(this, C, Mg).bind(this), { passive: !1 });
}, vs = new WeakMap(), Be = new WeakMap(), Vi = new WeakMap(), Ag = function(t) {
  u(this, Be, t.touches[0]);
}, Mg = function(t) {
  if (Ki(s(this, Be)) || bf(t)) return;
  const i = t.touches[0], r = i.clientX - s(this, Be).clientX, o = i.clientY - s(this, Be).clientY, h = this.$state.dragging();
  !h && Math.abs(o) > 5 || h || (t.preventDefault(), Math.abs(r) > 20 && (u(this, Be, i), u(this, Vi, this.$state.value()), a(this, C, sh).call(this, s(this, Vi), t)));
}, Lg = function(t) {
  const { hidden: i } = this.$props;
  ft(t, "focus", a(this, C, Rg).bind(this)), !(i() || s(this, Gt).isDisabled()) && new dt(t).add("keyup", a(this, C, Fg).bind(this)).add("keydown", a(this, C, Ng).bind(this)).add("pointerenter", a(this, C, qg).bind(this)).add("pointermove", a(this, C, Og).bind(this)).add("pointerleave", a(this, C, Dg).bind(this)).add("pointerdown", a(this, C, Vg).bind(this));
}, Ig = function(t) {
  s(this, Gt).isDisabled() || !this.$state.dragging() || new dt(document).add("pointerup", a(this, C, _g).bind(this), { capture: !0 }).add("pointermove", s(this, Nh).bind(this)).add("touchmove", a(this, C, Hg).bind(this), {
    passive: !1
  });
}, Rg = function() {
  a(this, C, is).call(this, this.$state.value());
}, ih = function(t, i) {
  var p, m, w, P;
  const { value: r, min: o, max: h, dragging: l } = this.$state, d = Math.max(o(), Math.min(t, h()));
  r.set(d);
  const f = this.createEvent("value-change", { detail: d, trigger: i });
  if (this.dispatch(f), (m = (p = s(this, Gt)).onValueChange) == null || m.call(p, f), l()) {
    const k = this.createEvent("drag-value-change", { detail: d, trigger: i });
    this.dispatch(k), (P = (w = s(this, Gt)).onDragValueChange) == null || P.call(w, k);
  }
}, is = function(t, i) {
  const { pointerValue: r, dragging: o } = this.$state;
  r.set(t), this.dispatch("pointer-value-change", { detail: t, trigger: i }), o() && a(this, C, ih).call(this, t, i);
}, Ta = function(t) {
  let i, r = this.el.getBoundingClientRect(), { min: o, max: h } = this.$state;
  if (this.$props.orientation() === "vertical") {
    const { bottom: l, height: d } = r;
    i = (l - t.clientY) / d;
  } else if (s(this, Be) && Te(s(this, Vi))) {
    const { width: l } = s(this, vs).getBoundingClientRect(), d = (t.clientX - s(this, Be).clientX) / l, f = h() - o(), p = f * Math.abs(d);
    i = (d < 0 ? s(this, Vi) - p : s(this, Vi) + p) / f;
  } else {
    const { left: l, width: d } = r;
    i = (t.clientX - l) / d;
  }
  return Math.max(
    o(),
    Math.min(
      h(),
      s(this, Gt).roundValue(
        _v(o(), h(), i, s(this, Gt).getStep())
      )
    )
  );
}, qg = function(t) {
  this.$state.pointing.set(!0);
}, Og = function(t) {
  const { dragging: i } = this.$state;
  i() || a(this, C, is).call(this, a(this, C, Ta).call(this, t), t);
}, Dg = function(t) {
  this.$state.pointing.set(!1);
}, Vg = function(t) {
  if (t.button !== 0) return;
  const i = a(this, C, Ta).call(this, t);
  a(this, C, sh).call(this, i, t), a(this, C, is).call(this, i, t);
}, sh = function(t, i) {
  var h, l, d, f;
  const { dragging: r } = this.$state;
  if (r()) return;
  r.set(!0), s(this, $s).remote.pauseControls(i);
  const o = this.createEvent("drag-start", { detail: t, trigger: i });
  this.dispatch(o), (l = (h = s(this, Gt)).onDragStart) == null || l.call(h, o), (f = (d = s(this, Ir)) == null ? void 0 : d.onDragStart) == null || f.call(d);
}, Ac = function(t, i) {
  var h, l, d, f;
  const { dragging: r } = this.$state;
  if (!r()) return;
  r.set(!1), s(this, $s).remote.resumeControls(i);
  const o = this.createEvent("drag-end", { detail: t, trigger: i });
  this.dispatch(o), (l = (h = s(this, Gt)).onDragEnd) == null || l.call(h, o), u(this, Be, null), u(this, Vi, null), (f = (d = s(this, Ir)) == null ? void 0 : d.onDragEnd) == null || f.call(d);
}, Rr = new WeakMap(), Ni = new WeakMap(), Ng = function(t) {
  if (!Object.keys(bl).includes(t.key)) return;
  const { key: r } = t, o = a(this, C, Mc).call(this, t);
  if (!Ki(o)) {
    a(this, C, is).call(this, o, t), a(this, C, ih).call(this, o, t);
    return;
  }
  const h = a(this, C, Lc).call(this, t);
  s(this, Ni) || (u(this, Ni, r === s(this, Rr)), !this.$state.dragging() && s(this, Ni) && a(this, C, sh).call(this, h, t)), a(this, C, is).call(this, h, t), u(this, Rr, r);
}, Fg = function(t) {
  if (!Object.keys(bl).includes(t.key) || !Ki(a(this, C, Mc).call(this, t))) return;
  const r = s(this, Ni) ? this.$state.pointerValue() : a(this, C, Lc).call(this, t);
  a(this, C, ih).call(this, r, t), a(this, C, Ac).call(this, r, t), u(this, Rr, ""), u(this, Ni, !1);
}, Mc = function(t) {
  let i = t.key, { min: r, max: o } = this.$state;
  return i === "Home" || i === "PageUp" ? r() : i === "End" || i === "PageDown" ? o() : !t.metaKey && /^[0-9]$/.test(i) ? (o() - r()) / 10 * Number(i) : null;
}, Lc = function(t) {
  var At, Ut;
  const { key: i, shiftKey: r } = t;
  t.preventDefault(), t.stopPropagation();
  const { shiftKeyMultiplier: o } = this.$props, { min: h, max: l, value: d, pointerValue: f } = this.$state, p = s(this, Gt).getStep(), m = s(this, Gt).getKeyStep(), w = r ? m * o() : m, P = Number(bl[i]), k = w * P, M = s(this, Ni) ? f() : ((Ut = (At = s(this, Gt)).getValue) == null ? void 0 : Ut.call(At)) ?? d(), B = (M + k) / p;
  return Math.max(h(), Math.min(l(), Number((p * B).toFixed(3))));
}, // -------------------------------------------------------------------------------------------
// Document (Pointer Events)
// -------------------------------------------------------------------------------------------
_g = function(t) {
  if (t.button !== 0) return;
  t.preventDefault(), t.stopImmediatePropagation();
  const i = a(this, C, Ta).call(this, t);
  a(this, C, is).call(this, i, t), a(this, C, Ac).call(this, i, t);
}, Hg = function(t) {
  t.preventDefault();
}, Nh = new WeakMap();
const Ea = ha(() => ({}));
var so, ne, no, ro, Nt, Ug, Bg, jg, Wg, Gg, Kg, Qg, zg, Fh;
class Dn extends qe {
  constructor(t) {
    super();
    c(this, Nt);
    c(this, so);
    c(this, ne);
    c(this, no, V(!0));
    c(this, ro, V(!0));
    c(this, Fh, oa((t, i) => {
      var r, o;
      (r = this.el) == null || r.style.setProperty("--slider-fill", t + "%"), (o = this.el) == null || o.style.setProperty("--slider-pointer", i + "%");
    }));
    u(this, ne, t);
  }
  onSetup() {
    u(this, so, ue());
    const t = new Ao();
    t.attach(this), this.$state.focused = t.focused.bind(t), On(Ea) || Qi(Ea, {
      default: "value"
    }), Qi(_u, {
      orientation: this.$props.orientation,
      disabled: s(this, ne).isDisabled,
      preview: V(null)
    }), b(a(this, Nt, jg).bind(this)), b(a(this, Nt, Wg).bind(this)), b(a(this, Nt, Gg).bind(this)), a(this, Nt, Qg).call(this), new Hv(s(this, ne), s(this, so)).attach(this), new Eg({
      callback: a(this, Nt, Ug).bind(this)
    }).attach(this);
  }
  onAttach(t) {
    Vt(t, "role", "slider"), Vt(t, "tabindex", "0"), Vt(t, "autocomplete", "off"), b(a(this, Nt, zg).bind(this));
  }
  onConnect(t) {
    it(gf(t, s(this, no).set)), b(a(this, Nt, Bg).bind(this));
  }
}
so = new WeakMap(), ne = new WeakMap(), no = new WeakMap(), ro = new WeakMap(), Nt = new WeakSet(), Ug = function(t) {
  s(this, ro).set(t[0].isIntersecting);
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
Bg = function() {
  const { hidden: t } = this.$props;
  this.$state.hidden.set(t() || !s(this, no).call(this) || !s(this, ro).bind(this));
}, jg = function() {
  const { dragging: t, value: i, min: r, max: o } = this.$state;
  v(t) || i.set(Fv(r(), o(), i(), s(this, ne).getStep()));
}, Wg = function() {
  this.$state.step.set(s(this, ne).getStep());
}, Gg = function() {
  if (!s(this, ne).isDisabled()) return;
  const { dragging: t, pointing: i } = this.$state;
  t.set(!1), i.set(!1);
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
Kg = function() {
  return wh(s(this, ne).isDisabled());
}, // -------------------------------------------------------------------------------------------
// Attributes
// -------------------------------------------------------------------------------------------
Qg = function() {
  const { orientation: t } = this.$props, { dragging: i, active: r, pointing: o } = this.$state;
  this.setAttributes({
    "data-dragging": i,
    "data-pointing": o,
    "data-active": r,
    "aria-disabled": a(this, Nt, Kg).bind(this),
    "aria-valuemin": s(this, ne).aria.valueMin ?? this.$state.min,
    "aria-valuemax": s(this, ne).aria.valueMax ?? this.$state.max,
    "aria-valuenow": s(this, ne).aria.valueNow,
    "aria-valuetext": s(this, ne).aria.valueText,
    "aria-orientation": t
  });
}, zg = function() {
  const { fillPercent: t, pointerPercent: i } = this.$state;
  s(this, Fh).call(this, ce(t(), 3), ce(i(), 3));
}, Fh = new WeakMap(), y(Dn, "props", {
  hidden: !1,
  disabled: !1,
  step: 1,
  keyStep: 1,
  orientation: "horizontal",
  shiftKeyMultiplier: 5
});
var gi, Yg, Xg, Jg, Zg;
class Vn extends Lt {
  constructor() {
    super();
    c(this, gi);
    new Dn({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.$props.disabled,
      aria: {
        valueNow: a(this, gi, Yg).bind(this),
        valueText: a(this, gi, Xg).bind(this)
      }
    });
  }
  onSetup() {
    b(a(this, gi, Jg).bind(this)), b(a(this, gi, Zg).bind(this));
  }
}
gi = new WeakSet(), // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
Yg = function() {
  const { value: t } = this.$state;
  return Math.round(t());
}, Xg = function() {
  const { value: t, max: i } = this.$state;
  return ce(t() / i() * 100, 2) + "%";
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
Jg = function() {
  const { value: t } = this.$props;
  this.$state.value.set(t());
}, Zg = function() {
  const { min: t, max: i } = this.$props;
  this.$state.min.set(t()), this.$state.max.set(i());
}, y(Vn, "props", {
  ...Dn.props,
  min: 0,
  max: 100,
  value: 0
}), y(Vn, "state", il);
const $i = /* @__PURE__ */ new Map(), Ho = /* @__PURE__ */ new Map();
var ao, qr, oo, Tt, ty, ey, Rc, qc, Oc, Dc, iy, nh;
const Gu = class Gu {
  constructor(e, t, i) {
    c(this, Tt);
    c(this, ao);
    c(this, qr);
    c(this, oo);
    y(this, "$images", V([]));
    u(this, qr, e), u(this, oo, t), u(this, ao, i), b(a(this, Tt, ty).bind(this));
  }
  static create(e, t) {
    const i = ue();
    return new Gu(e, t, i);
  }
};
ao = new WeakMap(), qr = new WeakMap(), oo = new WeakMap(), Tt = new WeakSet(), ty = function() {
  var i;
  const { canLoad: e } = s(this, ao).$state;
  if (!e()) return;
  const t = s(this, qr).call(this);
  if (t) {
    if (R(t) && $i.has(t)) {
      const r = $i.get(t);
      if ($i.delete(t), $i.set(t, r), $i.size > 99) {
        const o = $i.keys().next().value;
        $i.delete(o);
      }
      this.$images.set($i.get(t));
    } else if (R(t)) {
      const r = s(this, oo).call(this), o = t + "::" + r;
      if (!Ho.has(o)) {
        const h = new Promise(async (l, d) => {
          try {
            const f = await fetch(t, {
              credentials: Sa(r)
            });
            if (f.headers.get("content-type") === "application/json") {
              const m = await f.json();
              if (zt(m))
                if (m[0] && "text" in m[0])
                  l(a(this, Tt, qc).call(this, m));
                else {
                  for (let w = 0; w < m.length; w++) {
                    const P = m[w];
                    Ti(fT(P), !1), Ti(
                      "url" in P && R(P.url),
                      !1
                    ), Ti(
                      "startTime" in P && Te(P.startTime),
                      !1
                    );
                  }
                  l(m);
                }
              else
                l(a(this, Tt, Rc).call(this, m));
              return;
            }
            import("./dev-D3SS6qhA.js").then((m) => m.d).then(async ({ parseResponse: m }) => {
              try {
                const { cues: w } = await m(f);
                l(a(this, Tt, qc).call(this, w));
              } catch (w) {
                d(w);
              }
            });
          } catch (f) {
            d(f);
          }
        }).then((l) => ($i.set(o, l), l)).catch((l) => {
          a(this, Tt, nh).call(this, t, l);
        }).finally(() => {
          R(o) && Ho.delete(o);
        });
        Ho.set(o, h);
      }
      (i = Ho.get(o)) == null || i.then((h) => {
        this.$images.set(h || []);
      });
    } else if (zt(t))
      try {
        this.$images.set(a(this, Tt, ey).call(this, t));
      } catch (r) {
        a(this, Tt, nh).call(this, t, r);
      }
    else
      try {
        this.$images.set(a(this, Tt, Rc).call(this, t));
      } catch (r) {
        a(this, Tt, nh).call(this, t, r);
      }
    return () => {
      this.$images.set([]);
    };
  }
}, ey = function(e) {
  const t = a(this, Tt, Oc).call(this);
  return e.map((i, r) => (Ti(
    i.url && R(i.url)
  ), Ti(
    "startTime" in i && Te(i.startTime)
  ), {
    ...i,
    url: R(i.url) ? a(this, Tt, Dc).call(this, i.url, t) : i.url
  }));
}, Rc = function(e) {
  var h;
  Ti(R(e.url)), Ti(zt(e.tiles) && ((h = e.tiles) == null ? void 0 : h.length));
  const t = new URL(e.url), i = [], r = "tile_width" in e ? e.tile_width : e.tileWidth, o = "tile_height" in e ? e.tile_height : e.tileHeight;
  for (const l of e.tiles)
    i.push({
      url: t,
      startTime: "start" in l ? l.start : l.startTime,
      width: r,
      height: o,
      coords: { x: l.x, y: l.y }
    });
  return i;
}, qc = function(e) {
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    Ti(
      "startTime" in o && Te(o.startTime)
    ), Ti(
      "text" in o && R(o.text)
    );
  }
  const t = [], i = a(this, Tt, Oc).call(this);
  for (const r of e) {
    const [o, h] = r.text.split("#"), l = a(this, Tt, iy).call(this, h);
    t.push({
      url: a(this, Tt, Dc).call(this, o, i),
      startTime: r.startTime,
      endTime: r.endTime,
      width: l == null ? void 0 : l.w,
      height: l == null ? void 0 : l.h,
      coords: l && Te(l.x) && Te(l.y) ? { x: l.x, y: l.y } : void 0
    });
  }
  return t;
}, Oc = function() {
  let e = v(s(this, qr));
  return !R(e) || !/^https?:/.test(e) ? location.href : e;
}, Dc = function(e, t) {
  return /^https?:/.test(e) ? new URL(e) : new URL(e, t);
}, iy = function(e) {
  if (!e) return {};
  const [t, i] = e.split("="), r = i == null ? void 0 : i.split(","), o = {};
  if (!t || !r)
    return null;
  for (let h = 0; h < t.length; h++) {
    const l = +r[h];
    isNaN(l) || (o[t[h]] = l);
  }
  return o;
}, nh = function(e, t) {
};
let Ic = Gu;
var Or, Dr, Q, sy, Nc, ny, ry, ay, oy, Fc, hy, ly, _c, ss, cy;
class Vc extends Lt {
  constructor() {
    super(...arguments);
    c(this, Q);
    y(this, "media");
    c(this, Or);
    c(this, Dr, []);
  }
  onSetup() {
    this.media = ue(), u(this, Or, Ic.create(this.$props.src, this.$state.crossOrigin)), a(this, Q, Nc).call(this), this.setAttributes({
      "data-loading": a(this, Q, oy).bind(this),
      "data-error": a(this, Q, Fc).bind(this),
      "data-hidden": this.$state.hidden,
      "aria-hidden": Hn(this.$state.hidden)
    });
  }
  onConnect(t) {
    b(a(this, Q, sy).bind(this)), b(a(this, Q, hy).bind(this)), b(a(this, Q, Nc).bind(this)), b(a(this, Q, ny).bind(this)), b(a(this, Q, ly).bind(this)), b(a(this, Q, _c).bind(this));
  }
  getTime() {
    return this.$props.time();
  }
}
Or = new WeakMap(), Dr = new WeakMap(), Q = new WeakSet(), sy = function() {
  const t = this.$state.img();
  t && new dt(t).add("load", a(this, Q, ry).bind(this)).add("error", a(this, Q, ay).bind(this));
}, Nc = function() {
  const { crossOrigin: t } = this.$props, { crossOrigin: i } = this.$state, { crossOrigin: r } = this.media.$state, o = t() !== null ? t() : r();
  i.set(o === !0 ? "anonymous" : o);
}, ny = function() {
  const { src: t, loading: i, error: r } = this.$state;
  return t() && (i.set(!0), r.set(null)), () => {
    a(this, Q, cy).call(this), i.set(!1), r.set(null);
  };
}, ry = function() {
  const { loading: t, error: i } = this.$state;
  a(this, Q, _c).call(this), t.set(!1), i.set(null);
}, ay = function(t) {
  const { loading: i, error: r } = this.$state;
  i.set(!1), r.set(t);
}, oy = function() {
  const { loading: t, hidden: i } = this.$state;
  return !i() && t();
}, Fc = function() {
  const { error: t } = this.$state;
  return !Ki(t());
}, hy = function() {
  const { hidden: t } = this.$state, { duration: i } = this.media.$state, r = s(this, Or).$images();
  t.set(a(this, Q, Fc).call(this) || !Number.isFinite(i()) || r.length === 0);
}, ly = function() {
  let t = s(this, Or).$images();
  if (!t.length) return;
  let i = this.getTime(), { src: r, activeThumbnail: o } = this.$state, h = -1, l = null;
  for (let d = t.length - 1; d >= 0; d--) {
    const f = t[d];
    if (i >= f.startTime && (!f.endTime || i < f.endTime)) {
      h = d;
      break;
    }
  }
  t[h] && (l = t[h]), o.set(l), r.set((l == null ? void 0 : l.url.href) || "");
}, _c = function() {
  if (!this.scope || this.$state.hidden()) return;
  const t = this.el, i = this.$state.img(), r = this.$state.activeThumbnail();
  if (!i || !r || !t) return;
  let o = r.width ?? i.naturalWidth, h = (r == null ? void 0 : r.height) ?? i.naturalHeight, {
    maxWidth: l,
    maxHeight: d,
    minWidth: f,
    minHeight: p,
    width: m,
    height: w
  } = getComputedStyle(this.el);
  f === "100%" && (f = parseFloat(m) + ""), p === "100%" && (p = parseFloat(w) + "");
  let P = Math.max(parseInt(f) / o, parseInt(p) / h), k = Math.min(
    Math.max(parseInt(f), parseInt(l)) / o,
    Math.max(parseInt(p), parseInt(d)) / h
  ), M = !isNaN(k) && k < 1 ? k : P > 1 ? P : 1;
  a(this, Q, ss).call(this, t, "--thumbnail-width", `${o * M}px`), a(this, Q, ss).call(this, t, "--thumbnail-height", `${h * M}px`), a(this, Q, ss).call(this, t, "--thumbnail-aspect-ratio", String(ce(o / h, 5))), a(this, Q, ss).call(this, i, "width", `${i.naturalWidth * M}px`), a(this, Q, ss).call(this, i, "height", `${i.naturalHeight * M}px`), a(this, Q, ss).call(this, i, "transform", r.coords ? `translate(-${r.coords.x * M}px, -${r.coords.y * M}px)` : ""), a(this, Q, ss).call(this, i, "max-width", "none");
}, ss = function(t, i, r) {
  t.style.setProperty(i, r), s(this, Dr).push(() => t.style.removeProperty(i));
}, cy = function() {
  for (const t of s(this, Dr)) t();
  u(this, Dr, []);
}, y(Vc, "props", {
  src: null,
  time: 0,
  crossOrigin: null
}), y(Vc, "state", new la({
  src: "",
  img: null,
  thumbnails: [],
  activeThumbnail: null,
  crossOrigin: null,
  loading: !1,
  error: null,
  hidden: !1
}));
var ho;
class Uv extends Vc {
  constructor() {
    super(...arguments);
    c(this, ho);
  }
  onAttach(t) {
    u(this, ho, Co(Vn.state));
  }
  getTime() {
    const { duration: t, clipStartTime: i } = this.media.$state;
    return i() + s(this, ho).pointerRate() * t();
  }
}
ho = new WeakMap();
var Bv = Object.defineProperty, jv = Object.getOwnPropertyDescriptor, Wv = (n, e, t, i) => {
  for (var r = jv(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && Bv(e, t, r), r;
}, Ss, lo, yt, uy, dy, Hc, fy, Uc, py, my, Bc, gy, yy;
class Eh extends Lt {
  constructor() {
    super(...arguments);
    c(this, yt);
    c(this, Ss);
    c(this, lo);
  }
  get video() {
    return this.$state.video();
  }
  onSetup() {
    u(this, Ss, ue()), u(this, lo, Co(Vn.state)), a(this, yt, Hc).call(this), this.setAttributes({
      "data-loading": a(this, yt, fy).bind(this),
      "data-hidden": this.$state.hidden,
      "data-error": a(this, yt, Uc).bind(this),
      "aria-hidden": Hn(this.$state.hidden)
    });
  }
  onAttach(t) {
    b(a(this, yt, uy).bind(this)), b(a(this, yt, dy).bind(this)), b(a(this, yt, Hc).bind(this)), b(a(this, yt, py).bind(this)), b(a(this, yt, my).bind(this)), b(a(this, yt, yy).bind(this));
  }
}
Ss = new WeakMap(), lo = new WeakMap(), yt = new WeakSet(), uy = function() {
  const t = this.$state.video();
  t && (t.readyState >= 2 && a(this, yt, Bc).call(this), new dt(t).add("canplay", a(this, yt, Bc).bind(this)).add("error", a(this, yt, gy).bind(this)));
}, dy = function() {
  const { src: t } = this.$state, { canLoad: i } = s(this, Ss).$state;
  t.set(i() ? this.$props.src() : null);
}, Hc = function() {
  const { crossOrigin: t } = this.$props, { crossOrigin: i } = this.$state, { crossOrigin: r } = s(this, Ss).$state, o = t() !== null ? t() : r();
  i.set(o === !0 ? "anonymous" : o);
}, fy = function() {
  const { canPlay: t, hidden: i } = this.$state;
  return !t() && !i();
}, Uc = function() {
  const { error: t } = this.$state;
  return !Ki(t);
}, py = function() {
  const { src: t, hidden: i } = this.$state, { canLoad: r, duration: o } = s(this, Ss).$state;
  i.set(r() && (!t() || a(this, yt, Uc).call(this) || !Number.isFinite(o())));
}, my = function() {
  const { src: t, canPlay: i, error: r } = this.$state;
  t(), i.set(!1), r.set(null);
}, Bc = function(t) {
  const { canPlay: i, error: r } = this.$state;
  i.set(!0), r.set(null), this.dispatch("can-play", { trigger: t });
}, gy = function(t) {
  const { canPlay: i, error: r } = this.$state;
  i.set(!1), r.set(t), this.dispatch("error", { trigger: t });
}, yy = function() {
  const { video: t, canPlay: i } = this.$state, { duration: r } = s(this, Ss).$state, { pointerRate: o } = s(this, lo), h = t();
  i() && h && Number.isFinite(r()) && Number.isFinite(o()) && (h.currentTime = o() * r());
}, y(Eh, "props", {
  src: null,
  crossOrigin: null
}), y(Eh, "state", new la({
  video: null,
  src: null,
  crossOrigin: null,
  canPlay: !1,
  error: null,
  hidden: !1
}));
Wv([
  nt
], Eh.prototype, "video");
var Gv = Object.defineProperty, Kv = Object.getOwnPropertyDescriptor, Qv = (n, e, t, i) => {
  for (var r = Kv(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && Gv(e, t, r), r;
}, ks, _h, co;
class Hu extends Lt {
  constructor() {
    super(...arguments);
    c(this, ks);
    c(this, _h);
    c(this, co);
  }
  onSetup() {
    u(this, co, Co(Vn.state)), u(this, ks, Me(Ea)), u(this, _h, Eo(this.getValueText.bind(this)));
  }
  getValueText() {
    var M, B;
    const {
      type: t,
      format: i,
      decimalPlaces: r,
      padHours: o,
      padMinutes: h,
      showHours: l,
      showMs: d
    } = this.$props, { value: f, pointerValue: p, min: m, max: w } = s(this, co), P = (i == null ? void 0 : i()) ?? s(this, ks).default, k = t() === "current" ? f() : p();
    if (P === "percent") {
      const At = w() - m(), Ut = k / At * 100;
      return (s(this, ks).percent ?? ce)(Ut, r()) + "%";
    } else return P === "time" ? (s(this, ks).time ?? Fu)(k, {
      padHrs: o(),
      padMins: h(),
      showHrs: l(),
      showMs: d()
    }) : (((B = (M = s(this, ks)).value) == null ? void 0 : B.call(M, k)) ?? k.toFixed(2)) + "";
  }
}
ks = new WeakMap(), _h = new WeakMap(), co = new WeakMap(), y(Hu, "props", {
  type: "pointer",
  format: null,
  showHours: !1,
  showMs: !1,
  padHours: null,
  padMinutes: null,
  decimalPlaces: 2
});
Qv([
  _t
], Hu.prototype, "getValueText");
var Vr, uo;
class by extends Lt {
  constructor() {
    super(...arguments);
    c(this, Vr);
    c(this, uo, oa(() => {
      const { disabled: t, orientation: i } = s(this, Vr);
      if (t()) return;
      const r = this.el, { offset: o, noClamp: h } = this.$props;
      r && zv(r, {
        clamp: !h(),
        offset: o(),
        orientation: i()
      });
    }));
  }
  onSetup() {
    u(this, Vr, Me(_u));
    const { active: t } = Co(Vn.state);
    this.setAttributes({
      "data-visible": t
    });
  }
  onAttach(t) {
    Object.assign(t.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(t) {
    const { preview: i } = s(this, Vr);
    i.set(t), it(() => i.set(null)), b(s(this, uo).bind(this));
    const r = new ResizeObserver(s(this, uo).bind(this));
    r.observe(t), it(() => r.disconnect());
  }
}
Vr = new WeakMap(), uo = new WeakMap(), y(by, "props", {
  offset: 0,
  noClamp: !1
});
function zv(n, {
  clamp: e,
  offset: t,
  orientation: i
}) {
  const r = getComputedStyle(n), o = parseFloat(r.width), h = parseFloat(r.height), l = {
    top: null,
    right: null,
    bottom: null,
    left: null
  };
  if (l[i === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${t}px))`, i === "horizontal") {
    const d = o / 2;
    if (!e)
      l.left = `calc(var(--slider-pointer) - ${d}px)`;
    else {
      const f = `max(0px, calc(var(--slider-pointer) - ${d}px))`, p = `calc(100% - ${o}px)`;
      l.left = `min(${f}, ${p})`;
    }
  } else {
    const d = h / 2;
    if (!e)
      l.bottom = `calc(var(--slider-pointer) - ${d}px)`;
    else {
      const f = `max(${d}px, calc(var(--slider-pointer) - ${d}px))`, p = `calc(100% - ${h}px)`;
      l.bottom = `min(${f}, ${p})`;
    }
  }
  Object.assign(n.style, l);
}
var xe, Ft, wy, Ty, $y, vy, Sy, fo, ky, Py, Ey;
class jc extends Lt {
  constructor() {
    super(...arguments);
    c(this, Ft);
    c(this, xe);
    c(this, fo, xo(a(this, Ft, ky).bind(this), 25));
  }
  onSetup() {
    u(this, xe, ue());
    const { audioGain: t } = s(this, xe).$state;
    Qi(Ea, {
      default: "percent",
      value(i) {
        return (i * (t() ?? 1)).toFixed(2);
      },
      percent(i) {
        return Math.round(i * (t() ?? 1));
      }
    }), new Dn({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: a(this, Ft, vy).bind(this),
      aria: {
        valueMax: a(this, Ft, $y).bind(this),
        valueNow: a(this, Ft, wy).bind(this),
        valueText: a(this, Ft, Ty).bind(this)
      },
      onDragValueChange: a(this, Ft, Ey).bind(this),
      onValueChange: a(this, Ft, Py).bind(this)
    }).attach(this), b(a(this, Ft, Sy).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-volume-slider", ""), Vt(t, "aria-label", "Volume");
    const { canSetVolume: i } = s(this, xe).$state;
    this.setAttributes({
      "data-supported": i,
      "aria-hidden": Hn(() => !i())
    });
  }
}
xe = new WeakMap(), Ft = new WeakSet(), wy = function() {
  const { value: t } = this.$state, { audioGain: i } = s(this, xe).$state;
  return Math.round(t() * (i() ?? 1));
}, Ty = function() {
  const { value: t, max: i } = this.$state, { audioGain: r } = s(this, xe).$state;
  return ce(t() / i() * (r() ?? 1) * 100, 2) + "%";
}, $y = function() {
  const { audioGain: t } = s(this, xe).$state;
  return this.$state.max() * (t() ?? 1);
}, vy = function() {
  const { disabled: t } = this.$props, { canSetVolume: i } = s(this, xe).$state;
  return t() || !i();
}, Sy = function() {
  const { muted: t, volume: i } = s(this, xe).$state, r = t() ? 0 : i() * 100;
  this.$state.value.set(r), this.dispatch("value-change", { detail: r });
}, fo = new WeakMap(), ky = function(t) {
  if (!t.trigger) return;
  const i = ce(t.detail / 100, 3);
  s(this, xe).remote.changeVolume(i, t);
}, Py = function(t) {
  s(this, fo).call(this, t);
}, Ey = function(t) {
  s(this, fo).call(this, t);
}, y(jc, "props", {
  ...Dn.props,
  keyStep: 5,
  shiftKeyMultiplier: 2
}), y(jc, "state", il);
var mt, Nr, po, x, Cy, xy, Ay, My, Ly, Wc, Iy, Fr, Ry, qy, Gc, Oy, Kc, Dy, Vy, Ny, Fy, _y, Hy, Gs, Uy, By, jy;
class Ch extends Lt {
  constructor() {
    super();
    c(this, x);
    c(this, mt);
    c(this, Nr);
    c(this, po, V(null));
    c(this, Fr, !1);
    const { noSwipeGesture: t } = this.$props;
    new Dn({
      swipeGesture: () => !t(),
      getValue: a(this, x, Kc).bind(this),
      getStep: a(this, x, Dy).bind(this),
      getKeyStep: a(this, x, Vy).bind(this),
      roundValue: a(this, x, Ny),
      isDisabled: a(this, x, Fy).bind(this),
      aria: {
        valueNow: a(this, x, _y).bind(this),
        valueText: a(this, x, Hy).bind(this)
      },
      onDragStart: a(this, x, Ry).bind(this),
      onDragValueChange: a(this, x, qy).bind(this),
      onDragEnd: a(this, x, Gc).bind(this),
      onValueChange: a(this, x, Oy).bind(this)
    });
  }
  onSetup() {
    u(this, mt, ue()), Qi(Ea, {
      default: "time",
      value: a(this, x, By).bind(this),
      time: a(this, x, jy).bind(this)
    }), this.setAttributes({
      "data-chapters": a(this, x, xy).bind(this)
    }), this.setStyles({
      "--slider-progress": a(this, x, Cy).bind(this)
    }), b(a(this, x, My).bind(this)), b(a(this, x, Ay).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-time-slider", ""), Vt(t, "aria-label", "Seek");
  }
  onConnect(t) {
    b(a(this, x, Ly).bind(this)), hf(s(this, mt).textTracks, "chapters", s(this, po).set);
  }
}
mt = new WeakMap(), Nr = new WeakMap(), po = new WeakMap(), x = new WeakSet(), Cy = function() {
  const { bufferedEnd: t, duration: i } = s(this, mt).$state;
  return ce(Math.min(t() / Math.max(i(), 1), 1) * 100, 3) + "%";
}, xy = function() {
  var i;
  const { duration: t } = s(this, mt).$state;
  return ((i = s(this, po).call(this)) == null ? void 0 : i.cues.length) && Number.isFinite(t()) && t() > 0;
}, Ay = function() {
  u(this, Nr, xo(
    a(this, x, Wc).bind(this),
    this.$props.seekingRequestThrottle()
  ));
}, My = function() {
  if (this.$state.hidden()) return;
  const { value: t, dragging: i } = this.$state, r = a(this, x, Kc).call(this);
  v(i) || (t.set(r), this.dispatch("value-change", { detail: r }));
}, Ly = function() {
  const t = s(this, mt).player.el, { preview: i } = Me(_u);
  t && i() && W(t, "data-preview", this.$state.active());
}, Wc = function(t, i) {
  s(this, mt).remote.seeking(t, i);
}, Iy = function(t, i, r) {
  s(this, Nr).cancel();
  const { live: o } = s(this, mt).$state;
  if (o() && i >= 99) {
    s(this, mt).remote.seekToLiveEdge(r);
    return;
  }
  s(this, mt).remote.seek(t, r);
}, Fr = new WeakMap(), Ry = function(t) {
  const { pauseWhileDragging: i } = this.$props;
  if (i()) {
    const { paused: r } = s(this, mt).$state;
    u(this, Fr, !r()), s(this, mt).remote.pause(t);
  }
}, qy = function(t) {
  s(this, Nr).call(this, a(this, x, Gs).call(this, t.detail), t);
}, Gc = function(t) {
  const { seeking: i } = s(this, mt).$state;
  v(i) || a(this, x, Wc).call(this, a(this, x, Gs).call(this, t.detail), t);
  const r = t.detail;
  a(this, x, Iy).call(this, a(this, x, Gs).call(this, r), r, t);
  const { pauseWhileDragging: o } = this.$props;
  o() && s(this, Fr) && (s(this, mt).remote.play(t), u(this, Fr, !1));
}, Oy = function(t) {
  const { dragging: i } = this.$state;
  i() || !t.trigger || a(this, x, Gc).call(this, t);
}, // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
Kc = function() {
  const { currentTime: t } = s(this, mt).$state;
  return a(this, x, Uy).call(this, t());
}, Dy = function() {
  const t = this.$props.step() / s(this, mt).$state.duration() * 100;
  return Number.isFinite(t) ? t : 1;
}, Vy = function() {
  const t = this.$props.keyStep() / s(this, mt).$state.duration() * 100;
  return Number.isFinite(t) ? t : 1;
}, Ny = function(t) {
  return ce(t, 3);
}, Fy = function() {
  const { disabled: t } = this.$props, { canSeek: i } = s(this, mt).$state;
  return t() || !i();
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
_y = function() {
  const { value: t } = this.$state;
  return Math.round(t());
}, Hy = function() {
  const t = a(this, x, Gs).call(this, this.$state.value()), { duration: i } = s(this, mt).$state;
  return Number.isFinite(t) ? `${cd(t)} out of ${cd(i())}` : "live";
}, // -------------------------------------------------------------------------------------------
// Format
// -------------------------------------------------------------------------------------------
Gs = function(t) {
  const { duration: i } = s(this, mt).$state;
  return ce(t / 100 * i(), 5);
}, Uy = function(t) {
  const { liveEdge: i, duration: r } = s(this, mt).$state, o = Math.max(0, Math.min(1, i() ? 1 : Math.min(t, r()) / r()));
  return Number.isNaN(o) ? 0 : Number.isFinite(o) ? o * 100 : 100;
}, By = function(t) {
  const i = a(this, x, Gs).call(this, t), { live: r, duration: o } = s(this, mt).$state;
  return Number.isFinite(i) ? (r() ? i - o() : i).toFixed(0) : "LIVE";
}, jy = function(t, i) {
  const r = a(this, x, Gs).call(this, t), { live: o, duration: h } = s(this, mt).$state, l = o() ? r - h() : r;
  return Number.isFinite(r) ? `${l < 0 ? "-" : ""}${Fu(Math.abs(l), i)}` : "LIVE";
}, y(Ch, "props", {
  ...Dn.props,
  step: 0.1,
  keyStep: 5,
  shiftKeyMultiplier: 2,
  pauseWhileDragging: !1,
  noSwipeGesture: !1,
  seekingRequestThrottle: 100
}), y(Ch, "state", il);
var Yv = Object.defineProperty, Xv = Object.getOwnPropertyDescriptor, sl = (n, e, t, i) => {
  for (var r = Xv(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && Yv(e, t, r), r;
}, re, Sn, _r, ii, Zt, kn, te, Fi, Pn, Ps, A, Qc, zc, Wy, Gy, Ky, Qy, zy, rh, Yc, Xc, Yy, Hh, Uh, Xy, ah, oh, Jy, Zy, tb, eb, mo, ib, sb, nb;
class da extends Lt {
  constructor() {
    super(...arguments);
    c(this, A);
    c(this, re);
    c(this, Sn);
    c(this, _r);
    c(this, ii, null);
    c(this, Zt, []);
    c(this, kn, V(null));
    c(this, te, V([]));
    c(this, Fi, V(-1));
    c(this, Pn, V(-1));
    c(this, Ps, 0);
    c(this, Hh, oa((t) => {
      var d;
      let i, r = s(this, te).call(this), { seekableStart: o } = s(this, re).$state, h = o(), l = a(this, A, ah).call(this, r);
      for (let f = s(this, Ps); f < s(this, Zt).length; f++)
        if (i = a(this, A, oh).call(this, r[f], t, h, l), (d = s(this, Zt)[f]) == null || d.style.setProperty("--chapter-progress", i + "%"), i < 100) {
          u(this, Ps, f);
          break;
        }
    }));
    c(this, Uh, Eo(a(this, A, Xy).bind(this)));
    c(this, mo, Ou(
      () => {
        const t = v(s(this, kn));
        !this.scope || !t || !t.cues.length || (s(this, te).set(a(this, A, Jy).call(this, t.cues)), s(this, Fi).set(0), u(this, Ps, 0));
      },
      150,
      !0
    ));
  }
  get cues() {
    return s(this, te).call(this);
  }
  get activeCue() {
    return s(this, te).call(this)[s(this, Fi).call(this)] || null;
  }
  get activePointerCue() {
    return s(this, te).call(this)[s(this, Pn).call(this)] || null;
  }
  onSetup() {
    u(this, re, ue()), u(this, Sn, Co(Ch.state));
  }
  onAttach(t) {
    hf(s(this, re).textTracks, "chapters", a(this, A, Qc).bind(this)), b(a(this, A, Zy).bind(this));
  }
  onConnect() {
    it(() => a(this, A, zc).bind(this));
  }
  onDestroy() {
    a(this, A, Qc).call(this, null);
  }
  setRefs(t) {
    var i;
    if (u(this, Zt, t), (i = s(this, _r)) == null || i.dispose(), s(this, Zt).length === 1) {
      const r = s(this, Zt)[0];
      r.style.width = "100%", r.style.setProperty("--chapter-fill", "var(--slider-fill)"), r.style.setProperty("--chapter-progress", "var(--slider-progress)");
    } else s(this, Zt).length > 0 && Ke(() => a(this, A, Wy).call(this), u(this, _r, yh()));
  }
}
re = new WeakMap(), Sn = new WeakMap(), _r = new WeakMap(), ii = new WeakMap(), Zt = new WeakMap(), kn = new WeakMap(), te = new WeakMap(), Fi = new WeakMap(), Pn = new WeakMap(), Ps = new WeakMap(), A = new WeakSet(), Qc = function(t) {
  v(s(this, kn)) !== t && (a(this, A, zc).call(this), s(this, kn).set(t));
}, zc = function() {
  var t;
  u(this, Zt, []), s(this, te).set([]), s(this, Fi).set(-1), s(this, Pn).set(-1), u(this, Ps, 0), (t = s(this, _r)) == null || t.dispose();
}, Wy = function() {
  s(this, Zt).length && b(a(this, A, Gy).bind(this));
}, Gy = function() {
  const { hidden: t } = s(this, Sn);
  t() || (b(a(this, A, Ky).bind(this)), b(a(this, A, Qy).bind(this)), b(a(this, A, zy).bind(this)), b(a(this, A, Yy).bind(this)));
}, Ky = function() {
  const t = s(this, te).call(this);
  if (!t.length) return;
  let i, { seekableStart: r, seekableEnd: o } = s(this, re).$state, h = r(), l = o() || t[t.length - 1].endTime, d = l - h, f = 100;
  for (let p = 0; p < t.length; p++)
    if (i = t[p], s(this, Zt)[p]) {
      const m = p === t.length - 1 ? f : ce((i.endTime - Math.max(h, i.startTime)) / d * 100, 3);
      s(this, Zt)[p].style.width = m + "%", f -= m;
    }
}, Qy = function() {
  let { liveEdge: t, seekableStart: i, seekableEnd: r } = s(this, re).$state, { fillPercent: o, value: h } = s(this, Sn), l = s(this, te).call(this), d = t(), f = v(s(this, Fi)), p = l[f], m = d ? s(this, te).length - 1 : a(this, A, Xc).call(this, p && p.startTime / r() * 100 <= v(h) ? f : 0, o());
  d || !p ? a(this, A, rh).call(this, 0, l.length, 100) : m > f ? a(this, A, rh).call(this, f, m, 100) : m < f && a(this, A, rh).call(this, m + 1, f + 1, 0);
  const w = d ? 100 : a(this, A, oh).call(this, l[m], o(), i(), a(this, A, ah).call(this, l));
  a(this, A, Yc).call(this, s(this, Zt)[m], w), s(this, Fi).set(m);
}, zy = function() {
  let { hidden: t, pointerPercent: i } = s(this, Sn);
  if (t()) {
    s(this, Pn).set(-1);
    return;
  }
  const r = a(this, A, Xc).call(this, 0, i());
  s(this, Pn).set(r);
}, rh = function(t, i, r) {
  for (let o = t; o < i; o++) a(this, A, Yc).call(this, s(this, Zt)[o], r);
}, Yc = function(t, i) {
  t && (t.style.setProperty("--chapter-fill", i + "%"), W(t, "data-active", i > 0 && i < 100), W(t, "data-ended", i === 100));
}, Xc = function(t, i) {
  let r = 0, o = s(this, te).call(this);
  if (i === 0) return 0;
  if (i === 100) return o.length - 1;
  let { seekableStart: h } = s(this, re).$state, l = h(), d = a(this, A, ah).call(this, o);
  for (let f = t; f < o.length; f++)
    if (r = a(this, A, oh).call(this, o[f], i, l, d), r >= 0 && r < 100) return f;
  return 0;
}, Yy = function() {
  s(this, Hh).call(this, s(this, Uh).call(this));
}, Hh = new WeakMap(), Uh = new WeakMap(), Xy = function() {
  const { bufferedEnd: t, duration: i } = s(this, re).$state;
  return ce(Math.min(t() / Math.max(i(), 1), 1), 3) * 100;
}, ah = function(t) {
  var o;
  const { seekableEnd: i } = s(this, re).$state, r = i();
  return Number.isFinite(r) ? r : ((o = t[t.length - 1]) == null ? void 0 : o.endTime) || 0;
}, oh = function(t, i, r, o) {
  if (!t || s(this, te).call(this).length === 0) return 0;
  const l = o - r, d = Math.max(0, t.startTime - r), f = Math.min(o, t.endTime) - r, p = d / l, m = p * 100, w = Math.min(1, p + (f - d) / l) * 100;
  return Math.max(
    0,
    ce(
      i >= w ? 100 : (i - m) / (w - m) * 100,
      3
    )
  );
}, Jy = function(t) {
  let i = [], { seekableStart: r, seekableEnd: o, duration: h } = s(this, re).$state, l = r(), d = o();
  t = t.filter((m) => m.startTime <= d && m.endTime >= l);
  const f = t[0];
  f && f.startTime > l && i.push(new window.VTTCue(l, f.startTime, ""));
  for (let m = 0; m < t.length - 1; m++) {
    const w = t[m], P = t[m + 1];
    if (i.push(w), P) {
      const k = P.startTime - w.endTime;
      k > 0 && i.push(new window.VTTCue(w.endTime, w.endTime + k, ""));
    }
  }
  const p = t[t.length - 1];
  if (p) {
    i.push(p);
    const m = h();
    m >= 0 && m - p.endTime > 1 && i.push(new window.VTTCue(p.endTime, h(), ""));
  }
  return i;
}, Zy = function() {
  const { source: t } = s(this, re).$state;
  t(), a(this, A, tb).call(this);
}, tb = function() {
  if (!this.scope) return;
  const { disabled: t } = this.$props;
  if (t()) {
    s(this, te).set([]), s(this, Fi).set(0), u(this, Ps, 0);
    return;
  }
  const i = s(this, kn).call(this);
  if (i) {
    const r = s(this, mo).bind(this);
    r(), new dt(i).add("add-cue", r).add("remove-cue", r), b(a(this, A, eb).bind(this));
  }
  return u(this, ii, a(this, A, nb).call(this)), s(this, ii) && b(a(this, A, ib).bind(this)), () => {
    s(this, ii) && (s(this, ii).textContent = "", u(this, ii, null));
  };
}, eb = function() {
  s(this, re).$state.duration(), s(this, mo).call(this);
}, mo = new WeakMap(), ib = function() {
  const t = this.activePointerCue || this.activeCue;
  s(this, ii) && (s(this, ii).textContent = (t == null ? void 0 : t.text) || "");
}, sb = function() {
  let t = this.el;
  for (; t && t.getAttribute("role") !== "slider"; )
    t = t.parentElement;
  return t;
}, nb = function() {
  const t = a(this, A, sb).call(this);
  return t ? t.querySelector('[data-part="chapter-title"]') : null;
}, y(da, "props", {
  disabled: !1
});
sl([
  nt
], da.prototype, "cues");
sl([
  nt
], da.prototype, "activeCue");
sl([
  nt
], da.prototype, "activePointerCue");
sl([
  _t
], da.prototype, "setRefs");
const Os = ha(), wd = (n) => typeof n == "object" && n != null && n.nodeType === 1, Td = (n, e) => (!e || n !== "hidden") && n !== "visible" && n !== "clip", Uo = (n, e) => {
  if (n.clientHeight < n.scrollHeight || n.clientWidth < n.scrollWidth) {
    const t = getComputedStyle(n, null);
    return Td(t.overflowY, e) || Td(t.overflowX, e) || ((i) => {
      const r = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView) return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(i);
      return !!r && (r.clientHeight < i.scrollHeight || r.clientWidth < i.scrollWidth);
    })(n);
  }
  return !1;
}, Bo = (n, e, t, i, r, o, h, l) => o < n && h > e || o > n && h < e ? 0 : o <= n && l <= t || h >= e && l >= t ? o - n - i : h > e && l < t || o < n && l > t ? h - e + r : 0, Jv = (n) => {
  const e = n.parentElement;
  return e ?? (n.getRootNode().host || null);
}, Zv = (n, e) => {
  var t, i, r, o;
  if (typeof document > "u") return [];
  const { scrollMode: h, block: l, inline: d, boundary: f, skipOverflowHiddenElements: p } = e, m = typeof f == "function" ? f : (wt) => wt !== f;
  if (!wd(n)) throw new TypeError("Invalid target");
  const w = document.scrollingElement || document.documentElement, P = [];
  let k = n;
  for (; wd(k) && m(k); ) {
    if (k = Jv(k), k === w) {
      P.push(k);
      break;
    }
    k != null && k === document.body && Uo(k) && !Uo(document.documentElement) || k != null && Uo(k, p) && P.push(k);
  }
  const M = (i = (t = window.visualViewport) == null ? void 0 : t.width) != null ? i : innerWidth, B = (o = (r = window.visualViewport) == null ? void 0 : r.height) != null ? o : innerHeight, { scrollX: At, scrollY: Ut } = window, { height: Xt, width: se, top: Oe, right: De, bottom: de, left: E } = n.getBoundingClientRect(), { top: bt, right: It, bottom: bi, left: Xi } = ((wt) => {
    const et = window.getComputedStyle(wt);
    return { top: parseFloat(et.scrollMarginTop) || 0, right: parseFloat(et.scrollMarginRight) || 0, bottom: parseFloat(et.scrollMarginBottom) || 0, left: parseFloat(et.scrollMarginLeft) || 0 };
  })(n);
  let Qt = l === "start" || l === "nearest" ? Oe - bt : l === "end" ? de + bi : Oe + Xt / 2 - bt + bi, qt = d === "center" ? E + se / 2 - Xi + It : d === "end" ? De + It : E - Xi;
  const Ji = [];
  for (let wt = 0; wt < P.length; wt++) {
    const et = P[wt], { height: Ve, width: Bs, top: wi, right: Bn, bottom: ol, left: Io } = et.getBoundingClientRect();
    if (h === "if-needed" && Oe >= 0 && E >= 0 && de <= B && De <= M && (et === w && !Uo(et) || Oe >= wi && de <= ol && E >= Io && De <= Bn)) return Ji;
    const Ro = getComputedStyle(et), qo = parseInt(Ro.borderLeftWidth, 10), Oo = parseInt(Ro.borderTopWidth, 10), Do = parseInt(Ro.borderRightWidth, 10), Vo = parseInt(Ro.borderBottomWidth, 10);
    let Zi = 0, ts = 0;
    const No = "offsetWidth" in et ? et.offsetWidth - et.clientWidth - qo - Do : 0, Fo = "offsetHeight" in et ? et.offsetHeight - et.clientHeight - Oo - Vo : 0, hl = "offsetWidth" in et ? et.offsetWidth === 0 ? 0 : Bs / et.offsetWidth : 0, ll = "offsetHeight" in et ? et.offsetHeight === 0 ? 0 : Ve / et.offsetHeight : 0;
    if (w === et) Zi = l === "start" ? Qt : l === "end" ? Qt - B : l === "nearest" ? Bo(Ut, Ut + B, B, Oo, Vo, Ut + Qt, Ut + Qt + Xt, Xt) : Qt - B / 2, ts = d === "start" ? qt : d === "center" ? qt - M / 2 : d === "end" ? qt - M : Bo(At, At + M, M, qo, Do, At + qt, At + qt + se, se), Zi = Math.max(0, Zi + Ut), ts = Math.max(0, ts + At);
    else {
      Zi = l === "start" ? Qt - wi - Oo : l === "end" ? Qt - ol + Vo + Fo : l === "nearest" ? Bo(wi, ol, Ve, Oo, Vo + Fo, Qt, Qt + Xt, Xt) : Qt - (wi + Ve / 2) + Fo / 2, ts = d === "start" ? qt - Io - qo : d === "center" ? qt - (Io + Bs / 2) + No / 2 : d === "end" ? qt - Bn + Do + No : Bo(Io, Bn, Bs, qo, Do + No, qt, qt + se, se);
      const { scrollLeft: Ku, scrollTop: Qu } = et;
      Zi = ll === 0 ? 0 : Math.max(0, Math.min(Qu + Zi / ll, et.scrollHeight - Ve / ll + Fo)), ts = hl === 0 ? 0 : Math.max(0, Math.min(Ku + ts / hl, et.scrollWidth - Bs / hl + No)), Qt += Qu - Zi, qt += Ku - ts;
    }
    Ji.push({ el: et, top: Zi, left: ts });
  }
  return Ji;
};
function tS(n, e) {
  const t = Zv(n, e);
  for (const { el: i, top: r, left: o } of t)
    i.scroll({ top: r, left: o, behavior: e.behavior });
}
function eS(n, e = {}) {
  tS(n, {
    scrollMode: "if-needed",
    block: "center",
    inline: "center",
    ...e
  });
}
const iS = /* @__PURE__ */ [
  "a[href]",
  "[tabindex]",
  "input",
  "select",
  "button"
].map((n) => `${n}:not([aria-hidden='true'])`).join(","), sS = /* @__PURE__ */ new Set([
  "Escape",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "PageUp",
  "End",
  "PageDown",
  "Enter",
  " "
]);
var Es, je, ae, go, ct, Ks, Jc, rb, Zc, ab, ob, hh, hb;
class nS {
  constructor(e) {
    c(this, ct);
    c(this, Es, -1);
    c(this, je, null);
    c(this, ae, []);
    c(this, go);
    u(this, go, e);
  }
  get items() {
    return s(this, ae);
  }
  attachMenu(e) {
    ft(e, "focus", a(this, ct, rb).bind(this)), u(this, je, e), it(() => {
      u(this, je, null);
    });
  }
  listen() {
    s(this, je) && (this.update(), new dt(s(this, je)).add("keyup", a(this, ct, ab).bind(this)).add("keydown", a(this, ct, ob).bind(this)), it(() => {
      u(this, Es, -1), u(this, ae, []);
    }));
  }
  update() {
    u(this, Es, 0), u(this, ae, a(this, ct, hb).call(this));
  }
  scroll(e = a(this, ct, Jc).call(this)) {
    const t = s(this, ae)[e];
    t && requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        eS(t, {
          behavior: "smooth",
          boundary: (i) => !i.hasAttribute("data-root")
        });
      });
    });
  }
  focusActive(e = !0) {
    const t = a(this, ct, Jc).call(this);
    a(this, ct, Ks).call(this, t >= 0 ? t : 0, e);
  }
}
Es = new WeakMap(), je = new WeakMap(), ae = new WeakMap(), go = new WeakMap(), ct = new WeakSet(), Ks = function(e, t = !0) {
  var i;
  u(this, Es, e), s(this, ae)[e] ? (s(this, ae)[e].focus({ preventScroll: !0 }), t && this.scroll(e)) : (i = s(this, je)) == null || i.focus({ preventScroll: !0 });
}, Jc = function() {
  return s(this, ae).findIndex(
    (e) => document.activeElement === e || e.getAttribute("role") === "menuitemradio" && e.getAttribute("aria-checked") === "true"
  );
}, rb = function() {
  s(this, Es) >= 0 || (this.update(), this.focusActive());
}, Zc = function(e) {
  const t = e.target;
  if (wT(e) && t instanceof Element) {
    const i = t.getAttribute("role");
    return !/a|input|select|button/.test(t.localName) && !i;
  }
  return sS.has(e.key);
}, ab = function(e) {
  a(this, ct, Zc).call(this, e) && (e.stopPropagation(), e.preventDefault());
}, ob = function(e) {
  if (a(this, ct, Zc).call(this, e))
    switch (e.stopPropagation(), e.preventDefault(), e.key) {
      case "Escape":
        s(this, go).closeMenu(e);
        break;
      case "Tab":
        a(this, ct, Ks).call(this, a(this, ct, hh).call(this, e.shiftKey ? -1 : 1));
        break;
      case "ArrowUp":
        a(this, ct, Ks).call(this, a(this, ct, hh).call(this, -1));
        break;
      case "ArrowDown":
        a(this, ct, Ks).call(this, a(this, ct, hh).call(this, 1));
        break;
      case "Home":
      case "PageUp":
        a(this, ct, Ks).call(this, 0);
        break;
      case "End":
      case "PageDown":
        a(this, ct, Ks).call(this, s(this, ae).length - 1);
        break;
    }
}, hh = function(e) {
  var i;
  let t = s(this, Es);
  do
    t = (t + e + s(this, ae).length) % s(this, ae).length;
  while (((i = s(this, ae)[t]) == null ? void 0 : i.offsetParent) === null);
  return t;
}, hb = function() {
  if (!s(this, je)) return [];
  const e = s(this, je).querySelectorAll(iS), t = [], i = (r) => r.getAttribute("role") === "menu";
  for (const r of e)
    $h(r) && r.offsetParent !== null && // does not have display: none
    yf(s(this, je), r, i) && t.push(r);
  return t;
};
var rS = Object.defineProperty, aS = Object.getOwnPropertyDescriptor, Mo = (n, e, t, i) => {
  for (var r = aS(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && rS(e, t, r), r;
};
let oS = 0;
var We, Hr, Ur, ee, yo, si, Dt, Cs, xs, En, Cn, _i, xn, bo, An, I, lb, cb, ub, db, fb, tu, pb, Br, mb, eu, gb, $a, yb, bb, wb, Tb, $b, vb, Bh, Sb, jr, jh, kb, Wh, Pb, Wr, Gr, Eb;
class fa extends Lt {
  constructor() {
    super();
    c(this, I);
    c(this, We);
    c(this, Hr);
    c(this, Ur);
    c(this, ee, V(!1));
    c(this, yo, V(!1));
    c(this, si, V(null));
    c(this, Dt, V(null));
    c(this, Cs);
    c(this, xs, /* @__PURE__ */ new Set());
    c(this, En, null);
    c(this, Cn);
    c(this, _i);
    c(this, xn, !1);
    c(this, bo, V(!1));
    c(this, An, /* @__PURE__ */ new Set());
    c(this, Br, !1);
    c(this, Bh, a(this, I, Sb).bind(this));
    c(this, jr, !1);
    c(this, jh, a(this, I, kb).bind(this));
    c(this, Wh, a(this, I, Pb).bind(this));
    c(this, Wr, oa(() => {
      const t = v(s(this, Dt));
      if (!t) return;
      let i = 0, r = getComputedStyle(t), o = [...t.children];
      for (const h of ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"])
        i += parseFloat(r[h]) || 0;
      for (const h of o)
        if ($h(h) && h.style.display === "contents")
          o.push(...h.children);
        else if (h.nodeType === 3)
          i += parseFloat(getComputedStyle(h).fontSize);
        else if ($h(h)) {
          if (!mf(h)) continue;
          const l = getComputedStyle(h);
          i += h.offsetHeight + (parseFloat(l.marginTop) || 0) + (parseFloat(l.marginBottom) || 0);
        }
      Vs(t, "--menu-height", i + "px");
    }));
    c(this, Gr, !1);
    const { showDelay: t } = this.$props;
    u(this, Cn, new qv({
      trigger: s(this, si),
      content: s(this, Dt),
      showDelay: t,
      listen: (i, r, o) => {
        ea(i, (l) => {
          s(this, ee).call(this) ? o(l) : r(l);
        });
        const h = a(this, I, Tb).call(this);
        h && ea(h, (l) => {
          l.stopPropagation(), o(l);
        });
      },
      onChange: a(this, I, mb).bind(this)
    }));
  }
  get triggerElement() {
    return s(this, si).call(this);
  }
  get contentElement() {
    return s(this, Dt).call(this);
  }
  get isSubmenu() {
    return !!s(this, Cs);
  }
  onSetup() {
    u(this, We, ue());
    const t = ++oS;
    u(this, Hr, `media-menu-${t}`), u(this, Ur, `media-menu-button-${t}`), u(this, _i, new nS({
      closeMenu: this.close.bind(this)
    })), On(Os) && u(this, Cs, Me(Os)), a(this, I, lb).call(this), this.setAttributes({
      "data-open": s(this, ee),
      "data-root": !this.isSubmenu,
      "data-submenu": this.isSubmenu,
      "data-disabled": a(this, I, $a).bind(this)
    }), Qi(Os, {
      button: s(this, si),
      content: s(this, Dt),
      expanded: s(this, ee),
      hint: V(""),
      submenu: !!s(this, Cs),
      disable: a(this, I, yb).bind(this),
      attachMenuButton: a(this, I, ub).bind(this),
      attachMenuItems: a(this, I, db).bind(this),
      attachObserver: a(this, I, fb).bind(this),
      disableMenuButton: a(this, I, pb).bind(this),
      addSubmenu: a(this, I, vb).bind(this),
      onTransitionEvent: (i) => {
        s(this, An).add(i), it(() => {
          s(this, An).delete(i);
        });
      }
    });
  }
  onAttach(t) {
    t.style.setProperty("display", "contents");
  }
  onConnect(t) {
    var i;
    b(a(this, I, cb).bind(this)), this.isSubmenu && ((i = s(this, Cs)) == null || i.addSubmenu(this));
  }
  onDestroy() {
    s(this, si).set(null), s(this, Dt).set(null), u(this, En, null), s(this, An).clear();
  }
  open(t) {
    v(s(this, ee)) || (s(this, Cn).show(t), Gi());
  }
  close(t) {
    v(s(this, ee)) && (s(this, Cn).hide(t), Gi());
  }
}
We = new WeakMap(), Hr = new WeakMap(), Ur = new WeakMap(), ee = new WeakMap(), yo = new WeakMap(), si = new WeakMap(), Dt = new WeakMap(), Cs = new WeakMap(), xs = new WeakMap(), En = new WeakMap(), Cn = new WeakMap(), _i = new WeakMap(), xn = new WeakMap(), bo = new WeakMap(), An = new WeakMap(), I = new WeakSet(), lb = function() {
  let t = -1, i = On(Pa) ? Me(Pa) : null;
  Qi(Pa, {
    onDragStart: () => {
      var r;
      (r = i == null ? void 0 : i.onDragStart) == null || r.call(i), window.clearTimeout(t), t = -1, u(this, xn, !0);
    },
    onDragEnd: () => {
      var r;
      (r = i == null ? void 0 : i.onDragEnd) == null || r.call(i), t = window.setTimeout(() => {
        u(this, xn, !1), t = -1;
      }, 300);
    }
  });
}, cb = function() {
  const t = a(this, I, gb).call(this);
  this.isSubmenu || s(this, Wr).call(this), a(this, I, tu).call(this, t), t && (b(() => {
    const { height: i } = s(this, We).$state, r = s(this, Dt).call(this);
    r && Vs(r, "--player-height", i() + "px");
  }), s(this, _i).listen(), this.listen("pointerup", a(this, I, bb).bind(this)), ft(window, "pointerup", a(this, I, wb).bind(this)));
}, ub = function(t) {
  const i = t.el, r = this.isSubmenu, o = Hn(a(this, I, $a).bind(this));
  Vt(i, "tabindex", r ? "-1" : "0"), Vt(i, "role", r ? "menuitem" : "button"), W(i, "id", s(this, Ur)), W(i, "aria-haspopup", "menu"), W(i, "aria-expanded", "false"), W(i, "data-root", !this.isSubmenu), W(i, "data-submenu", this.isSubmenu), b(() => {
    W(i, "data-open", s(this, ee).call(this)), W(i, "aria-disabled", o());
  }), s(this, si).set(i), it(() => {
    s(this, si).set(null);
  });
}, db = function(t) {
  var h;
  const i = t.el;
  i.style.setProperty("display", "none"), W(i, "id", s(this, Hr)), Vt(i, "role", "menu"), Vt(i, "tabindex", "-1"), W(i, "data-root", !this.isSubmenu), W(i, "data-submenu", this.isSubmenu), s(this, Dt).set(i), it(() => s(this, Dt).set(null)), b(() => W(i, "data-open", s(this, ee).call(this))), s(this, _i).attachMenu(i), a(this, I, tu).call(this, !1);
  const o = a(this, I, Eb).bind(this);
  this.isSubmenu ? (h = s(this, Cs)) == null || h.onTransitionEvent(o) : (t.listen("transitionstart", o), t.listen("transitionend", o), t.listen("animationend", s(this, Wr)), t.listen("vds-menu-resize", s(this, Wr)));
}, fb = function(t) {
  u(this, En, t);
}, tu = function(t) {
  const i = v(s(this, Dt));
  i && W(i, "aria-hidden", wh(!t));
}, pb = function(t) {
  s(this, bo).set(t);
}, Br = new WeakMap(), mb = function(t, i) {
  var h, l, d, f, p, m;
  if (u(this, Br, Yh(i)), i == null || i.stopPropagation(), s(this, ee).call(this) === t) return;
  if (a(this, I, $a).call(this)) {
    t && s(this, Cn).hide(i);
    return;
  }
  (h = this.el) == null || h.dispatchEvent(
    new Event("vds-menu-resize", {
      bubbles: !0,
      composed: !0
    })
  );
  const r = s(this, si).call(this), o = s(this, Dt).call(this);
  if (r && (W(r, "aria-controls", t && s(this, Hr)), W(r, "aria-expanded", wh(t))), o && W(o, "aria-labelledby", t && s(this, Ur)), s(this, ee).set(t), a(this, I, $b).call(this, i), Gi(), s(this, Br)) {
    t ? o == null || o.focus() : r == null || r.focus();
    for (const w of [this.el, o])
      w && w.setAttribute("data-keyboard", "");
  } else
    for (const w of [this.el, o])
      w && w.removeAttribute("data-keyboard");
  if (this.dispatch(t ? "open" : "close", { trigger: i }), t)
    !this.isSubmenu && s(this, We).activeMenu !== this && ((l = s(this, We).activeMenu) == null || l.close(i), s(this, We).activeMenu = this), (f = (d = s(this, En)) == null ? void 0 : d.onOpen) == null || f.call(d, i);
  else {
    if (this.isSubmenu)
      for (const w of s(this, xs)) w.close(i);
    else
      s(this, We).activeMenu = null;
    (m = (p = s(this, En)) == null ? void 0 : p.onClose) == null || m.call(p, i);
  }
  t && requestAnimationFrame(a(this, I, eu).bind(this));
}, eu = function() {
  s(this, Gr) || s(this, jr) || (s(this, _i).update(), requestAnimationFrame(() => {
    s(this, Br) ? s(this, _i).focusActive() : s(this, _i).scroll();
  }));
}, gb = function() {
  return !a(this, I, $a).call(this) && s(this, ee).call(this);
}, $a = function() {
  return s(this, yo).call(this) || s(this, bo).call(this);
}, yb = function(t) {
  s(this, yo).set(t);
}, bb = function(t) {
  const i = s(this, Dt).call(this);
  s(this, xn) || i && nd(i, t) || t.stopPropagation();
}, wb = function(t) {
  const i = s(this, Dt).call(this);
  s(this, xn) || i && nd(i, t) || this.close(t);
}, Tb = function() {
  var i;
  const t = (i = this.el) == null ? void 0 : i.querySelector('[data-part="close-target"]');
  return this.el && t && yf(this.el, t, (r) => r.getAttribute("role") === "menu") ? t : null;
}, $b = function(t) {
  this.isSubmenu || (s(this, ee).call(this) ? s(this, We).remote.pauseControls(t) : s(this, We).remote.resumeControls(t));
}, vb = function(t) {
  s(this, xs).add(t), new dt(t).add("open", s(this, jh)).add("close", s(this, Wh)), it(s(this, Bh));
}, Bh = new WeakMap(), Sb = function(t) {
  s(this, xs).delete(t);
}, jr = new WeakMap(), jh = new WeakMap(), kb = function(t) {
  var r;
  u(this, jr, !0);
  const i = s(this, Dt).call(this);
  this.isSubmenu && ((r = this.triggerElement) == null || r.setAttribute("aria-hidden", "true"));
  for (const o of s(this, xs))
    if (o !== t.target)
      for (const h of [o.el, o.triggerElement])
        h == null || h.setAttribute("aria-hidden", "true");
  if (i) {
    const o = t.target.el;
    for (const h of i.children)
      h.contains(o) ? h.setAttribute("data-open", "") : h !== o && h.setAttribute("data-hidden", "");
  }
}, Wh = new WeakMap(), Pb = function(t) {
  var r;
  u(this, jr, !1);
  const i = s(this, Dt).call(this);
  this.isSubmenu && ((r = this.triggerElement) == null || r.setAttribute("aria-hidden", "false"));
  for (const o of s(this, xs))
    for (const h of [o.el, o.triggerElement])
      h == null || h.setAttribute("aria-hidden", "false");
  if (i)
    for (const o of i.children)
      o.removeAttribute("data-open"), o.removeAttribute("data-hidden");
}, Wr = new WeakMap(), Gr = new WeakMap(), Eb = function(t) {
  const i = s(this, Dt).call(this);
  i && t.propertyName === "height" && (u(this, Gr, t.type === "transitionstart"), W(i, "data-transition", s(this, Gr) ? "height" : null), s(this, ee).call(this) && a(this, I, eu).call(this));
  for (const r of s(this, An)) r(t);
}, y(fa, "props", {
  showDelay: 0
});
Mo([
  nt
], fa.prototype, "triggerElement");
Mo([
  nt
], fa.prototype, "contentElement");
Mo([
  nt
], fa.prototype, "isSubmenu");
Mo([
  _t
], fa.prototype, "open");
Mo([
  _t
], fa.prototype, "close");
var hS = Object.defineProperty, lS = Object.getOwnPropertyDescriptor, cS = (n, e, t, i) => {
  for (var r = lS(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && hS(e, t, r), r;
}, As, wo, Yi, xb, Ab, iu;
class Cb extends Lt {
  constructor() {
    super();
    c(this, Yi);
    c(this, As);
    c(this, wo, V(null));
    new Ao();
  }
  get expanded() {
    var t;
    return ((t = s(this, As)) == null ? void 0 : t.expanded()) ?? !1;
  }
  onSetup() {
    u(this, As, Me(Os));
  }
  onAttach(t) {
    s(this, As).attachMenuButton(this), b(a(this, Yi, xb).bind(this)), Vt(t, "type", "button");
  }
  onConnect(t) {
    b(a(this, Yi, Ab).bind(this)), a(this, Yi, iu).call(this);
    const i = new MutationObserver(a(this, Yi, iu).bind(this));
    i.observe(t, { attributeFilter: ["data-part"], childList: !0, subtree: !0 }), it(() => i.disconnect()), ea(t, (r) => {
      this.dispatch("select", { trigger: r });
    });
  }
}
As = new WeakMap(), wo = new WeakMap(), Yi = new WeakSet(), xb = function() {
  s(this, As).disableMenuButton(this.$props.disabled());
}, Ab = function() {
  const t = s(this, wo).call(this);
  t && b(() => {
    const i = s(this, As).hint();
    i && (t.textContent = i);
  });
}, iu = function() {
  var i;
  const t = (i = this.el) == null ? void 0 : i.querySelector('[data-part="hint"]');
  s(this, wo).set(t ?? null);
}, y(Cb, "props", {
  disabled: !1
});
cS([
  nt
], Cb.prototype, "expanded");
const su = ha();
var Hi, Ms, Tu, Ie, Lb, Ib, Gh, nu, ru;
class Mb extends qe {
  constructor() {
    super(...arguments);
    c(this, Ie);
    c(this, Hi, /* @__PURE__ */ new Set());
    c(this, Ms, V(""));
    c(this, Tu, null);
    y(this, "onValueChange");
    c(this, Gh, a(this, Ie, nu).bind(this));
  }
  get values() {
    return Array.from(s(this, Hi)).map((t) => t.value());
  }
  get value() {
    return s(this, Ms).call(this);
  }
  set value(t) {
    a(this, Ie, nu).call(this, t);
  }
  onSetup() {
    Qi(su, {
      add: a(this, Ie, Lb).bind(this),
      remove: a(this, Ie, Ib).bind(this)
    });
  }
  onAttach(t) {
    On(Os) || Vt(t, "role", "radiogroup"), this.setAttributes({ value: s(this, Ms) });
  }
  onDestroy() {
    s(this, Hi).clear();
  }
}
Hi = new WeakMap(), Ms = new WeakMap(), Tu = new WeakMap(), Ie = new WeakSet(), Lb = function(t) {
  s(this, Hi).has(t) || (s(this, Hi).add(t), t.onCheck = s(this, Gh), t.check(t.value() === s(this, Ms).call(this)));
}, Ib = function(t) {
  t.onCheck = null, s(this, Hi).delete(t);
}, Gh = new WeakMap(), nu = function(t, i) {
  var l;
  const r = v(s(this, Ms));
  if (!t || t === r) return;
  const o = a(this, Ie, ru).call(this, r), h = a(this, Ie, ru).call(this, t);
  o == null || o.check(!1, i), h == null || h.check(!0, i), s(this, Ms).set(t), (l = this.onValueChange) == null || l.call(this, t, i);
}, ru = function(t) {
  for (const i of s(this, Hi))
    if (t === v(i.value)) return i;
  return null;
};
var uS = Object.defineProperty, dS = Object.getOwnPropertyDescriptor, Rb = (n, e, t, i) => {
  for (var r = dS(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && uS(e, t, r), r;
}, Ui, na, qb, Ob;
class Uu extends Lt {
  constructor() {
    super();
    c(this, na);
    c(this, Ui);
    u(this, Ui, new Mb()), s(this, Ui).onValueChange = a(this, na, Ob).bind(this);
  }
  get values() {
    return s(this, Ui).values;
  }
  get value() {
    return s(this, Ui).value;
  }
  set value(t) {
    s(this, Ui).value = t;
  }
  onSetup() {
    b(a(this, na, qb).bind(this));
  }
}
Ui = new WeakMap(), na = new WeakSet(), qb = function() {
  s(this, Ui).value = this.$props.value();
}, Ob = function(t, i) {
  const r = this.createEvent("change", { detail: t, trigger: i });
  this.dispatch(r);
}, y(Uu, "props", {
  value: ""
});
Rb([
  nt
], Uu.prototype, "values");
Rb([
  nt
], Uu.prototype, "value");
var fS = Object.defineProperty, pS = Object.getOwnPropertyDescriptor, mS = (n, e, t, i) => {
  for (var r = pS(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && fS(e, t, r), r;
}, ni, Mn, Kt, Vb, Nb, Fb, _b, Hb, au, Ub;
class Db extends Lt {
  constructor() {
    super();
    c(this, Kt);
    c(this, ni, V(!1));
    c(this, Mn, {
      value: this.$props.value,
      check: a(this, Kt, Hb).bind(this),
      onCheck: null
    });
    new Ao();
  }
  get checked() {
    return s(this, ni).call(this);
  }
  onSetup() {
    this.setAttributes({
      value: this.$props.value,
      "data-checked": s(this, ni),
      "aria-checked": Hn(s(this, ni))
    });
  }
  onAttach(t) {
    const i = On(Os);
    Vt(t, "tabindex", i ? "-1" : "0"), Vt(t, "role", i ? "menuitemradio" : "radio"), b(a(this, Kt, Fb).bind(this));
  }
  onConnect(t) {
    a(this, Kt, Nb).call(this), ea(t, a(this, Kt, _b).bind(this)), it(a(this, Kt, Vb).bind(this));
  }
}
ni = new WeakMap(), Mn = new WeakMap(), Kt = new WeakSet(), Vb = function() {
  Ke(() => {
    Me(su).remove(s(this, Mn));
  }, this.connectScope);
}, Nb = function() {
  Me(su).add(s(this, Mn));
}, Fb = function() {
  var r, o;
  const { value: t } = this.$props, i = t();
  v(s(this, ni)) && ((o = (r = s(this, Mn)).onCheck) == null || o.call(r, i));
}, _b = function(t) {
  var i, r;
  v(s(this, ni)) || (a(this, Kt, au).call(this, !0, t), a(this, Kt, Ub).call(this, t), (r = (i = s(this, Mn)).onCheck) == null || r.call(i, v(this.$props.value), t));
}, Hb = function(t, i) {
  v(s(this, ni)) !== t && a(this, Kt, au).call(this, t, i);
}, au = function(t, i) {
  s(this, ni).set(t), this.dispatch("change", { detail: t, trigger: i });
}, Ub = function(t) {
  this.dispatch("select", { trigger: t });
}, y(Db, "props", {
  value: ""
});
mS([
  nt
], Db.prototype, "checked");
var gS = Object.defineProperty, yS = Object.getOwnPropertyDescriptor, Bu = (n, e, t, i) => {
  for (var r = yS(e, t), o = n.length - 1, h; o >= 0; o--)
    (h = n[o]) && (r = h(e, t, r) || r);
  return r && gS(e, t, r), r;
};
const Bb = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
var Ls, Kr, Ln, Re, jb, Wb, Gb, Kb, Qb;
class nl extends Lt {
  constructor() {
    super();
    c(this, Re);
    c(this, Ls);
    c(this, Kr);
    c(this, Ln);
    u(this, Ln, new Mb()), s(this, Ln).onValueChange = a(this, Re, Qb).bind(this);
  }
  get value() {
    return s(this, Ln).value;
  }
  get disabled() {
    const { rates: t } = this.$props, { canSetPlaybackRate: i } = s(this, Ls).$state;
    return !i() || t().length === 0;
  }
  onSetup() {
    u(this, Ls, ue()), On(Os) && u(this, Kr, Me(Os));
  }
  onConnect(t) {
    b(a(this, Re, jb).bind(this)), b(a(this, Re, Wb).bind(this)), b(a(this, Re, Gb).bind(this));
  }
  getOptions() {
    const { rates: t, normalLabel: i } = this.$props;
    return t().map((r) => ({
      label: r === 1 ? i : r + "×",
      value: r.toString()
    }));
  }
}
Ls = new WeakMap(), Kr = new WeakMap(), Ln = new WeakMap(), Re = new WeakSet(), jb = function() {
  s(this, Ln).value = a(this, Re, Kb).call(this);
}, Wb = function() {
  var o;
  const { normalLabel: t } = this.$props, { playbackRate: i } = s(this, Ls).$state, r = i();
  (o = s(this, Kr)) == null || o.hint.set(r === 1 ? t() : r + "×");
}, Gb = function() {
  var t;
  (t = s(this, Kr)) == null || t.disable(this.disabled);
}, Kb = function() {
  const { playbackRate: t } = s(this, Ls).$state;
  return t().toString();
}, Qb = function(t, i) {
  if (this.disabled) return;
  const r = +t;
  s(this, Ls).remote.changePlaybackRate(r, i), this.dispatch("change", { detail: r, trigger: i });
}, y(nl, "props", {
  normalLabel: "Normal",
  rates: Bb
});
Bu([
  nt
], nl.prototype, "value");
Bu([
  nt
], nl.prototype, "disabled");
Bu([
  _t
], nl.prototype, "getOptions");
var Qr, Bi, ji, To, ou;
class bS {
  constructor(e) {
    c(this, To);
    y(this, "priority", 10);
    c(this, Qr, null);
    c(this, Bi);
    c(this, ji);
    u(this, Bi, e);
  }
  attach() {
  }
  canRender() {
    return !0;
  }
  detach() {
    var e;
    (e = s(this, ji)) == null || e.abort(), u(this, ji, void 0), s(this, Bi).reset(), u(this, Qr, null);
  }
  changeTrack(e) {
    var t;
    !e || s(this, Qr) === e || ((t = s(this, ji)) == null || t.abort(), u(this, ji, new dt(e)), e.readyState < 2 ? (s(this, Bi).reset(), s(this, ji).add("load", () => a(this, To, ou).call(this, e), { once: !0 })) : a(this, To, ou).call(this, e), s(this, ji).add("add-cue", (i) => {
      s(this, Bi).addCue(i.detail);
    }).add("remove-cue", (i) => {
      s(this, Bi).removeCue(i.detail);
    }), u(this, Qr, e));
  }
}
Qr = new WeakMap(), Bi = new WeakMap(), ji = new WeakMap(), To = new WeakSet(), ou = function(e) {
  s(this, Bi).changeTrack({
    cues: [...e.cues],
    regions: [...e.regions]
  });
};
var we, oe, F, lh, zb, Yb, Xb, hu, Jb, Zb, tw, ew, lu, iw, sw, Wi, cu, ch, uu, du;
let wS = (we = class extends Lt {
  constructor() {
    super(...arguments);
    c(this, F);
    c(this, oe);
    c(this, Wi, -1);
  }
  onSetup() {
    u(this, oe, ue()), this.setAttributes({
      "aria-hidden": Hn(a(this, F, lh).bind(this))
    });
  }
  onAttach(t) {
    t.style.setProperty("pointer-events", "none");
  }
  onConnect(t) {
    we.lib() || import("./dev-D3SS6qhA.js").then((i) => i.d).then((i) => we.lib.set(i)), b(a(this, F, zb).bind(this));
  }
}, oe = new WeakMap(), F = new WeakSet(), lh = function() {
  const { textTrack: t, remotePlaybackState: i, iOSControls: r } = s(this, oe).$state, o = t();
  return r() || i() === "connected" || !o || !le(o);
}, zb = function() {
  if (!we.lib()) return;
  const { viewType: t } = s(this, oe).$state;
  return t() === "audio" ? a(this, F, Yb).call(this) : a(this, F, Zb).call(this);
}, Yb = function() {
  return b(a(this, F, Xb).bind(this)), a(this, F, lu).call(this, null), () => {
    this.el.textContent = "";
  };
}, Xb = function() {
  if (a(this, F, lh).call(this)) return;
  a(this, F, hu).call(this);
  const { textTrack: t } = s(this, oe).$state;
  ft(t(), "cue-change", a(this, F, hu).bind(this)), b(a(this, F, Jb).bind(this));
}, hu = function() {
  this.el.textContent = "", s(this, Wi) >= 0 && a(this, F, ch).call(this);
  const { realCurrentTime: t, textTrack: i } = s(this, oe).$state, { renderVTTCueString: r } = we.lib(), o = v(t), h = v(i).activeCues;
  for (const l of h) {
    const d = a(this, F, uu).call(this), f = a(this, F, du).call(this);
    f.innerHTML = r(l, o), d.append(f), this.el.append(f);
  }
}, Jb = function() {
  const { realCurrentTime: t } = s(this, oe).$state, { updateTimedVTTCueNodes: i } = we.lib();
  i(this.el, t());
}, Zb = function() {
  const { CaptionsRenderer: t } = we.lib(), i = new t(this.el), r = new bS(i);
  return s(this, oe).textRenderers.add(r), b(a(this, F, tw).bind(this, i)), b(a(this, F, ew).bind(this, i)), a(this, F, lu).call(this, i), () => {
    this.el.textContent = "", s(this, oe).textRenderers.remove(r), i.destroy();
  };
}, tw = function(t) {
  t.dir = this.$props.textDir();
}, ew = function(t) {
  var o;
  if (a(this, F, lh).call(this)) return;
  const { realCurrentTime: i, textTrack: r } = s(this, oe).$state;
  t.currentTime = i(), s(this, Wi) >= 0 && ((o = r()) != null && o.activeCues[0]) && a(this, F, ch).call(this);
}, lu = function(t) {
  const i = s(this, oe).player;
  if (!i) return;
  const r = a(this, F, iw).bind(this, t);
  ft(i, "vds-font-change", r);
}, iw = function(t) {
  var r;
  if (s(this, Wi) >= 0) {
    a(this, F, cu).call(this);
    return;
  }
  const { textTrack: i } = s(this, oe).$state;
  (r = i()) != null && r.activeCues[0] ? t == null || t.update(!0) : a(this, F, sw).call(this);
}, sw = function() {
  var r, o;
  const t = a(this, F, uu).call(this);
  W(t, "data-example", "");
  const i = a(this, F, du).call(this);
  W(i, "data-example", ""), i.textContent = this.$props.exampleText(), t == null || t.append(i), (r = this.el) == null || r.append(t), (o = this.el) == null || o.setAttribute("data-example", ""), a(this, F, cu).call(this);
}, Wi = new WeakMap(), cu = function() {
  window.clearTimeout(s(this, Wi)), u(this, Wi, window.setTimeout(a(this, F, ch).bind(this), 2500));
}, ch = function() {
  var t, i;
  (t = this.el) == null || t.removeAttribute("data-example"), (i = this.el) != null && i.querySelector("[data-example]") && (this.el.textContent = ""), u(this, Wi, -1);
}, uu = function() {
  const t = document.createElement("div");
  return W(t, "data-part", "cue-display"), t;
}, du = function() {
  const t = document.createElement("div");
  return W(t, "data-part", "cue"), t;
}, y(we, "props", {
  textDir: "ltr",
  exampleText: "Captions look like this."
}), y(we, "lib", V(null)), we);
var Wo, zr, Is, $o, vo, Mt, nw, rw, aw, fu, ow, hw, pu, lw;
let TS = (Wo = class extends Lt {
  constructor() {
    super(...arguments);
    c(this, Mt);
    c(this, zr);
    c(this, Is, V(null));
    c(this, $o, V(!0));
    c(this, vo, V(!0));
  }
  onSetup() {
    u(this, zr, ue()), a(this, Mt, fu).call(this);
    const { type: t } = this.$props;
    this.setAttributes({
      "data-type": t,
      "data-remainder": a(this, Mt, pu).bind(this)
    }), new Eg({
      callback: a(this, Mt, nw).bind(this)
    }).attach(this);
  }
  onAttach(t) {
    t.hasAttribute("role") || b(a(this, Mt, ow).bind(this)), b(a(this, Mt, fu).bind(this));
  }
  onConnect(t) {
    it(gf(t, s(this, $o).set)), b(a(this, Mt, rw).bind(this)), b(a(this, Mt, aw).bind(this));
  }
}, zr = new WeakMap(), Is = new WeakMap(), $o = new WeakMap(), vo = new WeakMap(), Mt = new WeakSet(), nw = function(t) {
  s(this, vo).set(t[0].isIntersecting);
}, rw = function() {
  const { hidden: t } = this.$props;
  this.$state.hidden.set(t() || !s(this, $o).call(this) || !s(this, vo).call(this));
}, aw = function() {
  if (!this.$props.toggle()) {
    s(this, Is).set(null);
    return;
  }
  this.el && ea(this.el, a(this, Mt, lw).bind(this));
}, fu = function() {
  const { hidden: t, timeText: i } = this.$state, { duration: r } = s(this, zr).$state;
  if (t()) return;
  const { type: o, padHours: h, padMinutes: l, showHours: d } = this.$props, f = a(this, Mt, hw).call(this, o()), p = r(), m = a(this, Mt, pu).call(this);
  if (!Number.isFinite(f + p)) {
    i.set("LIVE");
    return;
  }
  const w = m ? Math.max(0, p - f) : f, P = Fu(w, {
    padHrs: h(),
    padMins: l(),
    showHrs: d()
  });
  i.set((m ? "-" : "") + P);
}, ow = function() {
  if (!this.el) return;
  const { toggle: t } = this.$props;
  W(this.el, "role", t() ? "timer" : null), W(this.el, "tabindex", t() ? 0 : null);
}, hw = function(t) {
  const { bufferedEnd: i, duration: r, currentTime: o } = s(this, zr).$state;
  switch (t) {
    case "buffered":
      return i();
    case "duration":
      return r();
    default:
      return o();
  }
}, pu = function() {
  return this.$props.remainder() && s(this, Is).call(this) !== !1;
}, lw = function(t) {
  if (t.preventDefault(), s(this, Is).call(this) === null) {
    s(this, Is).set(!this.$props.remainder());
    return;
  }
  s(this, Is).set((i) => !i);
}, y(Wo, "props", {
  type: "current",
  showHours: !1,
  padHours: null,
  padMinutes: null,
  remainder: !1,
  toggle: !1,
  hidden: !1
}), y(Wo, "state", new la({
  timeText: "",
  hidden: !1
})), Wo);
class ju extends Pv {
}
class $S extends gg {
}
class vS extends Nv {
}
class cw extends Vn {
}
class SS extends Ch {
}
class kS extends jc {
}
class PS extends Uv {
}
class ES extends Hu {
}
class CS extends Eh {
}
class xS extends by {
}
class AS extends da {
}
class MS extends wS {
}
class LS extends TS {
}
const rl = $.createContext({ current: null });
rl.displayName = "Scope";
function IS(n, ...e) {
  return $.createElement(rl.Provider, { value: n }, ...e);
}
function RS() {
  return $.useContext(rl).current;
}
function uw(n) {
  const e = RS();
  return $.useMemo(() => Su(n.id, e), [e]);
}
function dw(n, e) {
  typeof n == "function" ? n(e) : n && (n.current = e);
}
function Us(...n) {
  return (e) => n.forEach((t) => dw(t, e));
}
function qS(n, e) {
  const t = $.forwardRef((i, r) => {
    var B, At, Ut, Xt, se, Oe, De, de;
    let o = $.useContext(rl), h = $.useRef(null), l = $.useRef();
    if (!l.current) {
      const E = DS(), bt = Sd(n, E, i, o.current);
      E.component = bt, l.current = E, h.current = bt.scope;
    }
    function d() {
      let E = l.current, bt = o.current;
      if (window.cancelAnimationFrame(E.destroyId), E.destroyId = -1, E.component.$$.destroyed) {
        const It = Sd(n, E, i, bt);
        E.component = It, E.attached = !1, E.forwardRef = !1, h.current = It.scope;
      }
      return E.el && vd(E, E.el), E.forwardRef || (dw(r, E.component), E.forwardRef = !0), () => uh(E);
    }
    function f(E) {
      const bt = l.current;
      if (!bt.forwardRef) {
        bt.el = E;
        return;
      }
      window.cancelAnimationFrame(bt.refChangeId), bt.refChangeId = window.requestAnimationFrame(() => {
        const It = l.current;
        It.refChangeId = -1, It.el !== E && (uh(It), E && vd(It, E), It.el = E);
      });
    }
    $.useEffect(() => {
      const E = l.current;
      return window.cancelAnimationFrame(E.destroyId), E.destroyId = -1, function() {
        $e(i.children) && (window.cancelAnimationFrame(E.refChangeId), E.refChangeId = -1, window.cancelAnimationFrame(E.connectId), E.connectId = -1, window.cancelAnimationFrame(E.destroyId), E.destroyId = window.requestAnimationFrame(() => {
          E.destroyId = -1, uh(E), E.component.$$.destroy(), E.component.$$[Jh] = null, E.callbacks = {}, E.domCallbacks = {}, h.current = null;
        }));
      };
    }, []), $.useEffect(Gi);
    let p = l.current, { children: m, ...w } = i, P = {}, k = p.prevProps, M = Object.keys(w);
    p.callbacks = {};
    for (const E of [...k, ...M])
      if (e.props.has(E))
        p.component.$props[E].set(
          // If the prop was removed we'll use the default value provided on Component creation.
          Et(w[E]) ? (B = n.props) == null ? void 0 : B[E] : w[E]
        );
      else if ((At = e.events) != null && At.has(E) || (Ut = e.eventsRE) != null && Ut.test(E))
        p.callbacks[E] = w[E];
      else if ((Xt = e.domEvents) != null && Xt.has(E) || (se = e.domEventsRE) != null && se.test(E)) {
        let bt = Xh(E.slice(2));
        p.domCallbacks[bt] = w[E], M.includes(E) ? p.el && !((de = p.listening) != null && de.has(bt)) && (p.listening || (p.listening = /* @__PURE__ */ new Set()), p.listening.add(bt), p.el.addEventListener(bt, p.onDOMEvent)) : ((Oe = p.el) == null || Oe.removeEventListener(bt, p.onDOMEvent), (De = p.listening) == null || De.delete(bt));
      } else
        P[E] = w[E];
    return p.prevProps = M, IS(
      h,
      $.createElement(OS, {
        effect: d
      }),
      $e(m) ? m == null ? void 0 : m(
        {
          ...P,
          suppressHydrationWarning: !0,
          ref: f
        },
        p.component
      ) : m
    );
  });
  return t.displayName = n.name + "Bridge", t;
}
function OS({ effect: n }) {
  return $.useEffect(n, []), null;
}
const $d = /* @__PURE__ */ new Map();
function DS() {
  const n = {
    el: null,
    prevProps: [],
    callbacks: {},
    domCallbacks: {},
    refChangeId: -1,
    connectId: -1,
    destroyId: -1,
    attached: !1,
    forwardRef: !1,
    listening: null,
    onDOMEvent(e) {
      var i, r;
      const t = Et(e.detail) ? [e] : [e.detail, e];
      (r = (i = n.domCallbacks)[e.type]) == null || r.call(i, ...t);
    }
  };
  return n;
}
function vd(n, e) {
  if (!(n.el === e && n.attached)) {
    if (n.attached && uh(n), n.domCallbacks) {
      n.listening || (n.listening = /* @__PURE__ */ new Set());
      for (const t of Object.keys(n.domCallbacks))
        n.listening.has(t) || (e.addEventListener(t, n.onDOMEvent), n.listening.add(t));
    }
    n.component.$$.attach(e), n.connectId = window.requestAnimationFrame(() => {
      n.component.$$.connect(), n.connectId = -1;
    }), n.attached = !0;
  }
}
function uh(n) {
  if (n.attached && (window.cancelAnimationFrame(n.connectId), n.connectId = -1, n.component.$$.detach(), n.attached = !1, n.el && n.listening)) {
    for (const e of n.listening)
      n.el.removeEventListener(e, n.onDOMEvent);
    n.listening.clear();
  }
}
function VS(n) {
  var i, r;
  let e = $d.get(n.type), t = Et(n.detail) ? [n] : [n.detail, n];
  e || $d.set(n.type, e = `on${$T(n.type)}`), (r = (i = this.callbacks)[e]) == null || r.call(i, ...t);
}
function Sd(n, e, t, i) {
  const r = MT(n, { props: t, scope: i });
  return r.$$[Jh] = VS.bind(e), r.$$.setup(), r;
}
function Lo(n) {
  return uw(n);
}
function gt(n, e) {
  const [, t] = $.useState();
  return $.useEffect(() => zd(() => {
    n(), t({});
  }), [e ?? n]), n();
}
function NS(n) {
  const [, e] = $.useState(), t = $.useRef(null);
  return t.current == null && (t.current = {
    state: {},
    $update: V({}),
    props: /* @__PURE__ */ new Set()
  }), $.useEffect(() => {
    let { state: i, $update: r, props: o } = t.current;
    return b(() => {
      for (const h of o) {
        const l = n[h]();
        i[h] = zt(l) ? [...l] : l;
      }
      r(), e({});
    });
  }, [n]), $.useMemo(() => {
    let { state: i, $update: r, props: o } = t.current, h = !1;
    return o.clear(), new Proxy(i, {
      get(l, d) {
        if (!o.has(d) && d in n) {
          o.add(d);
          const f = n[d]();
          i[d] = zt(f) ? [...f] : f, h || (r.set({}), h = !0, queueMicrotask(() => h = !1));
        }
        return i[d];
      },
      set(l, d, f) {
        return d in n || (i[d] = f), !0;
      }
    });
  }, [n]);
}
function ke(n, e) {
  return qS(n, {
    props: new Set(Object.keys(n.props || {})),
    events: new Set(e == null ? void 0 : e.events),
    eventsRE: e == null ? void 0 : e.eventsRegex,
    domEvents: e == null ? void 0 : e.domEvents,
    domEventsRE: e == null ? void 0 : e.domEventsRegex
  });
}
const FS = [
  "onAbort",
  "onAudioTrackChange",
  "onAudioTracksChange",
  "onAutoPlay",
  "onAutoPlayChange",
  "onAutoPlayFail",
  "onCanLoad",
  "onCanPlay",
  "onCanPlayThrough",
  "onControlsChange",
  "onDestroy",
  "onDurationChange",
  "onEmptied",
  "onEnd",
  "onEnded",
  "onError",
  "onFindMediaPlayer",
  "onFullscreenChange",
  "onFullscreenError",
  "onLiveChange",
  "onLiveEdgeChange",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onLoopChange",
  "onOrientationChange",
  "onPause",
  "onPictureInPictureChange",
  "onPictureInPictureError",
  "onPlay",
  "onPlayFail",
  "onPlaying",
  "onPlaysInlineChange",
  "onPosterChange",
  "onProgress",
  "onProviderChange",
  "onProviderLoaderChange",
  "onProviderSetup",
  "onQualitiesChange",
  "onQualityChange",
  "onRateChange",
  "onReplay",
  "onSeeked",
  "onSeeking",
  "onSourceChange",
  "onSourceChange",
  "onStalled",
  "onStarted",
  "onStreamTypeChange",
  "onSuspend",
  "onTextTrackChange",
  "onTextTracksChange",
  "onTimeUpdate",
  "onTitleChange",
  "onVdsLog",
  "onVideoPresentationChange",
  "onVolumeChange",
  "onWaiting"
], fw = $.forwardRef((n, e) => {
  const { children: t, ...i } = n, r = $.Children.toArray(t), o = r.find(HS);
  if (o) {
    const h = o.props.children, l = r.map((d) => d === o ? $.Children.count(h) > 1 ? $.Children.only(null) : $.isValidElement(h) ? h.props.children : null : d);
    return /* @__PURE__ */ N(mu, { ...i, ref: e, children: $.isValidElement(h) ? $.cloneElement(h, void 0, l) : null });
  }
  return /* @__PURE__ */ N(mu, { ...i, ref: e, children: t });
});
fw.displayName = "Slot";
const mu = $.forwardRef((n, e) => {
  const { children: t, ...i } = n;
  return $.isValidElement(t) ? $.cloneElement(t, {
    ...US(i, t.props),
    ref: e ? Us(e, t.ref) : t.ref
  }) : $.Children.count(t) > 1 ? $.Children.only(null) : null;
});
mu.displayName = "SlotClone";
const _S = ({ children: n }) => /* @__PURE__ */ N(zw, { children: n });
function HS(n) {
  return $.isValidElement(n) && n.type === _S;
}
function US(n, e) {
  const t = { ...e };
  for (const i in e) {
    const r = n[i], o = e[i];
    /^on[A-Z]/.test(i) ? r && o ? t[i] = (...l) => {
      o(...l), r(...l);
    } : r && (t[i] = r) : i === "style" ? t[i] = { ...r, ...o } : i === "className" && (t[i] = [r, o].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
const BS = ["button", "div", "span", "img", "video", "audio"], Ht = BS.reduce((n, e) => {
  const t = $.forwardRef((i, r) => {
    const { asChild: o, ...h } = i;
    return /* @__PURE__ */ N(o ? fw : e, { ...h, ref: r });
  });
  return t.displayName = `Primitive.${e}`, { ...n, [e]: t };
}, {}), jS = ke(ju, {
  events: FS,
  eventsRegex: /^onHls/,
  domEventsRegex: /^onMedia/
}), WS = $.forwardRef(
  ({ aspectRatio: n, children: e, ...t }, i) => /* @__PURE__ */ N(
    jS,
    {
      ...t,
      src: t.src,
      ref: i,
      style: {
        aspectRatio: n,
        ...t.style
      },
      children: (r) => /* @__PURE__ */ N(Ht.div, { ...r, children: e })
    }
  )
);
WS.displayName = "MediaPlayer";
function Un() {
  return uw(Ru);
}
const pw = /* @__PURE__ */ $.forwardRef((n, e) => {
  const { width: t, height: i, size: r = null, paths: o, ...h } = n;
  return $.createElement("svg", {
    viewBox: "0 0 32 32",
    ...h,
    width: t ?? r,
    height: i ?? r,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: e,
    dangerouslySetInnerHTML: { __html: o }
  });
});
pw.displayName = "VidstackIcon";
function GS(n) {
  return (n == null ? void 0 : n.$$PROVIDER_TYPE) === "REMOTION";
}
const KS = ke($S), QS = $.forwardRef(
  ({ loaders: n = [], children: e, iframeProps: t, mediaProps: i, ...r }, o) => {
    const h = $.useMemo(() => n.map((l) => new l()), n);
    return /* @__PURE__ */ N(KS, { ...r, loaders: h, ref: o, children: (l, d) => /* @__PURE__ */ Jr("div", { ...l, children: [
      /* @__PURE__ */ N(mw, { provider: d, mediaProps: i, iframeProps: t }),
      e
    ] }) });
  }
);
QS.displayName = "MediaProvider";
function mw({ provider: n, mediaProps: e, iframeProps: t }) {
  const { sources: i, crossOrigin: r, poster: o, remotePlaybackInfo: h, nativeControls: l, viewType: d } = Lo(ua), { loader: f } = n.$state, { $provider: p, $providerSetup: m } = Un(), w = gt(i), P = gt(l), k = gt(r), M = gt(o), B = gt(f), At = gt(p), Ut = gt(m), Xt = gt(h), se = B == null ? void 0 : B.mediaType(), Oe = gt(d), De = Oe === "audio", de = (B == null ? void 0 : B.name) === "youtube", E = (B == null ? void 0 : B.name) === "vimeo", bt = de || E, It = (B == null ? void 0 : B.name) === "remotion", bi = (B == null ? void 0 : B.name) === "google-cast", [Xi, Qt] = $.useState(""), [qt, Ji] = $.useState(!1);
  return $.useEffect(() => {
    !bi || Xi || import("./chromecast-fcYiHsj5.js").then((wt) => {
      Qt(wt.default);
    });
  }, [bi]), $.useEffect(() => {
    Ji(!0);
  }, []), bi ? /* @__PURE__ */ Jr(
    "div",
    {
      className: "vds-google-cast",
      ref: (wt) => {
        n.load(wt);
      },
      children: [
        /* @__PURE__ */ N(pw, { paths: Xi }),
        Xt != null && Xt.deviceName ? /* @__PURE__ */ Jr("span", { className: "vds-google-cast-info", children: [
          "Google Cast on",
          " ",
          /* @__PURE__ */ N("span", { className: "vds-google-cast-device-name", children: Xt.deviceName })
        ] }) : null
      ]
    }
  ) : It ? /* @__PURE__ */ N("div", { "data-remotion-canvas": !0, children: /* @__PURE__ */ N(
    "div",
    {
      "data-remotion-container": !0,
      ref: (wt) => {
        n.load(wt);
      },
      children: GS(At) && Ut ? $.createElement(At.render) : null
    }
  ) }) : bt ? $.createElement(
    $.Fragment,
    null,
    $.createElement("iframe", {
      ...t,
      className: (t != null && t.className ? `${t.className} ` : "") + de ? "vds-youtube" : "vds-vimeo",
      suppressHydrationWarning: !0,
      tabIndex: P ? void 0 : -1,
      "aria-hidden": "true",
      "data-no-controls": P ? void 0 : "",
      ref(wt) {
        n.load(wt);
      }
    }),
    !P && !De ? $.createElement("div", { className: "vds-blocker" }) : null
  ) : se ? $.createElement(se === "audio" ? "audio" : "video", {
    ...e,
    controls: P ? !0 : null,
    crossOrigin: typeof k == "boolean" ? "" : k,
    poster: se === "video" && P && M ? M : null,
    suppressHydrationWarning: !0,
    children: qt ? null : w.map(
      ({ src: wt, type: et }) => R(wt) ? /* @__PURE__ */ N("source", { src: wt, type: et !== "?" ? et : void 0 }, wt) : null
    ),
    ref(wt) {
      n.load(wt);
    }
  }) : null;
}
mw.displayName = "MediaOutlet";
function zS(n) {
  const e = Un(), t = $.useMemo(() => new Ns(n), Object.values(n));
  return $.useEffect(() => (e.textTracks.add(t), () => void e.textTracks.remove(t)), [t]), t;
}
function YS({ lang: n, ...e }) {
  return zS({ language: n, ...e }), null;
}
YS.displayName = "Track";
const XS = ke(vS, {
  domEventsRegex: /^onMedia/
}), JS = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(XS, { ...e, children: (i) => /* @__PURE__ */ N(
    Ht.button,
    {
      ...i,
      ref: Us(i.ref, t),
      children: n
    }
  ) })
);
JS.displayName = "FullscreenButton";
const kd = cw.state.record, ZS = Object.keys(kd).reduce(
  (n, e) => ({
    ...n,
    [e]() {
      return kd[e];
    }
  }),
  {}
);
function wl(n, e) {
  const t = Lo(il);
  return gt((t || ZS)[n]);
}
const Wu = [
  "onDragStart",
  "onDragEnd",
  "onDragValueChange",
  "onValueChange",
  "onPointerValueChange"
], tk = ke(ES), ek = ke(cw, {
  events: Wu
}), ik = $.forwardRef(({ children: n, ...e }, t) => /* @__PURE__ */ N(ek, { ...e, ref: t, children: (i) => /* @__PURE__ */ N(Ht.div, { ...i, children: n }) }));
ik.displayName = "Slider";
const sk = $.forwardRef((n, e) => /* @__PURE__ */ N(Ht.div, { ...n, ref: e }));
sk.displayName = "SliderThumb";
const nk = $.forwardRef((n, e) => /* @__PURE__ */ N(Ht.div, { ...n, ref: e }));
nk.displayName = "SliderTrack";
const rk = $.forwardRef((n, e) => /* @__PURE__ */ N(Ht.div, { ...n, ref: e }));
rk.displayName = "SliderTrackFill";
const ak = ke(xS), ok = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(ak, { ...e, children: (i) => /* @__PURE__ */ N(
    Ht.div,
    {
      ...i,
      ref: Us(i.ref, t),
      children: n
    }
  ) })
);
ok.displayName = "SliderPreview";
const hk = $.forwardRef(({ children: n, ...e }, t) => /* @__PURE__ */ N(tk, { ...e, children: (i, r) => {
  const o = gt(() => r.getValueText(), r);
  return /* @__PURE__ */ Jr(Ht.div, { ...i, ref: t, children: [
    o,
    n
  ] });
} }));
hk.displayName = "SliderValue";
const lk = $.forwardRef(({ children: n, ...e }, t) => {
  const i = wl("min"), r = wl("max"), o = wl("step"), h = (r - i) / o;
  return /* @__PURE__ */ N(Ht.div, { ...e, ref: t, children: Array.from({ length: Math.floor(h) + 1 }).map((l, d) => n(d)) });
});
lk.displayName = "SliderSteps";
const ck = ke(kS, {
  events: Wu,
  domEventsRegex: /^onMedia/
}), uk = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(ck, { ...e, ref: t, children: (i) => /* @__PURE__ */ N(Ht.div, { ...i, children: n }) })
);
uk.displayName = "VolumeSlider";
function dk(n = 0, e = 0, t = "") {
  return new window.VTTCue(n, e, t);
}
const al = $.createContext({
  $chapters: V(null)
});
al.displayName = "TimeSliderContext";
const fk = ke(SS, {
  events: Wu,
  domEventsRegex: /^onMedia/
}), pk = $.forwardRef(
  ({ children: n, ...e }, t) => {
    const i = $.useMemo(() => V(null), []);
    return /* @__PURE__ */ N(al.Provider, { value: { $chapters: i }, children: /* @__PURE__ */ N(fk, { ...e, ref: t, children: (r) => /* @__PURE__ */ N(Ht.div, { ...r, children: n }) }) });
  }
);
pk.displayName = "TimeSlider";
const mk = ke(AS), gk = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(mk, { ...e, children: (i, r) => /* @__PURE__ */ N(
    Ht.div,
    {
      ...i,
      ref: Us(i.ref, t),
      children: /* @__PURE__ */ N(gw, { instance: r, children: n })
    }
  ) })
);
gk.displayName = "SliderChapters";
function gw({ instance: n, children: e }) {
  const t = gt(() => n.cues, n), i = $.useRef([]), r = $.useRef(null), { $chapters: o } = $.useContext(al);
  return r.current || (r.current = dk()), $.useEffect(() => (o.set(n), () => void o.set(null)), [n]), $.useEffect(() => {
    n.setRefs(i.current);
  }, [t]), e(t.length ? t : [r.current], (h) => {
    if (!h) {
      i.current.length = 0;
      return;
    }
    i.current.push(h);
  });
}
gw.displayName = "SliderChapterTracks";
const yk = $.forwardRef(
  ({ children: n, ...e }, t) => {
    const { $chapters: i } = $.useContext(al), [r, o] = $.useState();
    return $.useEffect(() => b(() => {
      const h = i(), l = (h == null ? void 0 : h.activePointerCue) || (h == null ? void 0 : h.activeCue);
      o((l == null ? void 0 : l.text) || "");
    }), []), /* @__PURE__ */ Jr(Ht.div, { ...e, ref: t, children: [
      r,
      n
    ] });
  }
);
yk.displayName = "SliderChapterTitle";
const bk = $.forwardRef((n, e) => /* @__PURE__ */ N(Ht.div, { ...n, ref: e }));
bk.displayName = "SliderProgress";
const wk = ke(PS), Tk = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(wk, { ...e, children: (i) => /* @__PURE__ */ N(Ht.div, { ...i, ref: Us(i.ref, t), children: n }) })
);
Tk.displayName = "SliderThumbnail";
const $k = ke(CS, {
  events: ["onCanPlay", "onError"]
}), vk = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N($k, { ...e, children: (i, r) => /* @__PURE__ */ N(
    yw,
    {
      ...i,
      instance: r,
      ref: Us(i.ref, t),
      children: n
    }
  ) })
);
vk.displayName = "SliderVideo";
const yw = $.forwardRef(
  ({ instance: n, children: e, ...t }, i) => {
    const { canLoad: r } = Lo(ua), { src: o, video: h, crossOrigin: l } = n.$state, d = gt(o), f = gt(r), p = gt(l);
    return /* @__PURE__ */ N(
      Ht.video,
      {
        style: { maxWidth: "unset" },
        ...t,
        src: d || void 0,
        muted: !0,
        playsInline: !0,
        preload: f ? "auto" : "none",
        crossOrigin: p || void 0,
        ref: Us(h.set, i),
        children: e
      }
    );
  }
);
yw.displayName = "SliderVideoProvider";
const Pd = ju.state.record, bw = Object.keys(Pd).reduce(
  (n, e) => ({
    ...n,
    [e]() {
      return Pd[e];
    }
  }),
  {}
);
function sP(n, e) {
  var i;
  const t = Lo(ua);
  return gt((((i = e == null ? void 0 : e.current) == null ? void 0 : i.$state) || t || bw)[n]);
}
function nP(n) {
  const e = Lo(ua);
  return NS(n != null && n.current ? n.current.$state : e || bw);
}
const Sk = ke(MS), kk = $.forwardRef(
  ({ children: n, ...e }, t) => /* @__PURE__ */ N(Sk, { ...e, ref: t, children: (i) => /* @__PURE__ */ N(Ht.div, { ...i, children: n }) })
);
kk.displayName = "Captions";
const Pk = ke(LS), Ek = $.forwardRef(({ children: n, ...e }, t) => /* @__PURE__ */ N(Pk, { ...e, children: (i, r) => /* @__PURE__ */ N(
  ww,
  {
    ...i,
    instance: r,
    ref: Us(i.ref, t),
    children: n
  }
) }));
Ek.displayName = "Time";
const ww = $.forwardRef(
  ({ instance: n, children: e, ...t }, i) => {
    const { timeText: r } = n.$state, o = gt(r);
    return /* @__PURE__ */ Jr(Ht.div, { ...t, ref: i, children: [
      o,
      e
    ] });
  }
);
ww.displayName = "TimeText";
const rP = $.forwardRef(
  ({ size: n = 96, children: e, ...t }, i) => /* @__PURE__ */ N(
    "svg",
    {
      width: n,
      height: n,
      fill: "none",
      viewBox: "0 0 120 120",
      "aria-hidden": "true",
      "data-part": "root",
      ...t,
      ref: i,
      children: e
    }
  )
), aP = $.forwardRef(
  ({ width: n = 8, children: e, ...t }, i) => /* @__PURE__ */ N(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      strokeWidth: n,
      "data-part": "track",
      ...t,
      ref: i,
      children: e
    }
  )
), oP = $.forwardRef(
  ({ width: n = 8, fillPercent: e = 50, children: t, ...i }, r) => /* @__PURE__ */ N(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      pathLength: "100",
      strokeWidth: n,
      strokeDasharray: 100,
      strokeDashoffset: 100 - e,
      "data-part": "track-fill",
      ...i,
      ref: r,
      children: t
    }
  )
);
function hP() {
  const n = Un();
  return (n == null ? void 0 : n.player) || null;
}
function lP(n) {
  const e = Un(), t = $.useRef(null);
  return t.current || (t.current = new df()), $.useEffect(() => {
    const i = n, r = i instanceof ju, o = r ? i : e == null ? void 0 : e.player;
    t.current.setPlayer(o ?? null), t.current.setTarget(null);
  }, [e, n]), t.current;
}
function cP({ off: n = !0 } = {}) {
  const e = Un(), { textTracks: t, textTrack: i } = e.$state, r = gt(t);
  return gt(i), $.useMemo(() => {
    const o = r.filter(le), h = o.map((l) => ({
      track: l,
      label: l.label,
      value: Ed(l),
      get selected() {
        return i() === l;
      },
      select(d) {
        const f = t().indexOf(l);
        f >= 0 && e.remote.changeTextTrackMode(f, "showing", d);
      }
    }));
    return n && h.unshift({
      track: null,
      label: R(n) ? n : "Off",
      value: "off",
      get selected() {
        return !i();
      },
      select(l) {
        e.remote.toggleCaptions(l);
      }
    }), Object.defineProperty(h, "disabled", {
      get() {
        return !o.length;
      }
    }), Object.defineProperty(h, "selectedTrack", {
      get() {
        return i();
      }
    }), Object.defineProperty(h, "selectedValue", {
      get() {
        const l = i();
        return l ? Ed(l) : "off";
      }
    }), h;
  }, [r]);
}
function Ed(n) {
  return n.id + ":" + n.kind + "-" + n.label.toLowerCase();
}
function uP({
  auto: n = !0,
  sort: e = "descending"
} = {}) {
  const t = Un(), { qualities: i, quality: r, autoQuality: o, canSetQuality: h } = t.$state, l = gt(i);
  return gt(r), gt(o), gt(h), $.useMemo(() => {
    const d = L$(l, e === "descending"), f = d.map((p) => ({
      quality: p,
      label: p.height + "p",
      value: Cd(p),
      bitrateText: p.bitrate && p.bitrate > 0 ? `${(p.bitrate / 1e6).toFixed(2)} Mbps` : null,
      get selected() {
        return p === r();
      },
      get autoSelected() {
        return o();
      },
      select(m) {
        const w = i().indexOf(p);
        w >= 0 && t.remote.changeQuality(w, m);
      }
    }));
    return n && f.unshift({
      quality: null,
      label: R(n) ? n : "Auto",
      value: "auto",
      bitrateText: null,
      get selected() {
        return o();
      },
      get autoSelected() {
        return o();
      },
      select(p) {
        t.remote.requestAutoQuality(p);
      }
    }), Object.defineProperty(f, "disabled", {
      get() {
        return !h() || l.length <= 1;
      }
    }), Object.defineProperty(f, "selectedQuality", {
      get() {
        return r();
      }
    }), Object.defineProperty(f, "selectedValue", {
      get() {
        const p = r();
        return !o() && p ? Cd(p) : "auto";
      }
    }), f;
  }, [l, e]);
}
function Cd(n) {
  return n.height + "_" + n.bitrate;
}
function dP({
  rates: n = Bb,
  normalLabel: e = "Normal"
} = {}) {
  const t = Un(), { playbackRate: i, canSetPlaybackRate: r } = t.$state;
  return gt(i), gt(r), $.useMemo(() => {
    const o = n.map((h) => {
      const l = typeof h == "number" ? h === 1 && e ? e : h + "x" : h.label, d = typeof h == "number" ? h : h.rate;
      return {
        label: l,
        value: d.toString(),
        rate: d,
        get selected() {
          return i() === d;
        },
        select(f) {
          t.remote.changePlaybackRate(d, f);
        }
      };
    });
    return Object.defineProperty(o, "disabled", {
      get() {
        return !r() || !o.length;
      }
    }), Object.defineProperty(o, "selectedValue", {
      get() {
        return i().toString();
      }
    }), o;
  }, [n]);
}
const Ck = (n) => Xh(n);
var In, ht, K, Yr, Xr, G, Qs, Tw, $w, vw, Sw, kw, Pw, Ew, Cw, xw, Aw, Mw, Lw, Iw, Rw;
class fP {
  constructor(e, t) {
    c(this, G);
    c(this, In);
    c(this, ht);
    c(this, K, null);
    c(this, Yr, null);
    y(this, "config", {});
    c(this, Xr, /* @__PURE__ */ new Set());
    u(this, In, e), u(this, ht, t);
  }
  get instance() {
    return s(this, K);
  }
  setup(e) {
    const { streamType: t } = s(this, ht).$state, i = v(t).includes("live"), r = v(t).includes("ll-");
    u(this, K, new e({
      lowLatencyMode: r,
      backBufferLength: r ? 4 : i ? 8 : void 0,
      renderTextTracksNatively: !1,
      ...this.config
    }));
    const o = a(this, G, vw).bind(this);
    for (const h of Object.values(e.Events)) s(this, K).on(h, o);
    s(this, K).on(e.Events.ERROR, a(this, G, Aw).bind(this));
    for (const h of s(this, Xr)) h(s(this, K));
    s(this, ht).player.dispatch("hls-instance", {
      detail: s(this, K)
    }), s(this, K).attachMedia(s(this, In)), s(this, K).on(e.Events.AUDIO_TRACK_SWITCHED, a(this, G, Pw).bind(this)), s(this, K).on(e.Events.LEVEL_SWITCHED, a(this, G, Ew).bind(this)), s(this, K).on(e.Events.LEVEL_LOADED, a(this, G, xw).bind(this)), s(this, K).on(e.Events.LEVEL_UPDATED, a(this, G, Cw).bind(this)), s(this, K).on(e.Events.NON_NATIVE_TEXT_TRACKS_FOUND, a(this, G, Sw).bind(this)), s(this, K).on(e.Events.CUES_PARSED, a(this, G, kw).bind(this)), s(this, ht).qualities[ie.enableAuto] = a(this, G, Lw).bind(this), ft(s(this, ht).qualities, "change", a(this, G, Iw).bind(this)), ft(s(this, ht).audioTracks, "change", a(this, G, Rw).bind(this)), u(this, Yr, b(a(this, G, Tw).bind(this)));
  }
  onInstance(e) {
    return s(this, Xr).add(e), () => s(this, Xr).delete(e);
  }
  loadSource(e) {
    var t;
    R(e.src) && ((t = s(this, K)) == null || t.loadSource(e.src));
  }
  destroy() {
    var e, t;
    (e = s(this, K)) == null || e.destroy(), u(this, K, null), (t = s(this, Yr)) == null || t.call(this), u(this, Yr, null);
  }
}
In = new WeakMap(), ht = new WeakMap(), K = new WeakMap(), Yr = new WeakMap(), Xr = new WeakMap(), G = new WeakSet(), Qs = function(e, t) {
  return new H(Ck(e), { detail: t });
}, Tw = function() {
  if (!s(this, ht).$state.live()) return;
  const e = new Nu(a(this, G, $w).bind(this));
  return e.start(), e.stop.bind(e);
}, $w = function() {
  var e;
  s(this, ht).$state.liveSyncPosition.set(((e = s(this, K)) == null ? void 0 : e.liveSyncPosition) ?? 1 / 0);
}, vw = function(e, t) {
  var i;
  (i = s(this, ht).player) == null || i.dispatch(a(this, G, Qs).call(this, e, t));
}, Sw = function(e, t) {
  const i = a(this, G, Qs).call(this, e, t);
  let r = -1;
  for (let o = 0; o < t.tracks.length; o++) {
    const h = t.tracks[o], l = h.subtitleTrack ?? h.closedCaptions, d = new Ns({
      id: `hls-${h.kind}-${o}`,
      src: l == null ? void 0 : l.url,
      label: h.label,
      language: l == null ? void 0 : l.lang,
      kind: h.kind,
      default: h.default
    });
    d[q.readyState] = 2, d[q.onModeChange] = () => {
      d.mode === "showing" ? (s(this, K).subtitleTrack = o, r = o) : r === o && (s(this, K).subtitleTrack = -1, r = -1);
    }, s(this, ht).textTracks.add(d, i);
  }
}, kw = function(e, t) {
  var h;
  const i = (h = s(this, K)) == null ? void 0 : h.subtitleTrack, r = s(this, ht).textTracks.getById(`hls-${t.type}-${i}`);
  if (!r) return;
  const o = a(this, G, Qs).call(this, e, t);
  for (const l of t.cues)
    l.positionAlign = "auto", r.addCue(l, o);
}, Pw = function(e, t) {
  const i = s(this, ht).audioTracks[t.id];
  if (i) {
    const r = a(this, G, Qs).call(this, e, t);
    s(this, ht).audioTracks[D.select](i, !0, r);
  }
}, Ew = function(e, t) {
  const i = s(this, ht).qualities[t.level];
  if (i) {
    const r = a(this, G, Qs).call(this, e, t);
    s(this, ht).qualities[D.select](i, !0, r);
  }
}, Cw = function(e, t) {
  t.details.totalduration > 0 && s(this, ht).$state.inferredLiveDVRWindow.set(t.details.totalduration);
}, xw = function(e, t) {
  var f;
  if (s(this, ht).$state.canPlay()) return;
  const { type: i, live: r, totalduration: o, targetduration: h } = t.details, l = a(this, G, Qs).call(this, e, t);
  s(this, ht).notify(
    "stream-type-change",
    r ? i === "EVENT" && Number.isFinite(o) && h >= 10 ? "live:dvr" : "live" : "on-demand",
    l
  ), s(this, ht).notify("duration-change", o, l);
  const d = s(this, K).media;
  s(this, K).currentLevel === -1 && s(this, ht).qualities[ie.setAuto](!0, l);
  for (const p of s(this, K).audioTracks) {
    const m = {
      id: p.id.toString(),
      label: p.name,
      language: p.lang || "",
      kind: "main"
    };
    s(this, ht).audioTracks[D.add](m, l);
  }
  for (const p of s(this, K).levels) {
    const m = {
      id: ((f = p.id) == null ? void 0 : f.toString()) ?? p.height + "p",
      width: p.width,
      height: p.height,
      codec: p.codecSet,
      bitrate: p.bitrate
    };
    s(this, ht).qualities[D.add](m, l);
  }
  d.dispatchEvent(new H("canplay", { trigger: l }));
}, Aw = function(e, t) {
  var i;
  if (t.fatal)
    switch (t.type) {
      case "mediaError":
        (i = s(this, K)) == null || i.recoverMediaError();
        break;
      default:
        a(this, G, Mw).call(this, t.error);
        break;
    }
}, Mw = function(e) {
  s(this, ht).notify("error", {
    message: e.message,
    code: 1,
    error: e
  });
}, Lw = function() {
  s(this, K) && (s(this, K).currentLevel = -1);
}, Iw = function() {
  const { qualities: e } = s(this, ht);
  !s(this, K) || e.auto || (s(this, K)[e.switch + "Level"] = e.selectedIndex, tl && (s(this, In).currentTime = s(this, In).currentTime));
}, Rw = function() {
  const { audioTracks: e } = s(this, ht);
  s(this, K) && s(this, K).audioTrack !== e.selectedIndex && (s(this, K).audioTrack = e.selectedIndex);
};
var Rn, ri, So, yi, qw, Ow, Dw, Vw;
class pP {
  constructor(e, t, i) {
    c(this, yi);
    c(this, Rn);
    c(this, ri);
    c(this, So);
    u(this, Rn, e), u(this, ri, t), u(this, So, i), a(this, yi, qw).call(this);
  }
}
Rn = new WeakMap(), ri = new WeakMap(), So = new WeakMap(), yi = new WeakSet(), qw = async function() {
  const e = {
    onLoadStart: a(this, yi, Ow).bind(this),
    onLoaded: a(this, yi, Dw).bind(this),
    onLoadError: a(this, yi, Vw).bind(this)
  };
  let t = await Ak(s(this, Rn), e);
  if (Et(t) && !R(s(this, Rn)) && (t = await xk(s(this, Rn), e)), !t) return null;
  if (!t.isSupported()) {
    const i = "[vidstack] `hls.js` is not supported in this environment";
    return s(this, ri).player.dispatch(new H("hls-unsupported")), s(this, ri).notify("error", { message: i, code: 4 }), null;
  }
  return t;
}, Ow = function() {
  s(this, ri).player.dispatch(new H("hls-lib-load-start"));
}, Dw = function(e) {
  s(this, ri).player.dispatch(
    new H("hls-lib-loaded", {
      detail: e
    })
  ), s(this, So).call(this, e);
}, Vw = function(e) {
  const t = ka(e);
  s(this, ri).player.dispatch(
    new H("hls-lib-load-error", {
      detail: t
    })
  ), s(this, ri).notify("error", {
    message: t.message,
    code: 4,
    error: t
  });
};
async function xk(n, e = {}) {
  var t, i, r, o, h;
  if (!Et(n)) {
    if ((t = e.onLoadStart) == null || t.call(e), n.prototype && n.prototype !== Function)
      return (i = e.onLoaded) == null || i.call(e, n), n;
    try {
      const l = (r = await n()) == null ? void 0 : r.default;
      if (l && l.isSupported)
        (o = e.onLoaded) == null || o.call(e, l);
      else
        throw Error(
          ""
        );
      return l;
    } catch (l) {
      (h = e.onLoadError) == null || h.call(e, l);
    }
  }
}
async function Ak(n, e = {}) {
  var t, i, r;
  if (R(n)) {
    (t = e.onLoadStart) == null || t.call(e);
    try {
      if (await Iu(n), !$e(window.Hls))
        throw Error(
          ""
        );
      const o = window.Hls;
      return (i = e.onLoaded) == null || i.call(e, o), o;
    } catch (o) {
      (r = e.onLoadError) == null || r.call(e, o);
    }
  }
}
var ai, ra, Nw, Fw;
class mP {
  constructor(e) {
    c(this, ra);
    c(this, ai);
    y(this, "src", V(""));
    /**
     * Defines which referrer is sent when fetching the resource.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy}
     */
    y(this, "referrerPolicy", null);
    u(this, ai, e), e.setAttribute("frameBorder", "0"), e.setAttribute("aria-hidden", "true"), e.setAttribute(
      "allow",
      "autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope"
    ), this.referrerPolicy !== null && e.setAttribute("referrerpolicy", this.referrerPolicy);
  }
  get iframe() {
    return s(this, ai);
  }
  setup() {
    ft(window, "message", a(this, ra, Fw).bind(this)), ft(s(this, ai), "load", this.onLoad.bind(this)), b(a(this, ra, Nw).bind(this));
  }
  postMessage(e, t) {
    var i;
    (i = s(this, ai).contentWindow) == null || i.postMessage(JSON.stringify(e), t ?? "*");
  }
}
ai = new WeakMap(), ra = new WeakSet(), Nw = function() {
  const e = this.src();
  if (!e.length) {
    s(this, ai).setAttribute("src", "");
    return;
  }
  const t = v(() => this.buildParams());
  s(this, ai).setAttribute("src", YT(e, t));
}, Fw = function(e) {
  var r;
  const t = this.getOrigin();
  if ((e.source === null || e.source === ((r = s(this, ai)) == null ? void 0 : r.contentWindow)) && (!R(t) || t === e.origin)) {
    try {
      const o = JSON.parse(e.data);
      o && this.onMessage(o, e);
      return;
    } catch {
    }
    e.data && this.onMessage(e.data, e);
  }
};
const gP = [
  "bufferend",
  "bufferstart",
  // 'cuechange',
  "durationchange",
  "ended",
  "enterpictureinpicture",
  "error",
  "fullscreenchange",
  "leavepictureinpicture",
  "loaded",
  // 'loadeddata',
  // 'loadedmetadata',
  // 'loadstart',
  "playProgress",
  "loadProgress",
  "pause",
  "play",
  "playbackratechange",
  // 'progress',
  "qualitychange",
  "seeked",
  "seeking",
  // 'texttrackchange',
  "timeupdate",
  "volumechange",
  "waiting"
  // 'adstarted',
  // 'adcompleted',
  // 'aderror',
  // 'adskipped',
  // 'adallcompleted',
  // 'adclicked',
  // 'chapterchange',
  // 'chromecastconnected',
  // 'remoteplaybackavailabilitychange',
  // 'remoteplaybackconnecting',
  // 'remoteplaybackconnect',
  // 'remoteplaybackdisconnect',
  // 'liveeventended',
  // 'liveeventstarted',
  // 'livestreamoffline',
  // 'livestreamonline',
], yP = {
  Unstarted: -1,
  Ended: 0,
  Playing: 1,
  Paused: 2,
  Buffering: 3,
  Cued: 5
};
var Rs, Yt, _w, Hw, Uw, dh, fh;
class Mk {
  constructor() {
    c(this, Yt);
    y(this, "name", "google-cast");
    y(this, "target");
    c(this, Rs);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return Yw();
  }
  mediaType() {
    return "video";
  }
  canPlay(e) {
    return tl && !Zh && of(e);
  }
  async prompt(e) {
    var o;
    let t, i, r;
    try {
      t = await a(this, Yt, _w).call(this, e), s(this, Rs) || (u(this, Rs, new cast.framework.RemotePlayer()), new cast.framework.RemotePlayerController(s(this, Rs))), i = e.player.createEvent("google-cast-prompt-open", {
        trigger: t
      }), e.player.dispatchEvent(i), a(this, Yt, dh).call(this, e, "connecting", i), await a(this, Yt, Hw).call(this, v(e.$props.googleCast)), e.$state.remotePlaybackInfo.set({
        deviceName: (o = Xw()) == null ? void 0 : o.getCastDevice().friendlyName
      }), Yu() && a(this, Yt, dh).call(this, e, "connected", i);
    } catch (h) {
      const l = h instanceof Error ? h : a(this, Yt, fh).call(this, (h + "").toUpperCase(), "Prompt failed.");
      throw r = e.player.createEvent("google-cast-prompt-error", {
        detail: l,
        trigger: i ?? t,
        cancelable: !0
      }), e.player.dispatch(r), a(this, Yt, dh).call(this, e, Yu() ? "connected" : "disconnected", r), l;
    } finally {
      e.player.dispatch("google-cast-prompt-close", {
        trigger: r ?? i ?? t
      });
    }
  }
  async load(e) {
    if (!s(this, Rs))
      throw Error("[vidstack] google cast player was not initialized");
    return new (await import("./vidstack-google-cast-BaNgBqhV.js").then((t) => t.p)).GoogleCastProvider(s(this, Rs), e);
  }
}
Rs = new WeakMap(), Yt = new WeakSet(), _w = async function(e) {
  if (Jw()) return;
  const t = e.player.createEvent("google-cast-load-start");
  e.player.dispatch(t), await Iu(iT()), await customElements.whenDefined("google-cast-launcher");
  const i = e.player.createEvent("google-cast-loaded", { trigger: t });
  if (e.player.dispatch(i), !Zw())
    throw a(this, Yt, fh).call(this, "CAST_NOT_AVAILABLE", "Google Cast not available on this platform.");
  return i;
}, Hw = async function(e) {
  a(this, Yt, Uw).call(this, e);
  const t = await this.cast.requestSession();
  if (t)
    throw a(this, Yt, fh).call(this, t.toUpperCase(), tT(t));
}, Uw = function(e) {
  var t;
  (t = this.cast) == null || t.setOptions({
    ...eT(),
    ...e
  });
}, dh = function(e, t, i) {
  const r = { type: "google-cast", state: t };
  e.notify("remote-playback-change", r, i);
}, fh = function(e, t) {
  const i = Error(t);
  return i.code = e, i;
};
const Lk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleCastLoader: Mk
}, Symbol.toStringTag, { value: "Module" }));
var Ge, Kh, Bw;
class bP {
  constructor(e) {
    c(this, Kh);
    c(this, Ge);
    u(this, Ge, new chrome.cast.media.MediaInfo(e.src, e.type));
  }
  build() {
    return s(this, Ge);
  }
  setStreamType(e) {
    return e.includes("live") ? s(this, Ge).streamType = chrome.cast.media.StreamType.LIVE : s(this, Ge).streamType = chrome.cast.media.StreamType.BUFFERED, this;
  }
  setTracks(e) {
    return s(this, Ge).tracks = e.map(a(this, Kh, Bw)), this;
  }
  setMetadata(e, t) {
    return s(this, Ge).metadata = new chrome.cast.media.GenericMediaMetadata(), s(this, Ge).metadata.title = e, s(this, Ge).metadata.images = [{ url: t }], this;
  }
}
Ge = new WeakMap(), Kh = new WeakSet(), Bw = function(e, t) {
  const i = new chrome.cast.media.Track(t, chrome.cast.media.TrackType.TEXT);
  return i.name = e.label, i.trackContentId = e.src, i.trackContentType = "text/vtt", i.language = e.language, i.subtype = e.kind.toUpperCase(), i;
};
var qs, oi, ko, ut, gu, Kn, jw, Ww, Gw, yu, ph, bu;
class wP {
  constructor(e, t, i) {
    c(this, ut);
    c(this, qs);
    c(this, oi);
    c(this, ko);
    u(this, qs, e), u(this, oi, t), u(this, ko, i);
  }
  setup() {
    const e = this.syncRemoteActiveIds.bind(this);
    ft(s(this, oi).audioTracks, "change", e), ft(s(this, oi).textTracks, "mode-change", e), b(a(this, ut, Ww).bind(this));
  }
  getLocalTextTracks() {
    return s(this, oi).$state.textTracks().filter((e) => e.src && e.type === "vtt");
  }
  syncRemoteTracks(e) {
    if (!s(this, qs).isMediaLoaded) return;
    const t = a(this, ut, gu).call(this), i = this.getLocalTextTracks(), r = a(this, ut, Kn).call(this, chrome.cast.media.TrackType.AUDIO), o = a(this, ut, Kn).call(this, chrome.cast.media.TrackType.TEXT);
    for (const h of r) {
      if (a(this, ut, yu).call(this, t, h)) continue;
      const d = {
        id: h.trackId.toString(),
        label: h.name,
        language: h.language,
        kind: h.subtype ?? "main",
        selected: !1
      };
      s(this, oi).audioTracks[D.add](d, e);
    }
    for (const h of o) {
      if (a(this, ut, yu).call(this, i, h)) continue;
      const d = {
        id: h.trackId.toString(),
        src: h.trackContentId,
        label: h.name,
        language: h.language,
        kind: h.subtype.toLowerCase()
      };
      s(this, oi).textTracks.add(d, e);
    }
  }
  syncRemoteActiveIds(e) {
    if (!s(this, qs).isMediaLoaded) return;
    const t = a(this, ut, jw).call(this), i = new chrome.cast.media.EditTracksInfoRequest(t);
    a(this, ut, Gw).call(this, i).catch((r) => {
    });
  }
}
qs = new WeakMap(), oi = new WeakMap(), ko = new WeakMap(), ut = new WeakSet(), gu = function() {
  return s(this, oi).$state.audioTracks();
}, Kn = function(e) {
  var i;
  const t = ((i = s(this, qs).mediaInfo) == null ? void 0 : i.tracks) ?? [];
  return e ? t.filter((r) => r.type === e) : t;
}, jw = function() {
  const e = [], t = a(this, ut, gu).call(this).find((r) => r.selected), i = this.getLocalTextTracks().filter((r) => r.mode === "showing");
  if (t) {
    const r = a(this, ut, Kn).call(this, chrome.cast.media.TrackType.AUDIO), o = a(this, ut, ph).call(this, r, t);
    o && e.push(o.trackId);
  }
  if (i != null && i.length) {
    const r = a(this, ut, Kn).call(this, chrome.cast.media.TrackType.TEXT);
    if (r.length)
      for (const o of i) {
        const h = a(this, ut, ph).call(this, r, o);
        h && e.push(h.trackId);
      }
  }
  return e;
}, Ww = function() {
  const e = this.getLocalTextTracks();
  if (!s(this, qs).isMediaLoaded) return;
  const t = a(this, ut, Kn).call(this, chrome.cast.media.TrackType.TEXT);
  for (const i of e)
    if (!a(this, ut, ph).call(this, t, i)) {
      Zr(() => {
        var o;
        return (o = s(this, ko)) == null ? void 0 : o.call(this);
      });
      break;
    }
}, Gw = function(e) {
  const t = sT();
  return new Promise((i, r) => t == null ? void 0 : t.editTracksInfo(e, i, r));
}, yu = function(e, t) {
  return e.find((i) => a(this, ut, bu).call(this, i, t));
}, ph = function(e, t) {
  return e.find((i) => a(this, ut, bu).call(this, t, i));
}, // Note: we can't rely on id matching because they will differ between local/remote. A local
// track id might not even exist.
bu = function(e, t) {
  return t.name === e.label && t.language === e.language && t.subtype.toLowerCase() === e.kind.toLowerCase();
};
export {
  le as $,
  Bk as A,
  zt as B,
  gP as C,
  Jk as D,
  mP as E,
  Yk as F,
  wP as G,
  Gk as H,
  Ns as I,
  Et as J,
  fT as K,
  D as L,
  Te as M,
  Wk as N,
  Ok as O,
  Xk as P,
  ie as Q,
  Nu as R,
  hP as S,
  Go as T,
  rP as U,
  zk as V,
  aP as W,
  oP as X,
  yP as Y,
  lP as Z,
  sP as _,
  R as a,
  YS as a0,
  kk as a1,
  dP as a2,
  cP as a3,
  uP as a4,
  JS as a5,
  Ek as a6,
  Fu as a7,
  pk as a8,
  nk as a9,
  bk as aa,
  rk as ab,
  sk as ac,
  hk as ad,
  uk as ae,
  Nk as af,
  Fk as ag,
  Hk as ah,
  Uk as ai,
  _k as aj,
  WS as ak,
  QS as al,
  nP as am,
  Zk as b,
  v as c,
  yh as d,
  H as e,
  bP as f,
  fP as g,
  Mu as h,
  FT as i,
  pP as j,
  Dk as k,
  ft as l,
  jk as m,
  W as n,
  it as o,
  el as p,
  Vk as q,
  OT as r,
  Ke as s,
  qT as t,
  Qk as u,
  RT as v,
  Kk as w,
  V as x,
  b as y,
  Sl as z
};
